import { docsUz } from "./docs";
import { auditUz } from "./audit/uz";
import type { Dictionary } from "./ru";

/** Oʻzbek tili (lotin yozuvi). */
export const uz: Dictionary = {
  reportReset: {
    "deleteArchive": "Arxivni o‘chirish",
    "deleteArchiveTitle": "Tozalash arxivi o‘chirilsinmi?",
    "deleteArchiveText": "{{period}} davri hisobotlari arxivdan butunlay o‘chiriladi — ularni qayta yuklab olib bo‘lmaydi. Tozalash, uning sanasi va tarixdagi yozuv qoladi, buyurtmalar va to‘lovlar o‘chirilmaydi.",
    "deleteArchiveSave": "Arxiv hali kerak bo‘lsa — o‘chirishdan oldin yuklab oling:",
    "deleteArchiveConfirm": "Arxiv butunlay o‘chirilsinmi?",
    "deleteArchiveConfirmText": "Arxivni o‘chirishni bekor qilib bo‘lmaydi.",
    "archiveDeleted": "Arxiv o‘chirilgan",
    "title": "Hisobotlarni tozalash",
    "description": "Hisobni toza varaqdan boshlash: hisobotlardagi tushum va pul — tanlangan sanadan. Hech narsa o‘chirilmaydi, o‘tgan davr hisobotlari arxivga saqlanadi.",
    "currentFrom": "Hisobotlar {{date}} dan hisoblanadi",
    "currentAll": "Hisobotlar ish boshidan hisoblanadi",
    "currentHint": "Buyurtmalar, to‘lovlar, smenalar va hujjatlar o‘chirilmaydi. O‘tgan davr hisobotlari arxivda — uni Excel yoki PDF ko‘rinishida yuklab olish mumkin.",
    "start": "Hisobotlarni tozalash",
    "history": "Tozalashlar tarixi",
    "historyEmpty": "Hali tozalash bo‘lmagan",
    "colFrom": "Hisobotlar shu sanadan",
    "colArchive": "Arxiv davri",
   
    "colBy": "Kim va qachon",
   
    "statusActive": "Amalda",
    "statusCancelled": "Bekor qilingan",
    "archiveNone": "Ma’lumot yo‘q",
    "cancel": "Tozalashni bekor qilish",
    "cancelTitle": "Hisobotlarni tozalash bekor qilinsinmi?",
    "cancelText": "Hisobotlar yana {{since}} hisoblanadi. Bu tozalash arxivi tarixda qoladi.",
    "sinceDate": "{{date}} dan",
    "sinceStart": "ish boshidan",
    "cancelled": "Tozalash bekor qilindi — hisobotlar yana o‘tgan ma’lumotlarni ko‘rsatadi",
    "stepWhat": "Nima bo‘ladi",
    "stepArchive": "Arxiv",
    "stepConfirm": "Tasdiqlash",
    "stepOf": "3 qadamdan {{n}}-qadam · {{name}}",
    "date": "Hisobotlarni qaysi sanadan qayta hisoblash kerak",
    "dateHint": "Odatda — bugun yoki oyning birinchi kuni. Shu kungi sotuvlar yangi hisobotlarda qoladi.",
    "resets": "Noldan boshlanadi",
    "resetRevenue": "Hisobotlardagi tushum, to‘lovlar, qaytarishlar, o‘rtacha chek",
    "resetFinance": "Moliya: hisobotlardagi foyda, xarajatlar, xaridlar, hisobdan chiqarishlar, ish haqi fondi",
    "resetOther": "Taomlar sotuvi, mahsulotlar, ofitsiantlar, aksiyalar, xizmatlar va kengaytirilgan hisobotlar",
    "keeps": "O‘zgarmaydi",
    "keepMenu": "Menyu, texnologik kartalar, narxlar, stop-list",
    "keepStock": "Ombor va mahsulot qoldiqlari",
    "keepDebts": "Mijozlar va ularning qarzlari, yetkazib beruvchilarga qarzlar",
    "keepStaff": "Xodimlar, smenalar, ish haqi",
    "keepJournal": "Jurnallardagi buyurtmalar, to‘lovlar, kassa smenalari va hujjatlar — avvalgidek",
    "archivePeriod": "Arxivga {{from}} — {{to}} davri hisobotlari tushadi",
    "archiveEmpty": "Bu sanagacha hisobotlar yo‘q — arxiv bo‘sh bo‘ladi.",
    "archiveLimit": "Arxiv — bir yildan uzun emas va tarif bo‘yicha hisobotlar tarixidan chuqur emas. Ma’lumotlarning o‘zi bazada qoladi.",
    "archiveText": "O‘tgan davr hisobotlarini yuklab oling va o‘zingizda saqlang. Keyinroq arxivni tozalashlar tarixidan qayta yuklab olish mumkin.",
    "archiveSaved": "Arxivni saqladim yoki u menga kerak emas",
    "archiveTitle": "Hisobotlar arxivi",
    "branch": "Filial",
    "revenue": "Tushum",
    "orders": "Buyurtmalar",
    "confirmText": "Tasdiqlash uchun {{word}} so‘zini kiriting.",
    "confirmWord": "TOZALASH",
    "password": "Parolingiz",
    "comment": "Izoh",
    "commentPlaceholder": "Masalan: o‘qitishdan keyin ishni boshlash",
    "next": "Keyingi",
    "back": "Orqaga",
    "submit": "Hisobotlarni tozalash",
    "finalTitle": "Hisobotlar tozalansinmi?",
    "finalText": "Barcha xodimlarning barcha hisobotlari {{date}} dan boshlanadi. Ma’lumotlar o‘chirilmaydi, tozalashni tarixda bekor qilish mumkin.",
    "done": "Hisobotlar tozalandi — hisob {{date}} dan",
    "banner": "Hisobotlar {{date}} dan hisoblanadi — oldingi ma’lumotlar tozalash arxivida.",
    "bannerLink": "Hisobotlarni tozalash",
  },
  nav: {
    "reportReset": "Hisobotlarni tozalash",
    "menuPacks": "Tayyor menyular",
    "help": "Ma’lumotnoma",
    "stockRequests": "Omborga buyurtmalar",
    "purchaseRequests": "Xarid so‘rovlari",
    "conversions": "Bo‘laklash va yig‘ish",
    "warehouses": "Omborlar",
    "transfers": "Ko‘chirishlar",
    "expiry": "Yaroqlilik muddati",
    "production": "Ishlab chiqarish",
    site: "Sayt va QR-menyu",
    employees: "Kadrlar",
    positions: "Lavozimlar",
    workShifts: "Ish smenalari",
    payroll: "Ish haqi",
    tips: "Choychaqa",
    myWork: "Mening kabinetim",
    audit: "Audit jurnali",
    customers: "Mijozlar",
    debts: "Qarzlar",
    insights: "Kafe tahlili", expenses: "Xarajatlar", suppliers: "Yetkazib beruvchilar", supplierReturns: "Yetkazib beruvchilarga qaytarish", purchases: "Xaridlar", writeoffs: "Hisobdan chiqarish",
    analytics: "Analitika", dashboard: "Boshqaruv paneli", reports: "Hisobotlar",
    sales: "Savdo", pos: "Kassa (POS)", posShort: "POS", orders: "Buyurtmalar", kitchen: "Oshxona",
    venue: "Muassasa", branches: "Filiallar", tables: "Zallar va stollar",
    shifts: "Smenalar va bronlar", cashShifts: "Kassa smenalari", reservations: "Bron qilish",
    catalog: "Menyu va ombor", menu: "Menyu", products: "Mahsulotlar", costing: "Kalkulyatsiya", inventory: "Ombor", inventoryCounts: "Inventarizatsiya", notifications: "Bildirishnomalar", security: "Xavfsizlik",
    staff: "Xodimlar", users: "Xodimlar", roles: "Rollar va huquqlar",
    settings: "Sozlamalar", company: "Kompaniya", devices: "Terminallar", subscription: "Obuna", support: "Yordam", fraud: "Suiiste’moldan himoya", sms: "SMS-xabarnomalar", services: "Xizmatlar va ijara", banquets: "Banketlar", promotions: "Aksiyalar", deliveries: "Yetkazib berish", courier: "Mening yetkazishlarim", goals: "Maqsadlar va yutuqlar", myGoals: "Mening maqsadlarim", waiterZones: "Zallar bo‘yicha ofitsiantlar",
    kitchenStations: "Oshxona stansiyalari", more: "Yana",
  },
  common: {
    close: "Yopish",
    save: "Saqlash", cancel: "Bekor qilish", create: "Yaratish", edit: "Tahrirlash", delete: "Oʻchirish", retry: "Qayta urinish", add: "Qoʻshish",
    done: "Tayyor", saved: "Oʻzgarishlar saqlandi", search: "Qidirish…", logout: "Chiqish", logoutTitle: "Akkauntdan chiqasizmi?", logoutHint: "Ishni davom ettirish uchun qayta kirish kerak boʻladi.", profile: "Profil", branch: "Filial", allBranches: "Barcha filiallar",
    active: "Faol", inactive: "Oʻchirilgan", blocked: "Bloklangan", soon: "Tez orada",
    locked: "Tarifda mavjud emas", upgrade: "Ulash", theme: "Mavzu", language: "Til",
    name: "Nomi", description: "Tavsif", phone: "Telefon", status: "Holati", price: "Narxi", actions: "Amallar",
    all: "Hammasi", no: "Yoʻq", more: "Batafsil", filter: "Filtr", moveUp: "Yuqoriga", moveDown: "Pastga", hasErrors: "Xatolar bor",
    nothingFound: "Hech narsa topilmadi", nothingFoundHint: "Soʻrovni oʻzgartirib koʻring", resetSearch: "Qidiruvni tozalash", resetFilters: "Filtrlarni tozalash",
    deleteNamed: "«{{name}}» oʻchirilsinmi?",
  },
  ui: {
    ok: "Tushunarli", confirm: "Tasdiqlash", actionFailed: "Amalni bajarib boʻlmadi",
    typeToConfirmBefore: "Tasdiqlash uchun", typeToConfirmAfter: "deb yozing", dialog: "Dialog", close: "Yopish", clear: "Tozalash",
    showPassword: "Parolni koʻrsatish", hidePassword: "Parolni yashirish", select: "Tanlang…", loadError: "Yuklashda xatolik. Qayta urinib koʻring.",
    create: "«{{q}}» yaratish", increase: "Koʻpaytirish", decrease: "Kamaytirish", loading: "Yuklanmoqda", pages: "Sahifalar",
    pageRange: "{{total}} tadan {{from}}–{{to}}", prevPage: "Oldingi sahifa", nextPage: "Keyingi sahifa",
    selectAll: "Hammasini tanlash", selectRow: "Tanlash", selectedCount: "Tanlandi: {{count}}", clearSelection: "Tanlovni bekor qilish",
    grams: "g", kilograms: "kg", weight: "Vazn", perKg: "1 kg uchun",
  },
  currencySymbols: { KGS: "som", KZT: "₸", UZS: "soʻm", RUB: "₽", TJS: "somoniy" },
  errors: {
    IMPERSONATION_READ_ONLY: "Qo‘llab-quvvatlash seansi faqat o‘qish uchun",
    INVOICE_PAID: "Hisob to‘langan — o‘zgartirib bo‘lmaydi",
    DOWNGRADE_BLOCKED: "Foydalanish yangi tarif limitlaridan oshadi",
    ADDON_UNAVAILABLE: "Qo‘shimcha bu tarifda mavjud emas",
    MENU_PACK_NOT_PURCHASED: "Tayyor menyu hali to‘lanmagan — hisob to‘langandan keyin yuklash mumkin",
    TWO_FACTOR_INVALID: "Tasdiqlash kodi noto‘g‘ri",
    CLOCK_IN_NOT_ALLOWED: "Smenani belgilash mumkin emas",
    WORK_SHIFT_OPEN: "Xodimning smenasi allaqachon ochiq",
    PAYROLL_APPROVED: "Vedomost tasdiqlangan — o‘zgartirib bo‘lmaydi",
    CREDIT_LIMIT_EXCEEDED: "Mijozning kredit limiti oshib ketdi",
    DEPOSIT_REQUIRED: "Banket depozit kiritilgandan keyin tasdiqlanadi",
    DELIVERY_ADDRESS_OUT_OF_ZONE: "Manzil yetkazib berish hududlaridan tashqarida",
    CUSTOMER_DEBT_OVERDUE: "Mijozning muddati o‘tgan qarzi bor — yangi kredit berilmaydi",
    CUSTOMER_BLOCKED: "Mijoz bloklangan",
    CUSTOMER_PHONE_TAKEN: "Bu telefon raqamli mijoz allaqachon bor",
    CASH_SHIFT_NOT_OPEN: "Kassa smenasi ochilmagan",
    CASH_INSUFFICIENT: "Kassada naqd pul yetarli emas",
    INSUFFICIENT_STOCK: "Omborda qoldiq yetarli emas",
    APPROVAL_REQUIRED: "Menejer tasdig'i kerak",
    APPROVAL_INVALID: "Tasdiq bu amalga mos emas yoki muddati o'tgan",
    APPROVAL_USED: "Tasdiq allaqachon ishlatilgan",
    DISCOUNT_INVALID: "Chegirma ruxsat berilgan pozitsiyalar summasidan oshadi",
    BRANCH_INACTIVE: "Filial o'chirilgan — unda o'zgartirish mumkin emas",
    DOCUMENT_POSTED: "O'tkazilgan hujjatni o'zgartirib yoki o'chirib bo'lmaydi",
    INVENTORY_COUNT_CLOSED: "Inventarizatsiya allaqachon o'tkazilgan yoki bekor qilingan",
    PAYMENT_AMOUNT_INVALID: "Naqdsiz to‘lov to‘lanadigan qoldiqdan ko‘p",
    CUSTOMER_REQUIRED: "Qarzga to‘lash uchun mijozni tanlang",
    MODIFIERS_INVALID: "Modifikatorlar tanlovini tekshiring", TABLE_UNAVAILABLE: "Stol mavjud emas", ITEM_ALREADY_SENT: "Pozitsiya oshxonaga yuborilgan — o‘zgartirib bo‘lmaydi, faqat bekor qilish mumkin", ORDER_CLOSED: "Buyurtma yopilgan", ORDER_HAS_PAYMENTS: "Buyurtma bo‘yicha to‘lovlar bor — bekor qilish faqat qaytarish orqali", NOTHING_TO_SEND: "Oshxonaga yuborish uchun yangi pozitsiya yo‘q",
    NETWORK_ERROR: "Server bilan aloqa yoʻq. Internetni tekshiring", requestFailed: "Soʻrovda xatolik", unknown: "Nimadir notoʻgʻri ketdi. Qayta urinib koʻring",
    code: "kod: {{id}}…", actionFailed: "Amalni bajarib boʻlmadi",
    limitTitle: "Tarif limitiga yetildi", limitHint: "Limit: {{max}}. Tarifni oshiring yoki «Obuna» boʻlimida paket ulang.",
    planHint: "Tarifni uzaytirish yoki kengaytirish uchun «Sozlamalar → Obuna» boʻlimini oching.",
    conflictTitle: "Maʼlumotlarni boshqa foydalanuvchi oʻzgartirdi", conflictHint: "Joriy versiyani yukladik — tekshiring va oʻzgartirishni takrorlang.",
    VALIDATION_ERROR: "Maydonlar toʻgʻri toʻldirilganini tekshiring", UNAUTHENTICATED: "Tizimga kirish talab etiladi", TOKEN_EXPIRED: "Sessiya muddati tugadi",
    REFRESH_TOKEN_REUSED: "Xavfsizlik nuqtai nazaridan sessiya yakunlandi. Qayta kiring",
    DEVICE_REQUIRED: "PIN orqali kirish faqat roʻyxatdan oʻtgan terminalda mumkin", DEVICE_REVOKED: "Terminal administrator tomonidan oʻchirilgan",
    INVALID_CREDENTIALS: "Login yoki parol notoʻgʻri", FEATURE_NOT_IN_PLAN: "Bu funksiya tarifingizda mavjud emas", PLAN_LIMIT_REACHED: "Tarif limitiga yetildi",
    SUBSCRIPTION_READ_ONLY: "Obuna faqat oʻqish rejimida", SUBSCRIPTION_SUSPENDED: "Obuna toʻxtatilgan", PERMISSION_DENIED: "Huquqlar yetarli emas",
    BRANCH_ACCESS_DENIED: "Filialga kirish huquqi yoʻq", NOT_FOUND: "Topilmadi", VERSION_CONFLICT: "Maʼlumotlar oʻzgardi. Sahifani yangilang",
    DUPLICATE: "Bunday yozuv allaqachon mavjud", SLUG_TAKEN: "Bu manzil band", ENTITY_IN_USE: "Yozuv ishlatilmoqda, uni oʻchirib boʻlmaydi",
    ACCOUNT_LOCKED: "Akkaunt vaqtincha bloklangan", PIN_LOCKED: "PIN orqali kirish vaqtincha bloklangan",
    RATE_LIMITED: "Urinishlar juda koʻp. Keyinroq qayta urinib koʻring", INTERNAL_ERROR: "Serverning ichki xatosi",
    UNIT_CONVERSION_UNDEFINED: "Birlikni mahsulot birligiga oʻtkazib boʻlmaydi — mahsulot zichligini kiriting",
    RECIPE_CYCLE: "Yarim tayyor mahsulot oʻzini oʻzi oʻz ichiga olmaydi (yoki ichma-ichlik 5 darajadan chuqur)",
    RECIPE_VERSION_PUBLISHED: "Eʼlon qilingan TTK versiyasini oʻzgartirib boʻlmaydi — yangisini yarating",
    MENU_ITEM_UNAVAILABLE: "Pozitsiya sotuvda mavjud emas", TABLE_OCCUPIED: "Stol band",
    FILE_TOO_LARGE: "Fayl juda katta (10 MB gacha)", FILE_TYPE_NOT_ALLOWED: "Ruxsat etilgan rasmlar: JPEG, PNG, WebP, AVIF, HEIC",
    SERVICE_UNAVAILABLE: "Xizmat vaqtincha ishlamayapti",
    SHIFT_ALREADY_OPEN: "Bu kassada smena allaqachon ochiq", SHIFT_CLOSED: "Smena allaqachon yopilgan",
    CURSOR_EXPIRED: "Kassa maʼlumotlari eskirgan — toʻliq yuklash kerak", BATCH_TOO_LARGE: "Maʼlumotlar paketi juda katta", OPEN_ORDERS_EXIST: "Ochiq buyurtmalar bor — valyutani almashtirishdan oldin ularni yoping", TOTALS_MISMATCH: "Buyurtma summasi server hisobiga mos kelmaydi", TERMINAL_REVOKED: "Kassa administrator tomonidan oʻchirildi", REFUND_EXCEEDS_PAID: "Qaytarish summasi to‘langanidan ko‘p", ORDER_NOT_PAID: "Buyurtma bo‘yicha qaytarish uchun to‘lov yo‘q",
    INVALID_STATUS_TRANSITION: "Bu amal joriy holatda mavjud emas — sahifani yangilang", BUSINESS_RULE: "Amalni bajarib bo‘lmaydi", QUOTA_EXCEEDED: "Kvota tugadi — «Obuna» bo‘limida paket ulang",
    row: "{{n}}-qator",
    detail: {
      stock: "{{product}}: bor {{available}}, kerak {{required}}", stockAt: "{{product}} ({{warehouse}}): bor {{available}}, kerak {{required}}",
      creditOff: "Mijozga qarzga to‘lashga ruxsat berilmagan", credit: "Limit {{limit}}, hozirgi qarz {{balance}}, yangi qarz {{amount}}",
      cash: "Kassada {{expected}}, kerak {{amount}}", due: "To‘lanishi kerak bo‘lgan qoldiq {{due}}", depositLeft: "Depozitdan mavjud {{available}}",
      refund: "{{available}} dan ko‘p qaytarib bo‘lmaydi", deposit: "{{required}} kiritish kerak, kiritildi {{paid}}", discount: "Chegirma ruxsat etilgan pozitsiyalar summasi — {{base}}",
      unavailable: "Mavjud emas: {{items}}", permission: "Huquq kerak: {{perms}}. Administratorga murojaat qiling", retry: "{{min}} daqiqadan keyin urinib ko‘ring",
      quota: "Kerak {{needed}}, qoldi {{remaining}}", unit: "{{product}}: «{{unit}}» «{{base}}» birligiga o‘tkazilmaydi", limit: "Tarif limiti: {{max}}",
    },
  },
  validation: {
    purchaseLine: "Mahsulotni tanlang yoki nomini yozing", purchaseDocNotFound: "Bu filialda xarid topilmadi",
    geoLat: "Kenglikni ko‘rsating", geoLng: "Uzunlikni ko‘rsating", geoLatRange: "Kenglik — −90 dan 90 gacha", geoLngRange: "Uzunlik — −180 dan 180 gacha", geoPair: "Kenglik va uzunlikni ko‘rsating",
    socialWhatsapp: "WhatsApp raqami +996XXXXXXXXX formatida yoki havola", socialHandle: "Havola yoki akkaunt nomi (@name)",
    lossRequired: "Yoʻqotishni kiriting", lossMin: "Noldan kam boʻlmasin", lossOnlyReceipt: "Yoʻqotish — faqat xarid uchun", lossPercentMax: "Yoʻqotish 100% dan kam boʻlsin", lossQtyMax: "Yoʻqotish miqdordan kam boʻlsin",
    bulkPick: "Kamida bitta yozuvni tanlang", bulkMax: "Bir martada 500 tadan ko‘p emas", bulkWhat: "Nimani o‘zgartirishni tanlang", intOnly: "Butun son kiriting", nonZeroChange: "O‘zgarish nol bo‘lishi mumkin emas", bulkPercent: "Foiz — −90 dan 500 gacha",
    codeRequired: "Xatdagi kodni kiriting",
    code6: "Kod — 6 ta raqam", codeWrong: "Kod noto'g'ri", codeExpired: "Kod eskirgan yoki so'ralmagan — yangisini yuboring",
    codeTooMany: "Noto'g'ri urinishlar juda ko'p — yangi kod yuboring", resetLinkExpired: "Havola yaroqsiz yoki eskirgan — tiklashni qayta so'rang",
    nothingToPay: "To‘lanadigan narsa yo‘q",
    tipsPeriodTaken: "Bu davr choychaqasi allaqachon taqsimlangan",
    tipsEmpty: "Davr ichida choychaqa yo‘q",
    noShiftParticipants: "Davr ichida smenasi bor xodim yo‘q",
    dismissSelf: "O‘zingizni bo‘shata olmaysiz",
    positionNotFound: "Lavozim topilmadi",
    debtNotFound: "Ochiq qarz topilmadi",
    customerNotFound: "Mijoz topilmadi",
    diffReason2: "Farq sababini yozing",
    periodMax3: "Davr 3 oydan oshmasligi kerak",
    periodMax2: "Davr 2 oydan oshmasligi kerak",
    endAfterStart2: "Tugash vaqti boshlanishdan keyin bo‘lishi kerak",
    nonZero: "Summa 0 bo‘lishi mumkin emas",
    diffReason: "Farq sababini yozing",
    selectProduct: "Mahsulotni tanlang", expenseCategory: "Toifani tanlang", amountPositive: "Summa noldan katta bo'lishi kerak", qtyRequired: "Miqdorni kiriting", qtyPositive: "Miqdor noldan katta bo'lishi kerak", unknownUnit: "Noma'lum birlik", reasonSelect: "Sababni tanlang", amountRequired: "Summani kiriting", linesRequired: "Kamida bitta qator qo'shing", productNotFound: "Mahsulot topilmadi",
    refundPositive: "Qaytarish summasi 0 dan katta bo‘lishi kerak",
    reasonRequired: "Sababini ko‘rsating",
    refundTarget: "To‘lov yoki qaytarish usulini ko‘rsating",
    dateFormat: "Sana YYYY-OO-KK formatida",
    periodOrder: "Davr oxiri boshidan oldin",
    periodMax: "Davr bir yildan oshmasligi kerak",
    endAfterStart: "Tugash vaqti boshlanishdan keyin bo‘lishi kerak",
    paymentPositive: "To‘lov summasi 0 dan katta bo‘lishi kerak",
    reasonComment: "Sababini yozing", tableRequired: "Zaldagi buyurtma uchun stolni tanlang",
    required: "Majburiy maydon", minChars: "Kamida {{n}} ta belgi", maxChars: "Koʻpi bilan {{n}} ta belgi", min2: "Kamida 2 ta belgi",
    invalidId: "Notoʻgʻri identifikator", phoneFormat: "Telefon +996XXXXXXXXX formatida", invalidEmail: "Notoʻgʻri email",
    slugChars: "Faqat lotin harflari, raqamlar va chiziqcha", pinFormat: "PIN — 4–6 ta raqam", passwordMin: "Parol — kamida 10 ta belgi",
    siteSlugFormat: "Subdomen: 3–40 belgi, lotin harflari, raqamlar va defis", siteSlugReserved: "Bu xizmat manzili — boshqa subdomen tanlang",
    passwordMax: "Parol — koʻpi bilan 128 ta belgi", passwordChars: "Parolda harflar va raqamlar boʻlishi kerak",
    currencyCode: "ISO 4217 valyuta kodi", countryCode: "ISO 3166-1 mamlakat kodi", moneyInteger: "Summa butun son boʻlishi kerak (minor units)",
    invalidQty: "Notoʻgʻri miqdor", unknownTz: "Nomaʼlum vaqt mintaqasi", timeFormat: "SS:DD formati",
    formatsRequired: "Kamida bitta formatni tanlang", taxId: "STIR — 10–14 ta raqam", pct: "0 dan 99.99 gacha", sku: "Lotin harflari, raqamlar, . _ - (64 tagacha)",
    barcode: "Shtrix-kod — 6–14 ta raqam", invalidPrice: "Notoʻgʻri narx", oldPrice: "Eski narx joriy narxdan yuqori boʻlishi kerak",
    productRequired: "Tovar uchun ombordagi mahsulotni tanlang", oneDefaultVariant: "Standart variant faqat bitta boʻladi",
    duplicateVariants: "Variant nomlari takrorlanmoqda", modifiersRequired: "Kamida bitta modifikator qoʻshing",
    maxGteMin: "Maksimum minimumdan kam boʻlmasligi kerak", singleMax: "Yakka tanlovda maksimum = 1",
    minTooHigh: "Minimum faol modifikatorlar sonidan koʻp", modifierQty: "Mahsulotli modifikator uchun hisobdan chiqarish miqdorini kiriting",
    positive: "0 dan katta", loginFormat: "Email yoki +996… formatidagi telefonni kiriting", loginRequired: "Email yoki telefonni kiriting",
    passwordRequired: "Parolni kiriting", ingredientRequired: "Mahsulot yoki yarim tayyor mahsulotni tanlang",
    passwordNeedsContact: "Parol bilan kirish uchun email yoki telefon kerak", passwordOrPin: "Parol yoki PIN oʻrnating",
    activationCode: "Faollashtirish kodi — 8 ta belgi", assignRole: "Kamida bitta rol tayinlang", invalidDate: "Notoʻgʻri sana",
    acceptTerms: "Oferta shartlarini qabul qilish shart", seatsMin: "Kamida 1 oʻrin", numberRequired: "Raqamni kiriting", copyFactor: "Koeffitsiyent 0.01 dan 100 gacha", copyTargets: "Qayerga nusxalashni tanlang",
    goalTargetPositive: "Maqsad noldan katta boʻlishi kerak", goalTargetInteger: "Maqsad — butun son", goalDates: "Maqsad sanalarini kiriting", goalItemOnly: "Pozitsiya yoki kategoriya — faqat sotilgan taomlar soni boʻyicha maqsad uchun", goalItemOrCategory: "Pozitsiya yoki kategoriyani tanlang",
  },
  shell: {
    sections: "Boʻlimlar", home: "Bosh sahifa", logo: "Logotip", skipToContent: "Mazmunga oʻtish", workScreens: "Ish ekranlari", hideLabels: "Yozuvlarni yashirish", showLabels: "Yozuvlarni koʻrsatish",
  },
  guards: {
    noAccess: "Huquqlar yetarli emas",
    noAccessHint: "Boʻlimga kirish uchun egasi yoki boshqaruvchiga murojaat qiling.",
    featureLocked: "«{{feature}}» funksiyasi joriy tarifga kirmaydi. Qoʻshimcha xizmatni ulang yoki tarifni almashtiring.",
    soonTitle: "{{title}} — ishlab chiqilmoqda",
    soonHint: "Boʻlim joriy etish rejasiga koʻra yaqin yangilanishlardan birida paydo boʻladi.",
  },
  auth: {
    twoFactorTitle: "Tasdiqlash kodi",
    twoFactorHint: "Autentifikator ilovasini (Google Authenticator va h.k.) oching va 6 raqamni kiriting.",
    twoFactorBackupHint: "Himoyani yoqishda saqlangan zaxira kodlardan birini kiriting. Har bir kod bir marta ishlaydi.",
    twoFactorCodeLabel: "Ilovadagi kod",
    twoFactorBackupLabel: "Zaxira kod",
    twoFactorCodeFormat: "Kod — 6 raqam",
    twoFactorBackupFormat: "Zaxira kod — 8 belgi, masalan abcd-efgh",
    twoFactorConfirm: "Kirish",
    twoFactorUseBackup: "Ilovaga kirish yo'qmi? Zaxira kod",
    twoFactorUseApp: "Ilovadagi kodni kiritish",
    twoFactorWrong: "Kod noto'g'ri",
    twoFactorExpired: "Kod kiritish vaqti tugadi — qayta kiring",
    forgotTitle: "Parolni tiklash",
    forgotDescription: "Emailingizni kiriting — yangi parol uchun havola yuboramiz.",
    forgotSentTitle: "Pochtangizni tekshiring",
    forgotSent: "Agar {{email}} ro'yxatdan o'tgan bo'lsa, unga havola keladi. U 30 daqiqa amal qiladi.",
    forgotAgain: "Havolani qayta so'rash",
    backToLogin: "Kirishga qaytish",
    forgotSend: "Havola yuborish",
    resetTitle: "Yangi parol",
    resetDescription: "Yangi parol o'ylab toping. Saqlangandan so'ng barcha qurilmalarda qayta kiring.",
    resetNoToken: "Havola to'liq emas yoki eskirgan. Yangisini so'rang.",
    newPassword: "Yangi parol",
    passwordRules: "Kamida 10 belgi, harflar va raqamlar",
    resetSave: "Parolni saqlash",
    resetDone: "Parol o'zgartirildi — yangi parol bilan kiring",
    emailField: "Email",
    loginTitle: "Tizimga kirish",
    loginDescription: "Muassasangizning buyurtmalari, oshxonasi, ombori va analitikasi bir joyda.",
    terms: "Foydalanuvchi kelishuvi",
    loginField: "Email yoki telefon",
    loginPlaceholder: "owner@cafe.kg yoki +996…",
    password: "Parol",
    passwordPlaceholder: "Parolni kiriting",
    forgot: "Parolni unutdingizmi?",
    forgotHint: "Parolni tiklash yaqin yangilanishda paydo boʻladi. Muassasa egasiga murojaat qiling.",
    signIn: "Kirish",
    noAccount: "Akkauntingiz yoʻqmi?",
    chooseCompany: "Kompaniyani tanlang",
    chooseCompanyHint: "Bu login bir nechta muassasada mavjud",
    registerTitle: "Muassasani ulash",
    registerDescription: "14 kun toʻliq imkoniyat bepul. Karta kerak emas.",
    haveAccount: "Akkauntingiz bormi?",
    companyName: "Muassasa nomi",
    companyNamePlaceholder: "«Tong» qahvaxonasi",
    yourName: "Ismingiz",
    yourNamePlaceholder: "Aziz Karimov",
    phoneHint: "Bildirishnomalar va kirishni tiklash uchun",
    passwordHint: "Kamida 10 ta belgi, harflar va raqamlar",
    newPasswordPlaceholder: "Parol oʻylab toping",
    acceptBefore: "Men",
    acceptLink: "oferta shartlarini",
    acceptAfter: "va shaxsiy maʼlumotlarni qayta ishlash siyosatini qabul qilaman",
    startFree: "Bepul boshlash",
    registerCodeTitle: "Emailni tasdiqlang",
    registerCodeDescription: "{{email}} manziliga 6 xonali kod yubordik. U 10 daqiqa amal qiladi.",
    registerCodeLabel: "Xatdagi kod",
    registerCodeHint: "Kelmadimi? «Spam» va «Aksiyalar» papkalarini tekshiring.",
    registerConfirm: "Tasdiqlash",
    registerResend: "Kodni qayta yuborish",
    registerResendIn: "{{sec}} soniyadan keyin qayta yuborish",
    registerCodeSent: "Kod {{email}} manziliga yuborildi",
    registerChangeData: "Ma'lumotlarni o'zgartirish",
    forgotSelfSent: "Yangi parol uchun havola {{email}} manziliga yuborildi",
    forgotNoEmail: "Sizda email ko'rsatilmagan — administratordan «Xodimlar» bo'limida yangi parol o'rnatishni so'rang.",
  },
  terminal: {
    mode: "Rejim",
    modeLogin: "Kirish",
    modeClock: "Smenani belgilash",
    clockTitle: "Kelish va ketish",
    clockHint: "PIN kiriting — kelish yoki ketish avtomatik belgilanadi",
    clockedIn: "{{name}}: kelish belgilandi",
    clockedOut: "{{name}}: ketish belgilandi, ishlangan {{h}}",
    mark: "Belgilash",
    activateTitle: "Terminalni faollashtirish",
    activateDescription: "«Sozlamalar → Terminallar» boʻlimidagi bir martalik kodni kiriting.",
    code: "Faollashtirish kodi",
    activate: "Faollashtirish",
    wrongPin: "PIN notoʻgʻri",
    terminal: "Terminal",
    pinTitle: "PIN orqali kirish",
    pinHint: "Smenani boshlash uchun PIN-kodingizni kiriting",
    digitsEntered: "Kiritilgan raqamlar: {{count}}",
    erase: "Oʻchirish",
    managerTitle: "Menejer kirishi",
    managerHint: "PIN faqat buyurtmani qayta tayyorlashga qaytarish uchun kerak. Oshpazlar oshxona ekranida kirmasdan ishlaydi.",
    backToScreen: "Ekranga qaytish",
    appDevice: "Bu Kafe Coco kassasi — uni brauzerda emas, Kafe Coco ilovasida «Terminallar» bo‘limidagi kod bilan bog‘lang.",
    unsupported: "Bu qurilma turi hozircha brauzerda ishlamaydi. Kassa, oshxona ekrani yoki tayyorlik ekranini yarating.",
    screenFailed: "Ekran ishga tushmadi",
    revoked: "Qurilma o‘chirilgan — «Terminallar» bo‘limidagi kod bilan qayta faollashtiring.",
  },
  dashboard: {
    hello: "Assalomu alaykum, {{name}}!",
    sectionsHint: "Sahifalarini koʻrish uchun boʻlimni bosing",
    pages: "Sahifalar: {{count}}",
  },
  currencies: { KGS: "qirgʻiz somi", KZT: "tenge", UZS: "oʻzbek soʻmi", RUB: "rubl", TJS: "somoniy", USD: "AQSh dollari", EUR: "yevro" },
  formats: { dine_in: "Zalda", takeaway: "Olib ketish", delivery: "Yetkazib berish", self_service: "Oʻz-oʻziga xizmat" },
  branches: {
    description: "Kompaniyaning savdo nuqtalari: manzillar, ish vaqti, xizmat formatlari.",
    add: "Filial qoʻshish", create: "Filial yaratish", newTitle: "Yangi filial", editTitle: "«{{name}}» filiali",
    searchPlaceholder: "Nomi yoki shahar", empty: "Hozircha filiallar yoʻq",
    deleteTitle: "«{{name}}» filiali oʻchirilsinmi?", deleteHint: "Filial barcha roʻyxatlardan yashiriladi. Savdo tarixi saqlanadi.", deleted: "Filial oʻchirildi",
    tabMain: "Asosiy", tabHours: "Ish vaqti",
    namePlaceholder: "Markaziy", slug: "Havoladagi manzil (slug)", slugHint: "Sayt manzili va QR-menyuda ishlatiladi",
    city: "Shahar", cityPlaceholder: "Toshkent", address: "Manzil", addressPlaceholder: "Amir Temur koʻch., 77",
    timezone: "Vaqt mintaqasi", currency: "Valyuta", dayCutoff: "Ish kunining almashinuvi", dayCutoffHint: "Shu vaqtgacha boʻlgan savdo oldingi kunga tegishli",
    formats: "Ish formatlari", formatsShort: "Formatlar", tzCurrency: "Mintaqa / valyuta", working: "Ishlayapti",
    isActive: "Filial ishlayapti", isActiveHint: "Oʻchirilgan filial buyurtma qabul qilmaydi va tarif limitiga hisoblanmaydi",
    hoursError: "Vaqtni tekshiring: SS:DD formati", dayOff: "Dam olish kuni",
    opens: "{{day}}: ochilishi", closes: "{{day}}: yopilishi",
    overnightHint: "Yopilish ochilishdan oldin boʻlsa, yarim tundan keyin ishlashni bildiradi (masalan, 10:00 — 02:00).",
    days: { mon: "Dushanba", tue: "Seshanba", wed: "Chorshanba", thu: "Payshanba", fri: "Juma", sat: "Shanba", sun: "Yakshanba" },
  },
  users: {
    description: "ERP ga parol bilan, terminallarga PIN bilan kirish. Rollar filiallar boʻyicha tayinlanadi.",
    add: "Xodim qoʻshish", newTitle: "Yangi xodim", added: "Xodim qoʻshildi",
    searchPlaceholder: "Ism, telefon yoki email", allStatuses: "Barcha holatlar", activeMany: "Faollar", blockedMany: "Bloklanganlar",
    employee: "Xodim", you: "(siz)", contacts: "Kontaktlar", roles: "Rollar", role: "Rol", login: "Kirish", lastLogin: "Oxirgi kirish",
    allBranchesLower: "barcha filiallar",
    status: { active: "Faol", blocked: "Bloklangan", invited: "Taklif qilingan" },
    notFound: "Hech kim topilmadi", empty: "Hozircha xodimlar yoʻq",
    resetPin: "PIN ni tiklash", resetPassword: "Parolni tiklash",
    sendResetLink: "Parolni tiklash havolasini yuborish", resetLinkSent: "Yangi parol uchun havola {{email}} manziliga yuborildi",
    emailCodeLabel: "Xodim xatidagi kod", emailCodeHint: "«Kod yuborish»ni bosing — kod shu emailga keladi. Xodimdan uni aytib berishni so'rang.", sendCode: "Kod yuborish", resendIn: "{{sec}} soniyadan keyin qayta", codeSent: "Kod {{email}} manziliga yuborildi",
    block: "Bloklash", blockTitle: "{{name}} bloklansinmi?", blockHint: "Xodimning barcha seanslari darhol yakunlanadi, kirish imkonsiz boʻladi.",
    blocked: "Xodim bloklandi", unblock: "Blokdan chiqarish", unblocked: "Xodim blokdan chiqarildi",
    deleteTitle: "{{name}} oʻchirilsinmi?", deleteHint: "Xodim roʻyxatlardan yoʻqoladi, uning amallari tarixi saqlanadi.", deleted: "Xodim oʻchirildi",
    fullName: "Ism va familiya", fullNamePlaceholder: "Dilnoza Rahimova",
    access: "Kirish usuli", accessHint: "PIN — filial terminalida tezkor kirish. Parol — ERP ga kirish (tarifning foydalanuvchilar limitiga hisoblanadi).",
    accessOptions: { pin: "Faqat PIN", password: "Parol (ERP)", both: "Parol va PIN" },
    pin: "PIN-kod", pinHint: "4–6 ta raqam, kompaniyada takrorlanmaydi",
    chooseRole: "Rolni tanlang", chooseBranch: "Filialni tanlang", checkRoles: "Rollarni tekshiring", assignRole: "Kamida bitta rol tayinlang",
    addRole: "Rol qoʻshish", removeRole: "Rolni olib tashlash",
    newPin: "Yangi PIN", newPassword: "Yangi parol", pinLabel: "PIN-kod (4–6 ta raqam)", passwordLabel: "Parol (≥ 10 ta belgi, harflar va raqamlar)",
    pinChanged: "PIN oʻzgartirildi", passwordChanged: "Parol oʻzgartirildi, xodimning barcha seanslari yakunlandi",
  },
  notifications: {
    bell: "Bildirishnomalar",
    bellUnread: "Bildirishnomalar: {{n}} ta yangi",
    title: "Bildirishnomalar",
    settings: "Sozlamalar",
    readAll: "Hammasini o'qilgan deb belgilash",
    new: "yangi",
    empty: "Hozircha bildirishnomalar yo'q",
    emptyHint: "Bu yerda smena yakunlari, qoldiqlar, qaytarishlar va QR-buyurtmalar paydo bo'ladi.",
    settingsTitle: "Bildirishnomalar",
    settingsDescription: "Qaysi bildirishnomalarni qayerga yuborish. Muhimlari sarlavhadagi qo'ng'iroqchada doim ko'rinadi.",
    telegramHint: "O‘z Telegramingizni ulang: {{bot}} boti rolingizga mavjud bildirishnomalarni yuboradi.",
    telegramLinked: "Ulangan {{user}}",
    telegramNotLinked: "Ulanmagan",
    telegramNotInPlan: "Telegram-bildirishnomalar Pro tarifida yoki «Telegram» qo'shimchasi bilan mavjud.",
    telegramConnect: "Telegramni ulash",
    telegramRelink: "Boshqa chatni ulash",
    telegramUnlink: "O'chirish",
    telegramUnlinkTitle: "Telegram bildirishnomalarini o'chirasizmi?",
    telegramOpened: "Telegramni oching va bot chatida «Start» tugmasini bosing",
    refresh: "Holatni yangilash",
    linkedAt: "Ulangan {{at}}",
    channels: "Kanallar",
    channelTelegram: "Botdan xabarlar",
    channelEmail: "{{email}} manziliga xatlar",
    noEmail: "Sizda email ko'rsatilmagan",
    dailyReport: "Kunlik hisobot",
    dailyReportHint: "Kechqurun filiallar bo'yicha yakun: tushum, cheklar, top taomlar, hisobdan chiqarishlar.",
    types: "Nimani yuborish",
    typesHint: "Kerakli bildirishnomalarni yoqing va qayerga yuborishni tanlang. Ro‘yxat rolingiz huquqlariga bog‘liq.",
    typesEmpty: "Rolingiz uchun bildirishnomalar yo‘q",
    typesEmptyHint: "Huquq berilganda (masalan, kassa, ombor yoki tahlil) bildirishnomalar paydo bo‘ladi.",
    fromCoca: "Coca'dan",
    whatsNew: "Coca'da yangi",
    open: "Ochish",
    typeLabels: {
      "stock_request": "Filiallardan omborga buyurtmalar",
      purchase_request: "Yangi xarid so‘rovlari",
      purchase_decision: "Mening xarid so‘rovlarim: qaror va xarid",
      "stock_expiring": "Yaroqlilik muddati: o‘tgan va tugayotgan",
      stock_low: "Mahsulotlar tugab bormoqda",
      shift_closed: "Kassa smenasi yopilishi (Z-yakun)",
      refund_created: "Qaytarishlar",
      report_daily: "Kunlik hisobot",
      order_qr: "Yangi QR-buyurtmalar",
      table_call: "Ofitsiantni chaqirish va hisob so‘rash (QR)",
      supplier_due: "Yetkazib beruvchilarga to‘lov (muddati o‘tgan va bugun–ertaga)",
      support_reply: "Murojaatlaringizga yordam xizmati javoblari",
      support_access: "Coca yordam xizmatining kabinetga kirish so‘rovlari",
      fraud_alert: "Xodimlarning shubhali harakatlari",
      sms_quota: "SMS kvotasi: 80% va 100%",
      goal_achieved: "Jamoaning bajarilgan maqsadlari",
      achievement_earned: "Mening maqsadlarim va yutuqlarim",
      waiter_table: "Mening stollarim: stol biriktirildi yoki topshirildi",
      platform_message: "Coca xabarlari",
      platform_update: "Coca'ning yangi imkoniyatlari",
    },
  },
  security: {
    title: "Xavfsizlik",
    description: "Akkauntga kirishni himoyalash va faol seanslar.",
    twoFactor: "Ikki bosqichli himoya",
    twoFactorHint: "Kirishda paroldan tashqari telefondagi ilovadan kod kerak bo'ladi.",
    on: "Yoqilgan",
    off: "O'chirilgan",
    recommend: "Egasi va administratorlarga tavsiya etiladi: parol oshkor bo'lsa ham, telefonsiz kirib bo'lmaydi.",
    enable: "Yoqish",
    enableTitle: "Ikki bosqichli himoyani yoqish",
    enableHint: "QR-kodni autentifikator ilovasida skanerlang va u ko'rsatgan kodni kiriting.",
    qrAlt: "Autentifikator ilovasi uchun QR-kod",
    manualKey: "Yoki kalitni qo'lda kiriting:",
    enabledToast: "Ikki bosqichli himoya yoqildi",
    enabledAt: "{{at}} yoqilgan. Qolgan zaxira kodlar: {{n}}.",
    fewCodes: "Zaxira kodlar deyarli qolmadi — yangilarini yarating.",
    regen: "Yangi zaxira kodlar",
    regenTitle: "Yangi zaxira kodlar",
    regenHint: "Eski kodlar ishlamay qoladi. Ilovadagi kodni kiriting.",
    disable: "O'chirish",
    disableTitle: "Ikki bosqichli himoyani o'chirasizmi?",
    disableHint: "Parol va ilovadagi kodni (yoki zaxira kodni) kiriting.",
    disabledToast: "Ikki bosqichli himoya o'chirildi",
    codeOrBackup: "Ilovadagi kod yoki zaxira kod",
    backupTitle: "Zaxira kodlar",
    backupHint: "Ularni ishonchli joyda saqlang: telefon yo'qolsa kerak bo'ladi. Har bir kod — bitta kirish. Ular qayta ko'rsatilmaydi.",
    copy: "Nusxalash",
    copied: "Kodlar nusxalandi",
    download: "Yuklab olish",
    saved: "Kodlarni saqladim",
    sessions: "Faol seanslar",
    sessionsHint: "Akkauntingizga qayerdan kirilgan.",
    current: "shu",
    lastUsed: "faollik {{at}}",
    unknownDevice: "Noma'lum qurilma",
    revoke: "Tugatish",
    revokeTitle: "Bu seansni tugatasizmi?",
    logoutAll: "Barcha qurilmalardan chiqish",
    logoutAllTitle: "Barcha qurilmalardan chiqasizmi?",
    logoutAllHint: "Barcha seanslar, shu seans ham, tugatiladi.",
  },
  approval: {
    descriptionVoid: "Pozitsiya allaqachon oshxonada — uni faqat menejer o'chira oladi. Undan PIN-kodini kiritishni so'rang.",
    title: "Menejer tasdig'i kerak",
    description: "{{action}}: {{value}} — limitingizdan ({{limit}}) yuqori. Menejerdan PIN-kodini kiritishni so'rang.",
    confirm: "Tasdiqlash",
    pin: "Menejer PIN-kodi",
    pinFormat: "PIN — 4–6 raqam",
    wrongPin: "PIN noto'g'ri",
    noRight: "Bu xodim bunday amalni tasdiqlay olmaydi",
    self: "Faqat boshqa xodim tasdiqlay oladi",
    hint: "Tasdiq bir martalik va 2 daqiqa amal qiladi. Jurnalda ikkala xodim ham qayd etiladi.",
    actions: {
      order_discount: "Chegirma",
      order_void: "Pozitsiyani o'chirish",
      payment_refund: "Qaytarish",
      stock_writeoff: "Hisobdan chiqarish",
      cash_cash_out: "Kassadan olish",
    },
  },
  roles: {
    limitsTitle: "Tasdiqsiz limitlar",
    limitsHint: "Limitdan yuqori amalni menejer PIN-kodi bilan tasdiqlaydi. Bo'sh — cheklovsiz.",
    limitEmpty: "Bo'sh — cheklovsiz",
    limits: {
      orders_discount: "Chegirma, ko'pi bilan",
      payments_refund: "Qaytarish, ko'pi bilan",
      stock_documents_create: "Hisobdan chiqarish, ko'pi bilan",
      cash_shifts_cash_out: "Kassadan olish, ko'pi bilan",
    },
    description: "Xodim huquqlari toʻplami. Oʻz huquqlaringizdan kengroq rolni bera olmaysiz.",
    newTitle: "Yangi rol", created: "Rol yaratildi", updated: "Rol yangilandi", deleted: "Rol oʻchirildi", deleteTitle: "«{{name}}» roli oʻchirilsinmi?",
    empty: "Rollar yoʻq", system: "Tizimli", systemHint: "Tizimli rol — platforma shabloni, kompaniyangiz uchun huquqlarini oʻzgartirish mumkin",
    stats: "Huquqlar: {{perms}} · Xodimlar: {{users}}", scopeCompany: "Butun kompaniya",
    ownerReadOnly: "Ega roli tahrirlanmaydi", ownerReadOnlyHint: "Egada har doim toʻliq kirish huquqi bor, jumladan obuna.",
    namePlaceholder: "Katta kassir", scope: "Amal doirasi", scopeFixed: "Rol doirasi yaratishda belgilanadi",
    scopeHint: "Butun biznes — buxgalter, auditor uchun; filial — kassir, oshpaz uchun",
    inBranch: "Filialda", inCompany: "Butun kompaniyada", permissions: "Huquqlar",
    findSection: "Boʻlimni topish", selectedCount: "Tanlangan huquqlar: {{count}}",
  },
  systemRoles: {
    owner: "Ega", company_admin: "Kompaniya administratori", branch_manager: "Filial boshqaruvchisi", accountant: "Buxgalter",
    cashier: "Kassir", waiter: "Ofitsiant", cook: "Oshpaz", auditor: "Auditor", courier: "Kuryer",
  },
  permResources: {
    report_resets: "Hisobotlarni tozalash",
    purchase_requests: "Xarid so‘rovlari",
    waiter_zones: "Zallar bo‘yicha ofitsiantlar",
    goals: "Maqsadlar va yutuqlar",
    "stock_transfers": "Ko‘chirishlar",
    "production": "Ishlab chiqarish",
    tips: "Choychaqa",
    dashboard: "Boshqaruv paneli", pos: "POS", orders: "Buyurtmalar", tables: "Stollar", halls: "Zallar", kitchen: "Oshxona", menu: "Menyu",
    stop_list: "Stop-roʻyxat", recipes: "Retsepturalar", costing: "Kalkulyatsiya", warehouses: "Omborlar", stock: "Qoldiqlar",
    stock_documents: "Ombor hujjatlari", inventory_counts: "Inventarizatsiya", suppliers: "Yetkazib beruvchilar", supplier_payments: "Yetkazib beruvchilarga to‘lovlar", customers: "Mijozlar", debts: "Qarzlar",
    payments: "Toʻlovlar", cash_shifts: "Kassa smenalari", reservations: "Bronlar", employees: "Xodimlar", work_shifts: "Ish smenalari", payroll: "Ish haqi",
    expenses: "Xarajatlar", analytics: "Analitika", reports: "Hisobotlar", settings: "Sozlamalar", branches: "Filiallar",
    users: "Foydalanuvchilar", roles: "Rollar", devices: "Terminallar", audit: "Audit", subscription: "Obuna", support: "Yordam", fraud: "Suiiste’moldan himoya", sms: "SMS-xabarnomalar", services: "Xizmatlar va ijara", banquets: "Banketlar", promotions: "Aksiyalar", deliveries: "Yetkazib berish",
  },
  permActions: {
    "receive": "Qabul qilish",
    "complete": "Chiqarishni o‘tkazish",
    adjust: "Tuzatish", write_off: "Hisobdan chiqarish", x_report: "X-hisobot", calculate: "Hisoblash", pay: "To‘lash", grant_access: "Yordam xizmatiga kirish ruxsati",
    view: "Koʻrish", create: "Yaratish", update: "Tahrirlash", delete: "Oʻchirish", manage: "Boshqarish", approve: "Tasdiqlash",
    cancel: "Bekor qilish", refund: "Qaytarish", discount: "Chegirmalar", void: "Annulyatsiya", reopen: "Qayta ochish", transfer: "Koʻchirish",
    merge: "Birlashtirish", split: "Boʻlish", price_override: "Narxni oʻzgartirish", credit_sale: "Qarzga sotish", print: "Chop etish",
    export: "Eksport", post: "Oʻtkazish", unpost: "Oʻtkazishni bekor qilish", open_shift: "Smenani ochish", close_shift: "Smenani yopish",
    cash_in: "Pul kiritish", cash_out: "Pul olish", finance: "Moliya", assign: "Tayinlash",
  },
  venue: {
    title: "«{{name}}» muassasasi: valyuta va soliq", description: "Kafe Coco kassalari uchun joriy filial sozlamalari — oʻzgarishlar kassalarga bir necha soniyada yetadi.",
    currency: "Valyuta", currencyHint: "Faqat ochiq buyurtmalar boʻlmaganda almashtirish mumkin", symbolPosition: "Valyuta belgisi", before: "Summadan oldin", after: "Summadan keyin",
    taxRate: "Soliq stavkasi, %", taxIncluded: "Soliq narxga kiritilgan", taxIncludedHint: "Soliq chek summasiga ustidan qoʻshilsa, oʻchiring",
  },
  company: {
    description: "Rekvizitlar va yangi filiallar uchun standart hududiy sozlamalar.",
    legalName: "Yuridik nomi", legalNamePlaceholder: "MChJ «…»", taxId: "STIR",
    defaultLocale: "Standart til", baseCurrency: "Asosiy valyuta", baseCurrencyHint: "Qoʻllab-quvvatlash xizmati orqali oʻzgaradi — hisobotlarga taʼsir qiladi",
  },
  geo: {
    tab: "Xaritada",
    cardTitle: "Kontaktlar va xaritadagi joylar",
    cardDescription: "Mehmonlar sizni Coca saytidagi «Yaqin atrofda» sahifasida topadi: filiallarning xaritadagi nuqtalari, kontaktlar va amaldagi aksiyalar. Saytingizda «Yo‘nalish» tugmasi paydo bo‘ladi.",
    openNearby: "«Yaqin atrofda»ni ochish",
    onMap: "Xaritada",
    notOnMap: "Ko‘rsatilmagan",
    set: "Xaritada ko‘rsatish",
    noAddress: "Manzil ko‘rsatilmagan",
    modalTitle: "{{name}} xaritada",
    branchHint: "Xaritani bosing yoki belgini muassasa kirish joyiga suring. Nuqta mehmonlarga Coca saytidagi «Yaqin atrofda» sahifasida va saytingizdagi «Yo‘nalish» tugmasida ko‘rinadi.",
    contactsHint: "Mehmonlar uchun telefon, email va ijtimoiy tarmoqlar (Instagram, WhatsApp, Telegram…) «Sayt va QR-menyu» bo‘limida to‘ldiriladi.",
    contactsLink: "Kontaktlarni to‘ldirish",
    findAddress: "Manzil bo‘yicha topish",
    myLocation: "Mening joylashuvim",
    clear: "Nuqtani olib tashlash",
    noPoint: "Nuqta ko‘rsatilmagan",
    hint: "Xaritani bosing — belgi qo‘yiladi",
    mapAria: "Xarita: filial joyini tanlang",
    notFound: "Manzil topilmadi — belgini xaritaga qo‘lda qo‘ying",
    denied: "Joylashuvni aniqlab bo‘lmadi — geolokatsiyaga ruxsat bering yoki belgini qo‘lda qo‘ying",
    invalid: "Nuqta noto‘g‘ri ko‘rsatilgan — belgini qayta qo‘ying",
  },

  subscription: {
    description: "Tarif, limitlar va ulangan funksiyalar. Toʻlov va tarifni almashtirish — platforma menejeri orqali (onlayn toʻlov keyinroq paydo boʻladi).",
    trialLeft: "Sinov muddati: {{count}} kun qoldi", trialHint: "Muddat tugagach, cheklovlarsiz ishlash uchun tarif tanlang.",
    payHint: "Toʻliq kirishni qaytarish uchun hisobni toʻlang. Kassadagi savdo ishlashda davom etadi.",
    plan: "{{plan}} tarifi", features: "Funksiyalar", featuresHint: "Belgilanganlari tarifingizda mavjud", available: "Mavjud", unavailable: "Mavjud emas",
    status: {
      trialing: "Sinov muddati", active: "Faol", past_due: "Toʻlov kutilmoqda", read_only: "Faqat oʻqish", suspended: "Toʻxtatilgan",
      cancelled: "Bekor qilingan", expired: "Muddati tugagan", archived: "Arxivda",
    },
    limits: {
      branches: "Filiallar", terminals: "Terminallar", users: "Parolli foydalanuvchilar", warehouses: "Omborlar", menu_items: "Menyu pozitsiyalari",
      ai_requests: "Shu oydagi Coca AI so‘rovlari",
      storage_gb: "Xotira, GB", report_history_days: "Hisobotlar tarixi, kun", api_rps: "API, soʻrov/s",
    },
  },
  features: {
    core: {
      pos: "Kassa va buyurtmalar", menu: "Menyu", tables: "Zal va stollar", kds: "Oshxona ekrani", inventory_basic: "Asosiy ombor",
      recipes: "Retsepturalar va kalkulyatsiya", customers: "Mijozlar", debts: "Mijozlar qarzlari", staff: "Xodimlar va smenalar",
      payroll_basic: "Asosiy ish haqi", analytics_basic: "Asosiy analitika", qr_menu: "QR-menyu", website: "Muassasa sayti",
    },
    addon: {
      qr_ordering: "QR-buyurtma", online_payments: "Onlayn toʻlov", inventory_pro: "Ombor (kengaytirilgan)", procurement: "Xaridlar",
      production: "Ishlab chiqarish", payroll_pro: "Ish haqi (kengaytirilgan)", finance: "Moliya", loyalty: "Sodiqlik",
      promotions_pro: "Aksiyalar (kengaytirilgan)", reservations: "Bron qilish", banquets: "Banketlar", services: "Xizmatlar va ijara",
      delivery: "Yetkazib berish", aggregators: "Agregatorlar", telegram: "Telegram-bot", sms: "SMS-xabarnomalar", analytics_pro: "Hisobotlar (kengaytirilgan)",
      fraud: "Suiisteʼmoldan himoya", reviews: "Sharhlar", custom_domain: "Saytning oʻz manzili", api_access: "Tashqi dasturlarni ulash", offline_mode: "Internetsiz ishlash",
      desktop: "Kompyuter uchun kassa dasturi", fiscal: "Fiskalizatsiya", accounting_export: "1C ga eksport", ai: "Aqlli yordamchi",
      white_label: "White label", priority_support: "Ustuvor qoʻllab-quvvatlash",
    },
  },
  devices: {
    download: "Kassa dasturini yuklab olish:", platforms: { windows: "Windows", macos: "macOS" },
    where: "Kassa qayerda ishlaydi", whereBrowser: "Brauzerda", whereApp: "Kompyuter uchun dastur",
    pair: "Kassani ulash", pairTitle: "Kassani ulash", pairHint: "Kompyuterdagi kassa dasturini oching va kodni kiriting:",
    pairOneTime: "Kod bir martalik. Ulangandan soʻng kassa ushbu filial menyusi va stollarini yuklaydi, xodimlar oʻz PIN kodi bilan kiradi.",
    description: "Kassalar, oshxona ekranlari va ofitsiantlar planshetlari. PIN orqali kirish faqat roʻyxatdan oʻtgan qurilmalarda ishlaydi.",
    add: "Terminal qoʻshish", newTitle: "Yangi terminal", getCode: "Kod olish", namePlaceholder: "Kirish yonidagi kassa",
    type: "Qurilma turi", typeShort: "Turi", activity: "Faollik",
    empty: "Hozircha terminallar yoʻq", emptyHint: "Kassa yoki oshxona ekranini qoʻshing va qurilmani bir martalik kod bilan faollashtiring.",
    reset: "Yangi kod", resetTitle: "«{{name}}» uchun yangi kod berilsinmi?", resetHint: "Qurilma darhol kirish huquqini yoʻqotadi, undagi seanslar yakunlanadi. Yangi kodni shu qurilmaning oʻzida kiriting — nomi, filiali va kassa raqami saqlanadi.", resetCodeTitle: "«{{name}}» uchun yangi kod",
    deleteTitle: "«{{name}}» oʻchirilsinmi?", deleteHint: "Terminal roʻyxatdan yoʻqoladi va darhol kirish huquqini yoʻqotadi, limitdagi joy boʻshaydi. Buyurtmalar va jurnal saqlanadi.", deleted: "Terminal oʻchirildi",
    revoke: "Bloklash", revokeTitle: "«{{name}}» bloklansinmi?", revokeHint: "Qurilma darhol kirish huquqini yoʻqotadi, undagi barcha seanslar yakunlanadi.", revoked: "Terminal oʻchirildi",
    openBefore: "«{{name}}» qurilmasida ushbu manzilni oching:", openAfter: "va kodni kiriting:",
    codeCopied: "Kod nusxalandi", copyCode: "Kodni nusxalash", codeValid: "Kod yana {{time}} amal qiladi", codeExpired: "Kod muddati tugadi — terminalda «⋯ → Yangi kod» orqali yangisini bering",
    oneTimeHint: "Kod bir martalik. Faollashtirilgandan soʻng xodimlar qurilmaga oʻz PIN-kodi bilan kiradi.",
    oneTimeHintScreen: "Kod bir martalik. Faollashtirilgandan so‘ng ekran o‘zi ochiladi — PIN kerak emas.",
    access: { pin: "Xodimlar o‘z PIN-kodi bilan kiradi va o‘z huquqlari bilan ishlaydi.", screen: "PINsiz ishlaydi: faollashtirilgandan so‘ng ekran darhol ochiladi.", app: "Kassa kompyuteridagi Kafe Coco ilovasida bog‘lanadi." },
    status: { pending: "Faollashtirish kutilmoqda", active: "Faol", revoked: "Oʻchirilgan" },
    types: {
      pos: "Kassa (POS)", kds: "Oshxona ekrani (KDS)", waiter: "Ofitsiant", kiosk: "Oʻz-oʻziga xizmat kioski", customer_display: "Mijoz ekrani",
      ready_screen: "Tayyorlik ekrani", printer_bridge: "Chop etish serveri", desktop: "Kassa (POS)", courier: "Kuryer",
    },
  },
  menu: {
    description: "Pozitsiyalar, kategoriyalar, modifikatorlar va stop-roʻyxat. Oʻzgarishlar kassalarda darhol koʻrinadi.",
    tabItems: "Pozitsiyalar", tabCategories: "Kategoriyalar", tabModifiers: "Modifikatorlar", tabStop: "Stop-roʻyxat",
    notForSale: "Sotilmaydi", stop: "Stop", remaining: "{{count}} ta qoldi", hiddenInBranch: "Filialda yashirilgan", priceFrom: "{{price}} dan",
    pricePerKg: "{{price}}/kg",
    searchItems: "Nomi yoki artikul boʻyicha qidirish", addItem: "Pozitsiya qoʻshish", noItems: "Menyuda hozircha pozitsiyalar yoʻq",
    createCategoryFirst: "Avval kategoriya yarating", createCategoryFirstHint: "Masalan, «Qahva», «Issiq taomlar», «Desertlar» — «Kategoriyalar» yorligʻida.",
  },
  bulk: {
    select: "Tanlash", done: "Tayyor", selectAll: "Hammasini tanlash", selectPage: "Sahifadagilarning hammasini tanlash", change: "O‘zgartirish",
    onSale: "Sotish", offSale: "Sotuvdan olish", showPublic: "Ochiq menyuda ko‘rsatish", hidePublic: "Ochiq menyudan yashirish",
    allowDiscount: "Chegirmaga ruxsat berish", denyDiscount: "Chegirmani taqiqlash", move: "Kategoriyaga ko‘chirish…", price: "Narxni o‘zgartirish…",
    fromStop: "Sotuvga qaytarish", setPortions: "Qoldiqni belgilash", stopTitle: "Stopga: {{count}} ta",
    priceTitle: "Narx: {{count}} ta", priceUp: "Oshirish", priceDown: "Kamaytirish", priceMode: "Qanday o‘zgartirish", pricePercent: "Foizga", priceAmount: "Summaga",
    priceHint: "Variantlar narxi ham shunday o‘zgaradi. Narx 0 dan kam bo‘lmaydi, eski narx yangisidan yuqori bo‘lmasa o‘chiriladi.",
    moveTitle: "{{count}} ta pozitsiyani ko‘chirish", category: "Kategoriya",
    showCategories: "Ko‘rsatish", hideCategories: "Yashirish", channelsTitle: "Savdo kanallari: {{count}} ta", keep: "O‘zgartirmaslik", show: "Ko‘rsatish", hide: "Yashirish",
    deleteItemsTitle: "Pozitsiyalarni o‘chirasizmi ({{count}})?", deleteItemsHint: "Pozitsiyalar kassalar va saytdan yo‘qoladi, savdo tarixi saqlanadi.",
    deleteCategoriesTitle: "Kategoriyalarni o‘chirasizmi ({{count}})?", deleteCategoriesHint: "Faqat bo‘sh kategoriyalar o‘chiriladi. Birortasida pozitsiya bo‘lsa — hech narsa o‘chirilmaydi.",
    updated: "O‘zgartirildi: {{count}}", deleted: "O‘chirildi: {{count}}", stopped: "Stopda: {{count}}", unstopped: "Yana sotuvda",
  },
  stop: {
    hint: "Joriy filial uchun amal qiladi (yuqori panelda tanlangan). Kassalar va QR-menyu pozitsiyani darhol yashiradi.",
    add: "Stopga qoʻyish", added: "Pozitsiya stop-roʻyxatda", portionsLeft: "Qolgan porsiyalar: {{count}}",
    item: "Pozitsiya", state: "Holati", since: "Qachondan", return: "Qaytarish", backOnSale: "Yana sotuvda",
    empty: "Stop-roʻyxat boʻsh", emptyHint: "Barcha pozitsiyalar sotuvda mavjud.",
    portions: "Qolgan porsiyalar", portionsHint: "Boʻsh — butunlay tugagan. Son — tugagunicha sotiladi",
  },
  categories: {
    title: "Kategoriya", newTitle: "Yangi kategoriya", image: "Kategoriya rasmi", namePlaceholder: "Qahva", slug: "Manzil (slug)",
    parent: "Ota kategoriya", parentHint: "3 darajagacha ichma-ich", topLevel: "Yuqori daraja",
    channels: "Qayerda koʻrsatish", channel: { pos: "Kassa", qr: "QR-menyu", website: "Sayt", delivery: "Yetkazib berish" }, visible: "Kategoriya koʻrinadi",
    deleteTitle: "«{{name}}» kategoriyasi oʻchirilsinmi?", deleted: "Kategoriya oʻchirildi", itemsCount: "{{count}} ta poz.", hidden: "Yashirilgan",
    subcategory: "Ichki kategoriya", empty: "Hozircha kategoriyalar yoʻq", emptyHint: "Masalan: Qahva, Ichimliklar, Issiq taomlar, Desertlar.",
  },
  modifiers: {
    saved: "Guruh saqlandi", notSelected: "Tanlanmagan", newTitle: "Yangi modifikatorlar guruhi", newGroup: "Yangi guruh",
    usedIn: "Guruh {{count}} ta pozitsiyada ishlatiladi. Ochiq buyurtmalar avvalgi modifikatorlarni saqlaydi.",
    groupName: "Guruh nomi", groupNamePlaceholder: "Qoʻshimchalar / Sut / Qovurish darajasi",
    selection: "Tanlov", selectionType: "Tanlov turi", single: "Bitta variant", multiple: "Bir nechta",
    min: "Minimum", minHint: "≥ 1 — majburiy guruh", max: "Maksimum", maxHint: "Boʻsh — cheklovsiz",
    free: "Bepul, dona", freeHint: "Birinchi N tasi — qoʻshimcha toʻlovsiz", allowQuantity: "Bir xil narsadan bir nechtasini tanlash mumkin (×2 pishloq)",
    namePlaceholder: "Pishloq", writeOff: "Mahsulotni hisobdan chiqarish", product: "Mahsulot", quantity: "Miqdori (asosiy birlikda)",
    replaces: "Ingrediyentni almashtiradi", replacesHint: "Masalan, sigir suti oʻrniga oʻsimlik suti", replaced: "Almashtiriladigan",
    removes: "Ingrediyentni olib tashlaydi", removesHint: "«Piyozsiz»", removed: "Olib tashlanadigan",
    kitchenLabel: "Oshxona uchun belgi", kitchenLabelPlaceholder: "+pishloq", isDefault: "Standart tanlangan", add: "Modifikator qoʻshish",
    required: "Majburiy", optional: "Ixtiyoriy", one: "Bitta", upTo: "{{max}} tagacha", inItems: "{{count}} ta poz.da",
    deleteTitle: "«{{name}}» guruhi oʻchirilsinmi?", empty: "Modifikatorlar guruhlari yoʻq", emptyHint: "Qoʻshimchalar, sut tanlash, qovurish darajasi, «piyozsiz».",
  },
  items: {
    title: "Menyu pozitsiyasi", newTitle: "Yangi pozitsiya", newSaved: "Yangi pozitsiya (saqlandi)",
    saved: "Pozitsiya saqlandi", createdNext: "Pozitsiya yaratildi — endi TTK tuzish mumkin",
    onSale: "Sotuvda", onSaleHint: "Oʻchirilgan pozitsiya hech qayerda sotilmaydi", visiblePublic: "Mehmonlarga koʻrinadi", visiblePublicHint: "QR-menyu va sayt",
    allowDiscount: "Chegirmalarga ruxsat", isWeighted: "Vazn boʻyicha sotish",
    isWeightedHint: "Palov, baliq, salatlar tarozida: narx 1 kg uchun, kassada vazn gramm yoki kilogrammda kiritiladi", pricePerKg: "1 kg narxi", recipeWeighted: "Pozitsiya vazn boʻyicha sotiladi: TTK chiqishi — kilogrammda. Masalan, 12 kg palov qozoni — chiqish 12; 450 g sotuv qozon mahsulotlarining 0,45 / 12 qismini hisobdan chiqaradi.",
    basePricePlaceholder: "Asosiy: {{price}}", branchPrice: "{{name}} filialidagi narx",
    branchesHint: "Asosiy narx kompaniya uchun umumiy. Filialda pozitsiyani yashirish yoki oʻz narxini belgilash mumkin — boʻsh maydon asosiy narxni bildiradi (BR-052).",
    photo: "Pozitsiya rasmi", namePlaceholder: "Latte", oldPrice: "Eski narx (chizilgan)", sku: "Artikul",
    stockProduct: "Ombordagi mahsulot", stockProductHint: "Sotuvda TTKsiz toʻgʻridan-toʻgʻri hisobdan chiqariladi",
    weight: "Vazni, g", volume: "Hajmi, ml", calories: "Kaloriyasi, kkal", cookingTime: "Tayyorlash vaqti, daq",
    descriptionPlaceholder: "Tarkibi va tortilishi — mehmonlar QR-menyu va saytda koʻradi",
    posTags: "Kassa teglari", posTagsHint: "Kafe Coco kassasidagi tezkor filtrlar; yangi teg uchun nomini yozing", barcodes: "Shtrix-kodlar", barcodesHint: "Kassadagi skaner uchun: kodni kiriting va Enter bosing", barcodePlaceholder: "4600000000017", removeBarcode: "{{code}} shtrix-kodini oʻchirish",
    tagsLabel: "Belgilar", allergensLabel: "Allergenlar",
    minAge: "Yosh cheklovi", minAgeHint: "Alkogol va tamaki uchun kassir yoshni tasdiqlaydi (BR-049)",
    variants: "Variantlar", variantsHint: "Oʻz narxiga ega oʻlchamlar va hajmlar (S/M/L, 25/30/40 sm). Variantlarsiz asosiy narxda sotiladi.",
    variantPlaceholder: "Masalan, 300 ml", variantName: "Variant nomi", variantPrice: "Variant narxi", byDefault: "Standart",
    deleteVariant: "Variantni oʻchirish", addVariant: "Variant qoʻshish",
    modifierGroups: "Modifikatorlar guruhlari", modifierGroupsHint: "Qoʻshimchalar, qovurish, sut. Majburiy guruhlarni kassir oʻtkazib yubora olmaydi (BR-025).",
    noneSelected: "Tanlanmagan", groupSummary: "{{count}} ta · {{kind}}",
    recipe: "TTK", recipeFirst: "Avval pozitsiyani yarating — soʻngra texnologik kartani tuzing.",
    types: { dish: "Taom", drink: "Ichimlik", product: "Tovar", service: "Xizmat", combo: "Kombo", modifier_only: "Faqat modifikator" },
    tags: { new: "Yangi", hit: "Xit", spicy: "Achchiq", vegan: "Vegan", vegetarian: "Vegetarian", halal: "Halol" },
    allergens: {
      gluten: "Glyuten", lactose: "Laktoza", eggs: "Tuxum", nuts: "Yongʻoq", peanuts: "Yeryongʻoq", soy: "Soya", fish: "Baliq", shellfish: "Mollyuskalar",
      sesame: "Kunjut", celery: "Selderey", mustard: "Xantal", sulfites: "Sulfitlar",
    },
  },
  units: { g: "g", kg: "kg", ml: "ml", l: "l", pcs: "dona", portion: "porsiya" },
  recipe: {
    noConversion: "Birlikni mahsulot birligiga oʻtkazib boʻlmaydi", checkRows: "TTK qatorlarini tekshiring", cycle: "Siklik havola",
    publishTitle: "TTK eʼlon qilinsinmi?", publishHint: "Yangi savdolar shu versiya boʻyicha hisobdan chiqariladi. Oldingi versiya arxivga oʻtadi, yopilgan buyurtmalar oʻzgarmaydi.",
    publish: "Eʼlon qilish", published: "TTK eʼlon qilindi", discardTitle: "Qoralama bekor qilinsinmi?", discard: "Qoralamani bekor qilish",
    draftV: "Qoralama v{{v}}", publishedV: "Eʼlon qilingan v{{v}}", none: "TTK yoʻq", salesUse: "Savdolar eʼlon qilingan v{{v}} boʻyicha hisobdan chiqariladi",
    incomplete: "Tannarx toʻliq emas", output: "Chiqish", outputUnit: "Chiqish birligi",
    ingredient: "Ingrediyent", gross: "Brutto", unitShort: "Birl.", waste: "Chiqindi %", loss: "Yoʻqotish %", netSum: "Netto / summa",
    productPlaceholder: "Mahsulot yoki yarim tayyor mahsulot", noPrice: "narxi yoʻq", takeawayOnly: "Faqat olib ketish", deleteRow: "Qatorni oʻchirish",
    takeawayHint: "Faqat «olib ketish» va yetkazib berish uchun (qadoq)", addIngredient: "Ingrediyent qoʻshish",
    cost: "Tannarx", perPortion: "Bir porsiyaga", perOutput: "Chiqishga",
    instructions: "Tayyorlash texnologiyasi", instructionsPlaceholder: "Tayyorlash tartibi, harorat, tortilishi",
    draftSaved: "Qoralama saqlandi", saveDraft: "Qoralamani saqlash", history: "Versiyalar tarixi",
    statusActive: "amalda", statusDraft: "qoralama", statusArchive: "arxiv",
    owner: "TTK nima uchun", forItem: "Taom (umumiy)", variantsHint: "Har bir variantning oʻz TTKsi bor. Agar variantda u boʻlmasa, sotuvda taomning TTKsi boʻyicha hisobdan chiqariladi.",
    copy: "Nusxalash…", copyTitle: "TTKni nusxalash", copyAction: "Nusxalash",
    copyHint: "Tarkib, texnologiya va chiqish tanlangan variantlarning qoralamalariga tushadi (ularning qoralamalari almashtiriladi). Har birini alohida eʼlon qiling.",
    factorFor: "«{{name}}» uchun koeffitsiyent", factorHint: "Koeffitsiyent bruttoni koʻpaytiradi: 1 — oʻzgarishsiz, 1.5 — 50% koʻp (S → L).",
    copied: "Nusxalangan TTK: {{count}}",
  },
  products: {
    description: "Ingrediyentlar, tovarlar, yarim tayyor mahsulotlar va qadoq — TTK va omborning asosi.",
    add: "Mahsulot qoʻshish", newTitle: "Yangi mahsulot", saved: "Mahsulot saqlandi",
    searchPlaceholder: "Nomi, artikul yoki shtrix-kod", allTypes: "Barcha turlar",
    empty: "Hozircha mahsulotlar yoʻq", emptyHint: "Xarid narxi bilan ingrediyentlarni qoʻshing — taomlar tannarxi avtomatik hisoblanadi.",
    namePlaceholder: "Sut 3.2%", baseUnit: "Hisob birligi", baseUnitHint: "Faqat mahsulot TTKda boʻlmasa oʻzgaradi",
    baseUnits: { g: "grammlar", ml: "millilitrlar", pcs: "dona" }, unitColumn: "Hisob",
    purchasePrice: "Xarid narxi", purchasePriceFor: "{{unit}} uchun xarid narxi", perBaseHint: "= {{unit}} uchun {{price}} tiyin", priceAutoHint: "Qabul qilishda avtomatik yangilanadi",
    purchaseLoss: "Xariddagi yoʻqotish (standart)", purchaseLossHint: "Xarid qatoriga qoʻyiladi: suyak, tozalash, eritish", purchaseLossQtyHint: "Aniq: har bir xariddan shuncha {{unit}} yoʻqotiladi (idish, muz)", waste: "Standart chiqindi, %", wasteHint: "TTKga qoʻyiladi", barcodes: "Shtrix-kodlar", barcodesHint: "Vergul orqali",
    density: "Zichligi, g/ml", densityHint: "TTKda suyuqliklar uchun grammni koʻrsatish uchun kerak (va aksincha)",
    shelfLife: "Yaroqlilik muddati, kun", minStock: "Minimal qoldiq", minStockHint: "{{unit}} da — bildirishnomalar uchun",
    allergensHint: "Menyu pozitsiyalari ingrediyentlar allergenlarini meros qilib oladi", productionRecipe: "Ishlab chiqarish TTKsi",
    types: { ingredient: "Ingrediyent", goods: "Tovar", semi_finished: "Yarim tayyor mahsulot", packaging: "Qadoq", consumable: "Sarf materiali" },
  },
  costing: {
    descriptionGross: "Food cost maqsadi — {{pct}}%. Tannarx brutto va joriy xarid narxlari boʻyicha.",
    descriptionNet: "Food cost maqsadi — {{pct}}%. Tannarx netto va joriy xarid narxlari boʻyicha.",
    settingsTitle: "Kalkulyatsiya sozlamalari", settingsSaved: "Sozlamalar saqlandi",
    target: "Maqsadli food cost, %", targetHint: "Maqsaddan yuqori pozitsiyalar ajratib koʻrsatiladi; tavsiya etilgan narx shundan hisoblanadi",
    rounding: "Tavsiya etilgan narxni yaxlitlash", base: "Ingrediyentlar narxini hisoblash asosi", baseShort: "Hisoblash asosi", net: "Netto",
    overTarget: "Maqsaddan yuqori · {{count}}", noRecipe: "TTKsiz · {{count}}", costShort: "Tannarx", noRecipeBadge: "TTK yoʻq", noPrices: "narxlar yoʻq",
    margin: "Marja", markup: "Ustama", recommended: "Tavsiya etilgan narx",
    empty: "Pozitsiyalar yoʻq", emptyHint: "Menyu pozitsiyalarini qoʻshing va ular uchun TTK tuzing.",
    incompleteNote: "* — tannarx toʻliq emas: ayrim ingrediyentlarning xarid narxi yoʻq.",
  },
  upload: {
    photo: "Rasm", chooseImage: "Rasm tanlang", tooLarge: "Fayl juda katta",
    drop: "Rasmni bu yerga torting yoki tanlash uchun bosing", formats: "JPEG, PNG, WebP, HEIC · 10 MB gacha", replace: "Almashtirish", remove: "Olib tashlash",
  },
  tables: {
    description: "Joriy filialning zal rejasi, stollar holati va QR-kodlar.",
    status: { free: "Boʻsh", occupied: "Band", awaiting_payment: "Toʻlov kutmoqda", reserved: "Bron qilingan", cleaning: "Tozalash", unavailable: "Mavjud emas" },
    hallTypes: { hall: "Zal", vip: "VIP", terrace: "Terrasa", room: "Xona", banquet: "Banket", bar: "Bar" },
    shapes: { square: "Kvadrat", rect: "Toʻrtburchak", round: "Dumaloq" },
    planOf: "«{{name}}» zali rejasi", tableAria: "{{number}}-stol, oʻrinlar: {{count}}, {{status}}", seatsShort: "{{count}} oʻrin",
    hall: "Zal", newHall: "Yangi zal", hallPlaceholder: "Asosiy zal", createHall: "Zal yaratish",
    noHalls: "Hozircha zallar yoʻq", noHallsHint: "Zal yarating va stollarni joylashtiring — ofitsiantlar va kassirlar stolni rejadan tanlaydi.",
    table: "{{number}}-stol", tableShort: "Stol", newTable: "Yangi stol", tableStatus: "Stol holati",
    number: "Raqami", seats: "Oʻrinlar", shape: "Shakli", width: "Eni", height: "Boʻyi", rotation: "Burilish, °",
    gridTitle: "Kassadagi joyi", gridHint: "Kafe Coco kassasidagi zal sxemasi toʻridagi stol joyi. Boʻsh qolsa — kassa oʻzi joylashtiradi.", gridRow: "Qator", gridColumn: "Ustun", gridSpan: "Kengligi, ustun",
    nameOptional: "Nomi (ixtiyoriy)", namePlaceholder: "Deraza yonida", isActive: "Stol ishlatiladi",
    qr: "Stol QR-kodi", copy: "Nusxalash", linkCopied: "Havola nusxalandi", qrSticker: { open: "QR-kod", title: "{{number}}-stol QR-kodi", preview: "Stol uchun yorliq", print: "Chop etish", png: "PNG yuklab olish", table: "Stol", hintOrder: "Menyu, buyurtma va ofitsiantni chaqirish", hintMenu: "Muassasa menyusi" },
    regenerate: "Qayta chiqarish", regenerateTitle: "QR qayta chiqarilsinmi?", regenerateHint: "Eski stikerlar ishlamay qoladi.",
    deleteTable: "{{number}}-stol oʻchirilsinmi?", planSaved: "Zal rejasi saqlandi",
    view: "Koʻrinish", plan: "Reja", list: "Roʻyxat", savePlan: "Rejani saqlash", arrange: "Joylashtirish",
    renameHall: "Zal nomini oʻzgartirish", deleteHall: "Zalni oʻchirish", deleteHallTitle: "«{{name}}» zali oʻchirilsinmi?", deleteHallHint: "Zal stollari ham oʻchiriladi.",
    statuses: "Holatlar", dragHint: "Stollarni sichqoncha yoki barmoq bilan suring. Toʻr — {{grid}} birlik.",
    noTables: "Zalda stollar yoʻq", addTable: "Stol qoʻshish",
  },
  orders: {
    payments: "To‘lovlar",
    refunds: "Qaytarishlar",
    refund: "Qaytarishni rasmiylashtirish",
    refundTitle: "{{n}} buyurtma bo‘yicha qaytarish",
    refundAmount: "Qaytarish summasi",
    refundReason: "Qaytarish sababi",
    refundPayment: "To‘lov",
    refundAvailable: "Qaytarish mumkin: {{amount}}",
    refundDone: "Qaytarish rasmiylashtirildi",
    paidSum: "To‘langan",
    refundedSum: "Qaytarilgan",
    tax: "Soliq",
    taxIncluded: "Shu jumladan soliq",
    methods: {
      qr: "QR",
      credit: "Qarzga",
      cash: "Naqd",
      card: "Karta",
      deposit: "Banket depoziti",
    },
    anyPayment: "To‘lovga bog‘lanmagan",
    title: "Buyurtmalar",
    description: "Filial buyurtmalari: ochiq va tarix.",
    open: "Ochiq",
    all: "Hammasi",
    number: "Raqam",
    dailyNo: "№{{n}}",
    type: "Turi",
    table: "Stol",
    tableN: "Stol {{n}}",
    items: "Pozitsiyalar",
    total: "Summa",
    opened: "Ochilgan",
    empty: "Buyurtmalar yo‘q",
    emptyHint: "Yangi buyurtmalar kassada yaratiladi",
    history: "Tarix",
    search: "Raqam yoki mehmon ismi",
    guests: "Mehmonlar",
    guest: "Mehmon",
    comment: "Buyurtmaga izoh",
    cancel: "Buyurtmani bekor qilish",
    cancelTitle: "{{n}} buyurtmasini bekor qilasizmi?",
    cancelHint: "Yuborilgan pozitsiyalar bekor qilinadi, oshxonaga xabar boradi.",
    reason: "Sabab",
    reasonComment: "Izoh",
    void: "Bekor qilish",
    voidTitle: "«{{name}}» bekor qilinsinmi?",
    voidSentHint: "Pozitsiya oshxonada — oshpazga xabar boradi.",
    cancelled: "Buyurtma bekor qilindi",
    voided: "Pozitsiya bekor qilindi",
    details: "Buyurtma {{n}}",
    openInPos: "Kassada ochish",
    events: {
      line_added: "Pozitsiya qo‘shildi",
      qty_changed: "Miqdor o‘zgardi",
      payment: "To‘lov",
      refund: "Qaytarish",
      "order.update": "O‘zgartirildi",
      created: "Yaratildi",
      items_added: "Pozitsiyalar qo‘shildi",
      item_updated: "Pozitsiya o‘zgartirildi",
      item_voided: "Pozitsiya bekor qilindi",
      sent_to_kitchen: "Oshxonaga yuborildi",
      cancelled: "Bekor qilindi",
      transferred: "Boshqa stolga o‘tkazildi",
      updated: "O‘zgartirildi",
    },
    statuses: {
      draft: "Qoralama",
      open: "Ochiq",
      confirmed: "Tasdiqlangan",
      cooking: "Tayyorlanmoqda",
      ready: "Tayyor",
      served: "Berildi",
      paid: "To‘langan",
      completed: "Yopilgan",
      cancelled: "Bekor qilingan",
      refunded: "Qaytarilgan",
      partially_refunded: "Qisman qaytarilgan",
    },
    itemStatuses: {
      new: "Yangi",
      sent: "Oshxonada",
      accepted: "Qabul qilindi",
      cooking: "Tayyorlanmoqda",
      ready: "Tayyor",
      served: "Berildi",
      voided: "Bekor qilingan",
      returned: "Qaytarilgan",
    },
    types: {
      dine_in: "Zalda",
      takeaway: "Olib ketish",
      delivery: "Yetkazib berish",
      self_service: "O‘z-o‘ziga xizmat",
      pickup: "O‘zi olib ketish",
    },
    reasons: {
      guest_mistake: "Mehmon xatosi",
      waiter_mistake: "Xodim xatosi",
      long_wait: "Uzoq kutish",
      out_of_stock: "Mavjud emas",
      quality: "Sifat",
      other: "Boshqa",
    },
  },
  pos: {
    transferWaiter: "Ofitsiantga topshirish",
    transfer: "Topshirish",
    noWaiters: "Ofitsiantlar yo‘q: ularni «Zallar bo‘yicha ofitsiantlar» bo‘limida zonalarga qo‘shing yoki smenani belgilang.",
    waiter: "Ofitsiant",
    pickWaiter: "Ofitsiantni tanlang",
    waiterIs: "Ofitsiant: {{name}}",
    transferred: "Stol topshirildi",
    promotions: "Aksiyalar",
    promotionsHint: "Mos aksiyalar avtomatik hisoblanadi va buyurtma o‘zgarganda qayta hisoblanadi.",
    applyPromotions: "Aksiyalar",
    promotionsOn: "Aksiyalar yoqilgan",
    promotionsSwitch: "Aksiyalarni qo‘llash",
    promotionsSwitchHint: "Buyurtmadan barcha aksiyalarni olib tashlash uchun o‘chiring",
    promoCodes: "Promokodlar",
    promoCodesHint: "Vergul bilan, masalan WELCOME10",
    promoCodeInvalid: "Promokod topilmadi yoki amal qilmaydi",
    promotionsSaved: "Aksiyalar qayta hisoblandi",
    discount: "Chegirma",
    discountHint: "Chegirmaga ruxsat berilgan pozitsiyalarga. Limitdan yuqori — menejer PIN-kodi kerak.",
    applyDiscount: "Qo'llash",
    removeDiscount: "Chegirmani olib tashlash",
    discountKind: "Chegirma turi",
    discountPercent: "Foiz",
    discountAmount: "Summa",
    discountReason: "Sabab",
    discountValueRequired: "Chegirma miqdorini kiriting",
    discountPreview: "Chegirma",
    discountSaved: "Chegirma qo'llandi",
    addDiscount: "Chegirma qo'shish",
    changeDiscount: "Chegirmani o'zgartirish",
    discountReasons: {
      regular: "Doimiy mehmon",
      compliment: "Kompliment",
      staff: "Xodim",
      promo: "Aksiya",
      complaint: "Mehmon shikoyati",
      other: "Boshqa",
    },
    pickCustomer: "Mijoz",
    clearCustomer: "Mijozni olib tashlash",
    noShift: "Kassa smenasi ochilmagan",
    noShiftHint: "Kassir yoki boshqaruvchidan veb-kassa smenasini ochishni so‘rang.",
    creditNoCustomer: "Qarzga sotish uchun mijozni tanlang",
    creditOverLimit: "Kredit mavjud emas yoki limit oshgan. Mavjud: {{left}}",
    creditInfo: "{{name}}: qarz {{debt}}, limit {{limit}}",
    reference: "RRN yoki oxirgi 4 raqam",
    referenceHint: "Ixtiyoriy — terminal bilan solishtirish uchun",
    payTitle: "{{n}} buyurtmani to‘lash",
    due: "To‘lanadigan",
    method: "To‘lov usuli",
    amount: "To‘lov summasi",
    received: "Mehmondan olindi",
    tip: "Choychaqa",
    change: "Qaytim",
    payConfirm: "{{amount}} qabul qilish",
    paidDone: "Buyurtma to‘landi",
    partPaid: "{{total}} dan {{paid}} to‘landi",
    tax: "Soliq",
    taxIncluded: "Shu jumladan soliq",
    exact: "Qaytimsiz",
    notEnough: "Olingan summa to‘lovdan kam",
    paidAlready: "To‘langan",
    printReceipt: "Chek chop etish",
    title: "Kassa",
    newOrder: "Yangi buyurtma",
    openOrders: "Ochiq buyurtmalar",
    orderHistory: "Buyurtmalar tarixi",
    reservations: "Bronlar",
    noOpen: "Ochiq buyurtmalar yo‘q",
    searchMenu: "Menyudan qidirish…",
    orderDetails: "Buyurtma tafsilotlari",
    orderInfo: "Buyurtma haqida",
    customerName: "Mehmon ismi",
    selectTable: "Stolni tanlang",
    tableN: "Stol {{n}}",
    addNote: "Buyurtmaga izoh",
    notePlaceholder: "Buyurtmaga izoh yozing…",
    addToOrder: "Buyurtmaga qo‘shish",
    empty: "Menyudan pozitsiya qo‘shing",
    subtotal: "Oraliq summa",
    total: "Jami",
    send: "Oshxonaga",
    sendN: "Oshxonaga · {{n}}",
    sent: "Oshxonaga yuborildi",
    precheck: "Oldindan chek",
    pay: "To‘lash",
    paySoon: "To‘lov qabul qilish keyingi yangilanishda paydo bo‘ladi",
    stopped: "Stop",
    left: "Qoldi {{n}}",
    modifiersTitle: "Variantlarni tanlang",
    required: "majburiy",
    upTo: "{{n}} tagacha",
    chooseOne: "bittasini tanlang",
    quantity: "Miqdor",
    itemComment: "Pozitsiyaga izoh",
    weight: "Vazn", weightHint: "Narxi 1 kg uchun {{price}} — tortib, vaznini kiriting", changeWeight: "Vaznni oʻzgartirish", weightLine: "{{weight}} × {{price}}/kg", saveWeight: "Vaznni saqlash",
    add: "Qo‘shish · {{price}}",
    variant: "O‘lcham",
    course: "{{n}}-kurs",
    guestsN: "Mehmonlar: {{n}}",
    back: "Orqaga",
    switchUser: "Foydalanuvchini almashtirish",
    online: "Onlayn",
    reconnecting: "Qayta ulanmoqda…",
    offline: "Aloqa yo‘q",
    orderReady: "№{{n}} buyurtma tayyor",
    cart: "Buyurtma · {{n}}",
    tableSelect: "Stol tanlash",
    noHalls: "Zallar yo‘q — «Zallar va stollar» bo‘limida yarating",
    noOrder: "Buyurtma tanlanmagan",
    quick: {
      noOnion: "piyozsiz",
      spicy: "achchiqroq",
      noIce: "muzsiz",
      hot: "issiqroq",
    },
  },
  kds: {
    title: "Oshxona",
    station: "Stansiya",
    chooseStation: "Stansiyani tanlang",
    noStations: "Stansiyalar yo‘q — «Oshxona stansiyalari»ni oching",
    new: "Yangi",
    cooking: "Tayyorlanmoqda",
    ready: "Tayyor",
    start: "Boshlash",
    done: "Tayyor",
    serve: "Berish",
    recall: "Qaytarish",
    accept: "Qabul qilish",
    empty: "Buyurtmalar yo‘q",
    emptyHint: "Yangi buyurtmalar shu yerda avtomatik chiqadi",
    minutes: "{{n}} daq",
    soundOn: "Ovoz yoqilgan",
    soundOff: "Ovozni yoqish",
    keyboardHint: "1–9 — chiptani tanlash, Enter — keyingi qadam",
    recalled: "Qayta ishga qaytarildi",
    print: "Chop etish",
    repeatReadySound: "Tayyorlik ovozini takrorlash",
    exit: "Chiqish",
    newTicket: "Yangi buyurtma №{{n}}",
    managerLogin: "Menejer kirishi",
  },
  readyBoard: {
    title: "Buyurtmalar tayyorligi",
    preparing: "Tayyorlanmoqda",
    ready: "Tayyor — olib keting",
    empty: "Hozircha buyurtma yo‘q",
    fullscreen: "To‘liq ekran",
    background: "Tablo foni",
    backgrounds: { white: "Oq", warm: "Iliq oq", gray: "Och kulrang", graphite: "Grafit" },
    palette: "Rang palitrasi",
    palettes: { coca: "Coca", ocean: "Okean", forest: "Zumrad", violet: "Binafsha" },
    voice: "Ovozli e’lon",
    enableVoice: "Ovozni yoqish",
    speech: "{{number}}-buyurtma tayyor",
    speechNamed: "{{name}}, {{number}}-buyurtmangiz tayyor",
  },
  stations: {
    "warehouse": "Stansiya ombori",
    "warehouseHint": "Bu stansiya pozitsiyalarining sotuvi tanlangan ombordan hisobdan chiqariladi",
    "mainWarehouse": "Filialning asosiy ombori",
    title: "Oshxona stansiyalari",
    description: "Oshxona sexlari va ekranlari: buyurtma pozitsiyalari qayerga boradi.",
    add: "Stansiya qo‘shish",
    type: "Turi",
    norm: "Tayyorlash me’yori, daq",
    normHint: "Me’yordan keyin chipta sariq, 1,5 me’yordan keyin qizil bo‘ladi",
    simple: "Oddiy rejim",
    simpleHint: "Qahvaxona: chipta bir bosishda «Tayyor»",
    isDefault: "Standart",
    defaultHint: "Stansiyasiz pozitsiyalar shu yerga boradi",
    active: "Faol",
    activeTickets: "Faol chiptalar: {{n}}",
    empty: "Stansiyalar yo‘q",
    emptyHint: "Oshxonaga birinchi yuborishda «Oshxona» stansiyasi yaratiladi",
    deleteTitle: "«{{name}}» stansiyasi o‘chirilsinmi?",
    itemStation: "Oshxona stansiyasi",
    itemStationHint: "Bo‘sh — filialning standart stansiyasi",
    types: {
      hot: "Issiq sex",
      cold: "Sovuq sex",
      bar: "Bar",
      coffee: "Qahva",
      bakery: "Pishiriqlar",
      pizza: "Pitsa",
      grill: "Gril",
      dessert: "Desertlar",
      packing: "Qadoqlash",
      expo: "Tarqatish",
    },
  },
  print: {
    document: "Hujjat",
    print: "Chop etish",
    savePdf: "PDF saqlash",
    excel: "Excel yuklab olish",
    pdfHint: "Chop etish oynasida «PDF sifatida saqlash»ni tanlang",
    printedAt: "Chop etildi",
    precheck: "Oldindan chek",
    notFiscal: "Fiskal hujjat emas",
    table: "Stol",
    guests: "Mehmonlar",
    total: "Jami",
    thanks: "Rahmat!",
    printed: "Chop etishga yuborildi",
    usb: {
      title: "Chek printeri (USB)",
      description: "Cheklar, oldindan cheklar, oshxona tiketlari va smena hisobotlari chop etish oynasisiz to'g'ridan-to'g'ri printerga chiqadi. Sozlama shu qurilmada saqlanadi.",
      menu: "Chek printeri",
      pick: "USB-printerni tanlash",
      change: "Boshqa",
      connected: "Printer ulandi",
      savedHere: "Shu qurilmaga ulangan",
      howTo: "Chek printerini (ESC/POS) USB kabel bilan shu kompyuterga ulang va quyidagi tugmani bosing — brauzer qurilmalar ro'yxatini ko'rsatadi.",
      enabled: "USB-printerga chop etish",
      enabledHint: "O'chiq — brauzer oynasi orqali chop etish",
      paper: "Lenta kengligi",
      mm: "{{n}} mm",
      cut: "Chekdan keyin lentani kesish",
      test: "Sinov chop etish",
      testTitle: "Sinov chop etish",
      drawer: "Pul qutisini ochish",
      forget: "Uzish",
      busyHint: "Printer javob bermasa, Windows'da u o'z drayveri bilan band: drayverni WinUSB'ga almashtiring (Zadig dasturi). Linux'da usblp modulini o'chiring.",
      unsupportedTitle: "Brauzer USB orqali chop etishni qo'llab-quvvatlamaydi",
      unsupported: "Kompyuterda Google Chrome yoki Microsoft Edge va https manzil kerak. Safari, Firefox va iPhone'da — brauzer oynasi orqali.",
      errors: {
        notFound: "USB-printer topilmadi: kabel va quvvatni tekshiring. Chop etish — brauzer oynasi orqali.",
        busy: "Printer tizim drayveri bilan band. Windows'da drayverni WinUSB'ga (Zadig) almashtiring, Linux'da usblp'ni o'chiring.",
        noEndpoint: "Bu qurilma chek printeriga o'xshamaydi.",
        notConfigured: "USB-printer tanlanmagan.",
        cancelled: "Printer tanlanmadi.",
        denied: "Brauzer bu sahifada USB'ga kirishni taqiqladi.",
        failed: "USB-printerda chop etib bo'lmadi: {{message}}",
      },
    },
  },
  reports: {
    title: "Sotuvlar hisoboti",
    description: "Davr bo‘yicha to‘lovlar va qaytarishlardan tushum, buyurtmalar, o‘rtacha chek va top taomlar.",
    from: "Dan",
    to: "Gacha",
    groupBy: "Guruhlash",
    byHour: "Soatlar bo‘yicha",
    byDay: "Kunlar bo‘yicha",
    revenue: "Tushum",
    revenueHint: "To‘lovlar − qaytarishlar",
    orders: "Buyurtmalar",
    avgCheck: "O‘rtacha chek",
    refunds: "Qaytarishlar",
    tips: "Choychaqa",
    tax: "Soliq",
    cancelled: "Bekor qilingan",
    payments: "To‘lovlar",
    cash: "Naqd",
    card: "Karta",
    chart: "Vaqt bo‘yicha tushum",
    top: "Top taomlar",
    product: "Taom",
    qty: "Miqdor",
    sum: "Summa",
    noData: "Davr ichida sotuv yo‘q",
    mismatches: "Menyu narxidan boshqa narxda sotilgan",
    mismatchHint: "Kassa buyurtmani o‘z narxida qabul qildi (masalan, menyu yangilanishidan oldin oflayn). Server bunday buyurtmalarni qayta hisoblamaydi.",
    menuPrice: "Menyu narxi",
    soldPrice: "Sotuv narxi",
    lines: "Qatorlar",
    presets: {
      today: "Bugun",
      yesterday: "Kecha",
      week: "7 kun",
      month: "30 kun",
    },
  },
  reservations: {
    title: "Bron qilish",
    description: "Stollarni bron qilish: kassa ularni darhol ko‘radi va mehmonlar kelishidan bir soat oldin stolni belgilaydi.",
    add: "Yangi bron",
    edit: "Bron",
    customer: "Mehmon ismi",
    phone: "Telefon",
    guests: "Mehmonlar",
    date: "Sana",
    time: "Vaqt",
    duration: "Davomiyligi",
    startsAt: "Boshlanishi",
    endsAt: "Tugashi",
    tables: "Stollar",
    note: "Izoh",
    status: "Holati",
    statuses: {
      booked: "Bron qilingan",
      seated: "Mehmonlar keldi",
      completed: "Yakunlangan",
      cancelled: "Bekor qilingan",
      no_show: "Kelishmadi",
    },
    empty: "Bronlar yo‘q",
    emptyHint: "Bron yarating — kassa uni ko‘rib, stolni belgilaydi",
    cancel: "Bronni bekor qilish",
    cancelTitle: "«{{name}}» bronini bekor qilasizmi?",
    cancelled: "Bron bekor qilindi",
    saved: "Bron saqlandi",
    seat: "Mehmonlar keldi",
    noShow: "Kelishmadi",
    complete: "Yakunlash",
    conflict: "Bron boshqa qurilmada o‘zgartirildi — maʼlumotlar yangilandi",
    minutes: "{{n}} daq",
    hours: "{{n}} soat",
    noTables: "Stolsiz",
    prevDay: "Oldingi kun",
    nextDay: "Keyingi kun",
    today: "Bugun",
    guestsN: "{{n}} mehmon",
  },
  orderTypes: {
    dine_in: "Zalda",
    takeaway: "Olib ketish",
    delivery: "Yetkazib berish",
    self_service: "O'z-o'ziga xizmat",
    pickup: "O'zi olib ketadi",
  },
  expenseCategories: {
    rent: "Ijara",
    salary: "Ish haqi",
    utilities: "Kommunal",
    repair: "Ta'mirlash",
    marketing: "Reklama",
    transport: "Transport",
    household: "Xo'jalik mollari",
    taxes: "Soliqlar",
    other: "Boshqa",
  },
  writeoffReasons: {
    spoilage: "Buzilgan",
    expired: "Muddati o'tgan",
    cooking_error: "Tayyorlashdagi xato",
    breakage: "Singan",
    staff_meal: "Xodimlar ovqati",
    tasting: "Tatib ko'rish",
    internal_use: "Ichki ehtiyoj",
    unknown: "Boshqa",
  },
  insights: {
    depositNote: "Banket depozitlari: keldi {{dep}}, buyurtmalarga hisoblandi {{applied}}.",
    laborCost: "Ish haqi fondi", laborHint: "Ish haqi hisob-kitoblari bo'yicha hisoblangan", laborPct: "Labor cost {{pct}}%", laborReplaced: "Qo'lda kiritilgan «Ish haqi» xarajatlari o'rniga ({{sum}})", salaryPaid: "Ish haqi to'landi", tipPoolNote: "{{n}} kunlik choychaqa pul bilan taqsimlangan — summalar buyurtmalardan emas, taqsimotdan olindi.", profitHint: "Tushum − tannarx − hisobdan chiqarish − xarajatlar − ish haqi",
    methods: { cash: "Naqd", card: "Karta", qr: "QR", credit: "Qarzga", deposit: "Banket depoziti" }, debtNote: "Keldi = tushum − qarzga sotilgan ({{credit}}) + to'langan qarzlar ({{repaid}}).",
    title: "Kafe tahlili",
    description: "Davr bo'yicha tushum, xarajatlar, foyda, taomlar sotuvi, mahsulot sarfi, hisobdan chiqarishlar va ofitsiantlar.",
    period: "Davr",
    presets: {
      today: "Bugun",
      yesterday: "Kecha",
      week: "7 kun",
      month: "Shu oy",
    },
    tabs: {
      abc: "ABC-tahlil",
      matrix: "Menyu matritsasi",
      costs: "Food va labor cost",
      heatmap: "Soatlar bo‘yicha",
      branches: "Filiallar",
      finance: "Moliya",
      items: "Taomlar",
      categories: "Toifalar",
      products: "Mahsulotlar",
      writeoffs: "Hisobdan chiqarish",
      waiters: "Ofitsiantlar",
    },
    byDays: "Kunlar bo'yicha",
    date: "Sana",
    noData: "Davr uchun ma'lumot yo'q",
    noSales: "Davrda sotuv yo'q",
    revenue: "Tushum",
    revenueHint: "Qaytarishlar: {{refunds}} · choychaqa: {{tips}}",
    costOfSales: "Tannarx",
    foodCost: "Food cost {{pct}}%",
    costHint: "Texkarta bo'yicha mahsulotlar",
    expenses: "Xarajatlar",
    expensesHint: "Ijara, ish haqi va boshqalar",
    profit: "Foyda",
    margin: "Marja {{pct}}%",
    grossProfit: "Yalpi foyda",
    grossProfitHint: "Tushum − tannarx",
    purchases: "Xaridlar",
    writeoffs: "Hisobdan chiqarish",
    cashLeft: "Qolgan pul",
    cashLeftHint: "Keldi − xaridlar − xarajatlar",
    noRecipeTitle: "Hamma taomlarda texkarta yo'q",
    noRecipeHint: "Tannarx va mahsulot sarfi hisoblanmadi: {{items}}. Menyuda texkartalarni to'ldiring.",
    whereFrom: "Tushum qayerdan",
    whereFromHint: "Menyu toifalari bo'yicha (pozitsiyalar summasi)",
    noCategory: "Toifasiz",
    whereTo: "Pul qayerga ketdi",
    whereToHint: "Xarajatlar, xaridlar va hisobdan chiqarishlar",
    noExpenses: "Davrda xarajat yo'q",
    byOrderType: "Buyurtma turi bo'yicha",
    ordersN: "buyurtmalar: {{n}}",
    byMethod: "To'lov usuli bo'yicha",
    moneyFlow: "Pul harakati",
    moneyFlowHint: "Qancha keldi, qancha ketdi va qancha qoldi",
    cameIn: "Keldi",
    purchasesPaid: "Xaridlar uchun to‘landi",
    supplierCreditNote: "Yetkazib beruvchilardan qarzga xaridlar: {{amount}} — to‘langanda puldan chiqadi",
    profitByDay: "Kunlar bo'yicha foyda",
    categoriesQty: "Toifalar bo'yicha sotildi",
    categoriesHint: "Har bir toifada nechta sotildi; kunlar bo'yicha ko'rish uchun qatorni bosing",
    pcs: "dona",
    category: "Toifa",
    sold: "Sotildi",
    perDay: "Kuniga o'rtacha",
    itemsTitle: "Taomlar bo'yicha sotuv",
    itemsHint: "Kunlar bo'yicha sotuvni ko'rish uchun taomni bosing",
    searchItem: "Taom yoki toifani qidirish",
    purchased: "Xarid qilindi",
    usedCost: "Sarflangan summa",
    usedHint: "Sotilgan taomlar texkartasi bo'yicha",
    writtenOff: "Hisobdan chiqarildi",
    topUsed: "Eng ko'p sarflanadi",
    topUsedHint: "Sarflangan narxi bo'yicha",
    noUsage: "Davrda mahsulot harakati yo'q",
    productsTitle: "Mahsulotlar",
    searchProduct: "Mahsulotni qidirish",
    product: "Mahsulot",
    used: "Sarflandi",
    noWriteoffs: "Davrda hisobdan chiqarish yo'q",
    documents: "Hujjatlar",
    byReason: "Sabablar bo'yicha",
    docsN: "{{n}} hujjat",
    byProduct: "Mahsulotlar bo'yicha",
    reasons: "Sabablar",
    noWaiter: "Ofitsiantsiz",
    waitersRevenue: "Ofitsiantlar bo'yicha tushum",
    waiter: "Ofitsiant",
    guests: "Mehmonlar",
    itemsSold: "Pozitsiyalar",
    serviceTime: "Xizmat vaqti",
    minutes: "{{n}} daq",
    cancels: "Bekor qilish / o'chirish",
    pro: {
      locked: "«Hisobotlar (kengaytirilgan)» qo‘shimchasi bilan mavjud",
      lockedHint: "ABC-tahlil, menyu matritsasi, food cost va labor cost, soatlar bo‘yicha savdo va filiallarni solishtirish — nima daromad keltiradi, nimani olib tashlash yoki qimmatlashtirish kerak.",
      export: "CSV yuklab olish",
      abcBy: "Ko‘rsatkich",
      abcByOptions: {
        revenue: "Taomlar tushum bo‘yicha",
        margin: "Taomlar marja bo‘yicha",
        qty: "Taomlar soni bo‘yicha",
        products: "Mahsulotlar sarf bo‘yicha",
        customers: "Mijozlar summa bo‘yicha",
      },
      abcClass: "{{c}} sinf",
      abcClassHint: "{{count}} poz. · {{value}}",
      pareto: "Pareto: yuqori 20%",
      paretoHint: "{{count}} eng yaxshi pozitsiya ulushi",
      abcHint: "A — dastlabki 80%, B — keyingi 15%, C — qolgani. C sinfdagilar — almashtirishga nomzodlar.",
      name: "Nomi",
      value: "Ko‘rsatkich",
      share: "Ulush",
      cumulative: "Yig‘ma",
      class: "Sinf",
      noRecipe: "texkarta yo‘q",
      matrixHint: "Mashhur — savdodagi ulushi {{pop}} dan; foydali — porsiya marjasi {{margin}} dan. Tannarx — texkartalar bo‘yicha.",
      matrixNoRecipes: "Texkartalarni to‘ldiring — ularsiz marjani hisoblab bo‘lmaydi.",
      quad: {
        star: "Yulduzlar",
        plowhorse: "Ishchi otlar",
        puzzle: "Jumboqlar",
        dog: "Itlar",
      },
      quadHint: {
        star: "Mashhur va foydali — sifat va menyudagi o‘rnini saqlang.",
        plowhorse: "Yaxshi sotiladi, lekin foyda kam — narxni oshiring yoki tannarxni kamaytiring.",
        puzzle: "Foydali, lekin kam sotiladi — targ‘ib qiling: rasm, menyudagi o‘rin, ofitsiant tavsiyasi.",
        dog: "Kam sotiladi va foyda kam — almashtirishga nomzodlar.",
      },
      matrixRow: "{{qty}} dona · marja {{margin}} · fc {{fc}}",
      withoutRecipe: "Texkartasiz — matritsada yo‘q",
      foodCost: "Food cost",
      laborCost: "Labor cost",
      primeCost: "Prime cost",
      primeCostHint: "Tannarx + ish haqi",
      perLaborHour: "Mehnat soatiga tushum",
      laborHours: "Ish smenalari bo‘yicha {{hours}} soat",
      foodCostByDays: "Kunlar bo‘yicha food cost",
      byCategory: "Toifalar bo‘yicha",
      revenue: "Tushum",
      hours: "Soat",
      branchesTitle: "Filiallarni solishtirish",
      branchesTotal: "Jami: {{revenue}}, buyurtmalar {{orders}}, foyda {{profit}}",
      orders: "Buyurtmalar",
      avgCheck: "O‘rtacha chek",
      profit: "Foyda",
      heatmapTitle: "Hafta kunlari va soatlar bo‘yicha tushum",
      heatmapHint: "Qanchalik to‘q — tushum shuncha ko‘p. Vaqt — muassasa mahalliy vaqti.",
      ordersN: "buyurtmalar: {{count}}",
      less: "kam",
      more: "ko‘p",
      heatmapDays: "{{from}} — {{to}}",
      weekdays: {
        "1": "Du",
        "2": "Se",
        "3": "Ch",
        "4": "Pa",
        "5": "Ju",
        "6": "Sh",
        "7": "Ya",
      },
    },
  },
  expenses: {
    title: "Xarajatlar",
    description: "Ijara, ish haqi, kommunal va boshqa xarajatlar. Mahsulot xaridi — «Xaridlar» bo'limida.",
    add: "Xarajat qo'shish",
    editTitle: "Xarajatni o'zgartirish",
    saved: "Xarajat saqlandi",
    category: "Toifa",
    date: "Sana",
    amount: "Summa",
    comment: "Izoh",
    commentPlaceholder: "Masalan: oktabr ijarasi",
    deleteTitle: "«{{name}}» xarajatini ({{sum}}) o'chirasizmi?",
    allCategories: "Barcha toifalar",
    total: "Jami",
    empty: "Hozircha xarajat yo'q",
    emptyHint: "Xarajatlarni qo'shing — ular moliyaviy hisobot va foydaga tushadi.",
  },
  inventory: {
    stockTitle: "Ombordagi qoldiqlar",
    stockDescription: "Filial omborida qancha mahsulot bor va qancha summaga. Sotuvlar mahsulotlarni texkartalar bo'yicha avtomatik hisobdan chiqaradi.",
    search: "Mahsulot, artikul yoki shtrixkod",
    onlyLow: "Faqat «kam» va «minusda»",
    showAll: "Harakatsiz mahsulotlar bilan",
    quantity: "Qoldiq",
    minStock: "Minimum",
    value: "Qiymati",
    totalValue: "Qoldiqlar qiymati",
    state: "Holati",
    states: {
      ok: "Yetarli",
      low: "Kam",
      negative: "Minusda",
    },
    empty: "Hozircha qoldiqlar yo'q",
    emptyHint: "Xarid yoki inventarizatsiya o'tkazing — qoldiqlar shu yerda paydo bo'ladi.",
    card: "Harakat kartasi",
    opening: "Boshida",
    closing: "Oxirida",
    incoming: "Kirim",
    outgoing: "Chiqim",
    balance: "Keyingi qoldiq",
    operation: "Operatsiya",
    when: "Qachon",
    order: "buyurtma №{{n}}",
    noMovements: "Davr ichida harakat yo'q",
    moveTypes: {
      "disassembly": "Bo‘laklash",
      "assembly": "Yig‘ish",
      "return_to_supplier": "Yetkazib beruvchiga qaytarish",
      "transfer_out": "Ko‘chirish (chiqim)",
      "transfer_in": "Ko‘chirish (kirim)",
      "production": "Ishlab chiqarish",
      receipt: "Xarid",
      writeoff: "Hisobdan chiqarish",
      consumption: "Sotuv",
      inventory_adjustment: "Inventarizatsiya",
      reversal: "Storno",
      cost_adjustment: "Narx tuzatmasi",
    },
    countsTitle: "Inventarizatsiya",
    countsDescription: "Mahsulotlarni qayta sanash. Sanash vaqtidagi sotuvlar hisobga olinadi, farq akt bilan o'tkaziladi.",
    newCount: "Inventarizatsiyani boshlash",
    newCountHint: "Tizimdagi qoldiq boshlanish paytida qayd etiladi, sotuvni to'xtatmasa bo'ladi.",
    start: "Boshlash",
    scope: "Nimani sanaymiz",
    scopes: {
      "location": "Saqlash joyi",
      all: "Barcha mahsulotlar",
      category: "Kategoriya",
      products: "Tanlangan mahsulotlar",
    },
    pickProducts: "Mahsulotlarni tanlang",
    blind: "Ko'r",
    blindHint: "Sanovchi tizimdagi qoldiqni ko'rmaydi",
    blindNote: "Ko'r inventarizatsiya: tizimdagi qoldiq va farq yashirilgan.",
    started: "№{{n}} inventarizatsiya boshlandi",
    countTitle: "№{{n}} inventarizatsiya",
    number: "Raqam",
    status: "Holat",
    statuses: {
      counting: "Sanalmoqda",
      posted: "O'tkazildi",
      cancelled: "Bekor qilindi",
    },
    counted: "Sanaldi",
    countedOf: "{{total}} tadan {{n}} tasi sanaldi",
    system: "Tizim bo'yicha",
    fact: "Fakt",
    diff: "Farq",
    shortage: "Kamomad",
    surplus: "Ortiqcha",
    result: "Natija",
    onlyDiff: "Faqat farqlar",
    notCounted: "sanalmagan",
    noDiff: "Farq yo'q",
    saveCounts: "Sanoqni saqlash",
    savedCounts: "Sanoq saqlandi",
    post: "O'tkazish",
    postTitle: "№{{n}} inventarizatsiyani o'tkazasizmi?",
    postHint: "Sanalmagan qatorlar o'zgarmaydi. Kamomad partiyalar bo'yicha hisobdan chiqariladi, ortiqcha oxirgi xarid narxida kirim qilinadi.",
    posted: "Inventarizatsiya o'tkazildi",
    cancel: "Bekor qilish",
    cancelTitle: "№{{n}} inventarizatsiyani bekor qilasizmi?",
    cancelHint: "Qoldiqlar o'zgarmaydi.",
    cancelled: "Inventarizatsiya bekor qilindi",
    emptyCounts: "Hali inventarizatsiya bo'lmagan",
    emptyCountsHint: "Birinchisini boshlang — u ombordagi boshlang'ich qoldiqlarni ham belgilaydi.",
  },
  stockDocs: {
    backToList: "Xaridlarga",
    receiptPageDescription: "Nima, qancha va necha puldan sotib olindi. Qabul qilishdagi yoʻqotish (suyak, tozalash, eritish) omborga kirimni kamaytiradi — birlik narxi sof vazndan hisoblanadi.",
    newProduct: "Yangi mahsulot",
    createProduct: "«{{name}}» mahsulotini qoʻshish",
    loss: "Yoʻqotish",
    lossMode: "Yoʻqotish foiz yoki miqdorda",
    lossQty: "Yoʻqotish",
    toStock: "Omborga",
    wasPrice: "avval {{price}}",
    "expiresAt": "Yaroqli",
    "expiresHint": "bo‘sh — mahsulotning saqlash muddati bo‘yicha",
    receiptsTitle: "Xaridlar",
    writeoffsTitle: "Hisobdan chiqarish",
    receiptsDescription: "Nima va qanchadan sotib olindi. Xarid mahsulot narxini yangilaydi — taom tannarxi shundan hisoblanadi.",
    writeoffsDescription: "Buzilgan, muddati o'tgan va boshqa sabab bilan hisobdan chiqarilgan mahsulotlar.",
    newReceipt: "Yangi xarid",
    newWriteoff: "Yangi hisobdan chiqarish",
    post: "O'tkazish",
    saved: "Hujjat o'tkazildi",
    supplier: "Yetkazib beruvchi",
    supplierPlaceholder: "Yetkazib beruvchini tanlang yoki qo‘shing",
    dueTitle: "To‘lov muddatini ko‘chirish",
    returnEmpty: "Qancha qaytarishni ko‘rsating",
    returnFromReceipt: "Xarid bo‘yicha yetkazib beruvchiga qaytarish",
    returnReason: "Sabab: brak, noto‘g‘ri tovar…",
    returnable: "{{bought}} dan {{qty}} qaytarish mumkin",
    returnSum: "Qaytarish summasi (xarid narxlarida)",
    returnHint: "Tovar shu xarid partiyasidan ombordan chiqadi, yetkazib beruvchiga qarz qaytarish summasiga kamayadi; xarid to‘langan bo‘lsa — summa avansga aylanadi.",
    returnToSupplier: "Yetkazib beruvchiga qaytarish",
    byReceipt: "xarid bo‘yicha",
    toPay: "To‘lash kerak",
    price: "Narx",
    returned: "Qaytarilgan",
    settlements: "To‘lovlar va hisob-kitoblar",
    returnsTitle: "Xarid bo‘yicha qaytarishlar",
    returnsPageTitle: "Yetkazib beruvchilarga qaytarish",
    returnsPageDescription: "Yetkazib beruvchilarga qaytarilgan tovar: ombordan xarid narxlarida, summa qarzni kamaytiradi yoki avansga aylanadi",
    searchReturn: "Yetkazib beruvchi, mahsulot yoki izoh",
    emptyReturns: "Yetkazib beruvchilarga qaytarishlar yo‘q",
    allSuppliers: "Barcha yetkazib beruvchilar",
    newReturn: "Yetkazib beruvchiga qaytarish",
    return: "Yetkazib beruvchiga qaytarish",
    createSupplier: "«{{name}}» yetkazib beruvchisini qo‘shish",
    payment: "To‘lov",
    onCredit: "Qarzga",
    mixedUnpaid: "Xarid o‘tkazildi, lekin to‘liq to‘lanmadi — yetkazib beruvchi kartasidan qolganini to‘lang.",
    dueDate: "To‘lash muddati",
    dueHint: "Yetkazib beruvchi kechiktirishi: {{n}} kun",
    paymentAll: "Barcha xaridlar",
    paymentUnpaid: "To‘lanmagan",
    reason: "Sabab",
    addLine: "Mahsulot qo'shish",
    byLastPrice: "oxirgi xarid narxi bo'yicha",
    byFifo: "o'tkazishda partiyalar bo'yicha (FIFO)",
    receipt: "Xarid",
    writeoff: "Hisobdan chiqarish",
    products: "Mahsulotlar",
    open: "Ochish",
    deleteTitle: "{{date}} sanadagi {{sum}} hujjatni o'chirasizmi?",
    deleteHint: "Qoldiqlar o'tkazishdan oldingi holatga qaytadi, hujjat hisobotlardan chiqadi. Mahsulot narxi qaytarilmaydi.",
    searchReceipt: "Yetkazib beruvchi, mahsulot, izoh",
    searchWriteoff: "Mahsulot, izoh",
    emptyReceipts: "Davrda xarid yo'q",
    emptyWriteoffs: "Davrda hisobdan chiqarish yo'q",
    emptyHint: "Hujjatlar mahsulot va moliya tahliliga tushadi.",
  },
  cash: {
    title: "Kassa smenalari",
    description: "Veb-kassa smenasi: maydalik, kiritish va olish, X-hisobot va Z-hisobot bilan yopish. Filialdagi barcha kassalar smenalari arxivi.",
    webRegister: "Veb-kassa",
    register: "Kassa",
    shift: "Smena",
    open: "Smenani ochish",
    openHint: "Maydalikni kiriting — smena boshidagi kassadagi naqd pul.",
    opened: "Smena ochildi",
    close: "Smenani yopish",
    closeHint: "Kassadagi naqd pulni sanang. Yopilgandan keyin Z-hisobotni o‘zgartirib bo‘lmaydi.",
    closeAndPrint: "Yopish va Z chop etish",
    closed: "Smena yopildi",
    noShift: "Smena ochilmagan",
    noShiftHint: "Veb-kassada to‘lov qabul qilish uchun smenani oching.",
    statusOpen: "Ochiq",
    statusClosed: "Yopiq",
    status: "Holati",
    openedAt: "Ochildi",
    closedAt: "Yopildi",
    cashier: "Kassir",
    float: "Maydalik",
    expected: "Kutilgan naqd",
    counted: "Haqiqatda",
    difference: "Farq",
    diffComment: "Farqqa izoh",
    diffCommentRequired: "Farq sababini yozing",
    sales: "Sotuvlar",
    refunds: "Qaytarishlar",
    net: "Tushum",
    checks: "Cheklar",
    avgCheck: "O‘rtacha chek",
    tips: "Choychaqa",
    cancelled: "Bekor qilingan buyurtmalar",
    debtRepaymentsCash: "Qarzlarni naqd to‘lash",
    operation: "Kiritish / olish",
    operationType: "Operatsiya",
    operationDone: "Operatsiya bajarildi",
    operations: "Operatsiyalar",
    amount: "Summa",
    reason: "Sababi",
    xReport: "X-hisobot",
    zReport: "Z-hisobot",
    printX: "X-hisobotni chop etish",
    printZ: "Z-hisobotni chop etish",
    archive: "Smenalar arxivi",
    archiveEmpty: "Hali smenalar bo‘lmagan",
    ops: {
      banquet_deposit: "Banket depoziti",
      banquet_refund: "Banket depozitini qaytarish",
      salary_payout: "Ish haqini to‘lash",
      supplier_payment: "Yetkazib beruvchiga to‘lov",
      supplier_refund: "Yetkazib beruvchidan pul qaytarish",
      cash_in: "Kiritish",
      cash_out: "Olish",
      collection: "Inkassatsiya",
      expense: "Kassadan xarajat",
      tip_payout: "Choychaqa to‘lash",
      debt_repayment: "Qarzni to‘lash",
      correction_in: "Tuzatish +",
      correction_out: "Tuzatish −",
    },
  },
  suppliers: {
    avgShort: "o‘rtacha {{price}}",
    payAdvance: "Avans to‘lash",
    refund: "Pulni qaytarish",
    refunded: "Pul qaytarish o‘tkazildi",
    refundTitle: "Yetkazib beruvchi pul qaytaradi: {{name}}",
    refundShort: "Yetkazib beruvchidan pul qaytarish",
    refundCashHint: "Naqd pul ochiq kassa smenasiga tushadi",
    voidRefundTitle: "{{amount}} pul qaytarishni bekor qilasizmi?",
    voidRefundHint: "Yetkazib beruvchidagi avans tiklanadi. Smena ochiq bo‘lsa, naqd pul kassadan olinadi.",
    products: "Tovarlar",
    noProducts: "Bu yetkazib beruvchidan hali xarid bo‘lmagan",
    bought: "Xarid qilingan",
    returnedQty: "qaytarilgan {{qty}}",
    lastPrice: "Oxirgi narx",
    avgPrice: "O‘rtacha narx",
    refundMethods: {
      cash: "Kassaga naqd",
      bank: "Hisobga",
    },
    advance: "Avans",
    advanceHint: "Qarzdan ko‘proq to‘lash mumkin — qoldig‘i keyingi xaridlarga hisoblanadi",
    advanceAlert: "Yetkazib beruvchidagi avans: {{amount}} — keyingi xaridga hisoblanadi",
    advanceLeft: "Avans: {{amount}}",
    advancesNote: "Yetkazib beruvchilarga avanslar: {{amount}} — keyingi xaridlarga hisoblanadi",
    statement: {
      open: "Solishtirish dalolatnomasi",
      title: "O‘zaro hisob-kitoblarni solishtirish dalolatnomasi",
      print: "Chop etish",
      period: "{{from}} dan {{to}} gacha",
      date: "Sana",
      operation: "Operatsiya",
      increase: "Xaridlar, pul qaytarish",
      decrease: "To‘lovlar, tovar qaytarish",
      balance: "Saldo",
      opening: "Boshlang‘ich saldo",
      closing: "Yakuniy saldo",
      turnover: "Davr aylanmasi",
      empty: "Davrda operatsiyalar yo‘q",
      weOwe: "Yetkazib beruvchi foydasiga qarz: {{amount}}",
      theyOwe: "Xaridor foydasiga qarz (ortiqcha to‘lov): {{amount}}",
      settled: "Qarz yo‘q",
      kinds: {
        receipt: "Xarid",
        return: "Yetkazib beruvchiga qaytarish",
        payment: "To‘lov",
        refund: "Yetkazib beruvchidan pul qaytarish",
      },
    },
    title: "Yetkazib beruvchilar",
    description: "Yetkazib beruvchilar ro‘yxati, qarzga xaridlar va ularga to‘lovlar",
    add: "Yetkazib beruvchi qo‘shish",
    all: "Barcha yetkazib beruvchilar",
    payablesTab: "Qancha qarzmiz",
    search: "Nomi, STIR, telefon",
    empty: "Hozircha yetkazib beruvchilar yo‘q",
    emptyHint: "Yetkazib beruvchini qo‘shing yoki xaridda tanlang — qarz o‘zi hisoblanadi",
    name: "Nomi",
    contactPerson: "Aloqa shaxsi",
    phone: "Telefon",
    email: "Email",
    terms: "To‘lovni kechiktirish",
    termsHint: "Xarid sanasidan to‘lov muddatigacha kunlar; 0 — darhol",
    taxId: "STIR",
    legalName: "Yuridik nomi",
    address: "Manzil",
    notes: "Izohlar",
    active: "Faol",
    activeHint: "Faol bo‘lmagan yetkazib beruvchini yangi xaridda tanlab bo‘lmaydi",
    inactive: "Faol emas",
    info: "Rekvizitlar",
    lastPurchase: "Oxirgi xarid",
    nextDue: "Eng yaqin muddat",
    weOweShort: "Bizning qarz",
    weOwe: "Bizning qarz: {{amount}}",
    overdue: "Muddati o‘tgan",
    dueSoon: "7 kunda to‘lanadi",
    purchased: "Jami xarid qilingan",
    paidTotal: "Jami to‘langan",
    noTerms: "Darhol",
    overdueAlert: "Yetkazib beruvchiga to‘lov muddati o‘tgan: {{amount}}",
    documents: "Xaridlar",
    noDocuments: "Hozircha xaridlar yo‘q",
    noDocumentsHint: "Xaridni o‘tkazing va shu yetkazib beruvchini tanlang",
    payments: "To‘lovlar",
    noPayments: "Hozircha to‘lovlar yo‘q",
    voided: "Bekor qilingan",
    pay: "To‘lash",
    paid: "To‘lov o‘tkazildi",
    payTitle: "Yetkazib beruvchiga to‘lov: {{name}}",
    payDoc: "{{date}} xaridi, to‘lanadi {{amount}}",
    method: "To‘lov usuli",
    methods: {
      cash: "Kassadan naqd",
      bank: "O‘tkazma orqali",
      return: "Tovarni qaytarish",
    },
    reference: "To‘lov topshirig‘i raqami",
    cashHint: "Naqd pul ochiq kassa smenasidan beriladi va kassadagi summani kamaytiradi",
    fifoHint: "Summa eng eski to‘lanmagan xaridlarni yopadi",
    void: "To‘lovni bekor qilish",
    voidTitle: "{{amount}} to‘lovini bekor qilasizmi?",
    voidHint: "Yetkazib beruvchiga qarz qaytadi. Smena ochiq bo‘lsa, naqd pul kassaga qaytadi.",
    deleteTitle: "«{{name}}» yetkazib beruvchisini o‘chirasizmi?",
    deleteHint: "Xaridlar tarixda qoladi. Qarzi bor yetkazib beruvchini o‘chirib bo‘lmaydi.",
    statuses: {
      paid: "To‘langan",
      partially_paid: "Qisman to‘langan",
      unpaid: "To‘lanmagan",
      overdue: "Muddati o‘tgan",
    },
    segments: {
      all: "Hammasi",
      debt: "Qarzi bor",
      overdue: "To‘lov muddati o‘tgan",
      inactive: "Faol emas",
    },
    aging: {
      d1_30: "1–30 kun kechikkan",
      d31_60: "31–60 kun kechikkan",
      d60: "> 60 kun kechikkan",
    },
    creditors: "Kimga qarzmiz",
    noCreditors: "Yetkazib beruvchilarga qarz yo‘q",
    unpaidDocs: "To‘lanmagan xaridlar",
  },
  customers: {
    title: "Mijozlar",
    description: "Mehmonlar bazasi: buyurtmalar tarixi, sevimli taomlar, chegirmalar va qarzlar. Barcha filiallar uchun umumiy.",
    add: "Yangi mijoz",
    search: "Telefon (oxirgi raqamlar) yoki ism",
    empty: "Hozircha mijozlar yo‘q",
    emptyHint: "Mehmonlarni kassada yoki shu yerda qo‘shing",
    name: "Mijoz",
    firstName: "Ism",
    lastName: "Familiya",
    phone: "Telefon",
    email: "Email",
    birthDate: "Tug‘ilgan sana",
    discount: "Shaxsiy chegirma",
    notes: "Izohlar",
    consent: "Xabarnomalarga rozilik",
    consentHint: "Marketing xabarlari faqat rozilik bilan (sana saqlanadi)",
    creditAllowed: "Qarzga sotishga ruxsat",
    creditHint: "Kassa limit doirasida mijoz buyurtmalarini qarzga to‘lay oladi",
    creditLimit: "Kredit limiti",
    creditBadge: "{{limit}} gacha kredit",
    blocked: "Bloklangan",
    blockedHint: "Yangi kredit va onlayn buyurtmalarsiz",
    orders: "Buyurtmalar",
    ordersN: "buyurtmalar: {{n}}",
    spent: "Xaridlar summasi",
    avgCheck: "O‘rtacha chek",
    lastVisit: "Oxirgi tashrif",
    visitEvery: "Keladi har",
    days: "{{n}} kun",
    debt: "Qarz",
    debtShort: "qarz {{amount}}",
    overdueAlert: "Muddati o‘tgan: {{amount}} — yangi kredit mavjud emas",
    favorites: "Sevimli taomlar",
    history: "Buyurtmalar",
    noOrders: "Buyurtmalar yo‘q",
    anonymize: "Shaxsiy maʼlumotlarni o‘chirish",
    anonymizeTitle: "Mijozning shaxsiy maʼlumotlarini o‘chirasizmi?",
    anonymizeHint: "Ism, telefon, email va izohlar o‘chiriladi. Buyurtmalar va qarz qoladi. Qaytarib bo‘lmaydi.",
    anonymized: "Maʼlumotlar o‘chirildi",
    pick: "Buyurtma mijozi",
    quickAdd: "Yangi mijoz",
    createAndPick: "Yaratish va tanlash",
    segments: {
      all: "Barcha mijozlar",
      debtors: "Qarzdorlar",
      overdue: "Muddati o‘tgan",
      inactive: "Uzoq vaqt kelmaganlar",
      vip: "Xaridlar summasi bo‘yicha",
      blocked: "Bloklanganlar",
      birthday: "Shu haftada tug‘ilgan kuni",
    },
  },
  debts: {
    owedToUs: "Bizga qarz",
    weOwe: "Biz yetkazib beruvchilarga qarzmiz",
    title: "Qarzlar",
    description: "Qarzdorlar, muddati o‘tgan qarzlar va qarzlar yoshi. To‘lash — mijoz kartochkasida.",
    total: "Jami qarz",
    overdue: "Muddati o‘tgan",
    debtors: "Qarzdorlar",
    noDebtors: "Qarzdorlar yo‘q",
    oldest: "Eng eski qarz",
    aging: {
      d0_7: "7 kungacha",
      d8_30: "8–30 kun",
      d31_60: "31–60 kun",
      d60: "60 kundan ortiq",
    },
    ledger: "Qarz jurnali",
    noEntries: "Qarzlar bo‘lmagan",
    repay: "To‘lash",
    repayTitle: "Qarzni to‘lash: {{name}}",
    repaid: "Qarz to‘landi",
    balance: "Joriy qarz: {{amount}}",
    amount: "Summa",
    comment: "Izoh",
    reason: "Sababi",
    cashHint: "Naqd pul veb-kassaning ochiq smenasiga tushadi.",
    adjustTitle: "Qarzni tuzatish",
    increase: "Hisoblash",
    decrease: "Kamaytirish",
    dueDate: "To‘lov muddati",
    due: "{{date}} gacha",
    remaining: "{{amount}} qoldi",
    writeOff: "Hisobdan chiqarish",
    writeOffTitle: "{{amount}} qarzni hisobdan chiqarasizmi?",
    writeOffHint: "Umidsiz qarz to‘liq hisobdan chiqariladi. Harakat auditga yoziladi.",
    writeOffComment: "Umidsiz qarz",
    writtenOff: "Qarz hisobdan chiqarildi",
    kinds: {
      charge: "Hisoblash",
      repayment: "To‘lash",
      adjustment: "Tuzatish",
      write_off: "Hisobdan chiqarish",
    },
    statuses: {
      open: "Ochiq",
      partially_paid: "Qisman to‘langan",
      paid: "To‘langan",
      overdue: "Muddati o‘tgan",
      written_off: "Hisobdan chiqarilgan",
    },
  },
  staff: {
    employeesTitle: "Kadrlar",
    employeesDescription: "Filial xodimlari: lavozim, ishga qabul sanasi, to‘lov sxemasi, hozir kim smenada. Bo‘shatish kirishni bloklaydi, maʼlumotlar saqlanadi.",
    employee: "Xodim",
    position: "Lavozim",
    noPosition: "Lavozimsiz",
    hiredAt: "Ishga qabul sanasi",
    payScheme: "To‘lov",
    own: "o‘ziniki",
    ownScheme: "Shaxsiy to‘lov sxemasi",
    ownSchemeHint: "Aks holda — lavozim sxemasi bo‘yicha",
    employmentHint: "Lavozim, ishga qabul va to‘lov sxemasi. Stavkalar o‘zgarishi auditga yoziladi.",
    status: "Holati",
    offShift: "Smenada emas",
    onShiftSince: "{{time}} dan beri smenada",
    dismissedAt: "{{date}} bo‘shatilgan",
    noEmployees: "Xodimlar yo‘q",
    dismiss: "Bo‘shatish",
    dismissTitle: "{{name}} ni bo‘shatasizmi?",
    dismissHint: "Kirish va PIN bloklanadi, ochiq smena yopiladi. Maʼlumotlar va hisob-kitoblar saqlanadi.",
    dismissDate: "Bo‘shatish sanasi",
    dismissReason: "Sababi",
    dismissed: "Xodim bo‘shatildi",
    restore: "Tiklash",
    restoreTitle: "{{name}} ni tiklaysizmi?",
    positionsTitle: "Lavozimlar",
    positionsDescription: "Lavozimlar va ularning xodimlari uchun standart to‘lov sxemasi.",
    addPosition: "Yangi lavozim",
    deletePosition: "«{{name}}» lavozimini o‘chirasizmi?",
    noPositions: "Hozircha lavozimlar yo‘q",
    defaultScheme: "Standart to‘lov sxemasi",
    scheme: {
      hourlyRate: "Soatlik stavka",
      shiftRate: "Smena stavkasi",
      monthlySalary: "Oylik maosh",
      salesPercent: "Shaxsiy sotuvdan %",
      tierFrom: "Yuqori % summadan",
      tierHint: "Pog‘ona: summadan oshgan sotuv qismi",
      tierPercent: "Yuqori %",
      nightCoef: "Tungi koeffitsiyent",
      nightHint: "1,5 — tungi soatlar +50% (22:00–06:00)",
      tipsViaPayroll: "Choychaqani ish haqi bilan to‘lash",
      perHour: "{{v}}/soat",
      perShift: "{{v}}/smena",
      perMonth: "{{v}}/oy",
      ofSales: "sotuvdan {{v}}%",
    },
  },
  shifts: {
    title: "Ish smenalari",
    description: "Xodimlarning kelishi va ketishi: terminalda PIN bilan, kabinetdan yoki qo‘lda. Sababli tuzatishlar, tabelni tasdiqlash.",
    add: "Qo‘lda smena",
    onShift: "Hozir smenada: {{n}}",
    nobody: "Smenada hech kim yo‘q",
    list: "Smenalar",
    timesheet: "Tabel",
    date: "Sana",
    time: "Vaqt",
    worked: "Ishlangan",
    night: "Tungi",
    total: "Jami",
    shiftsCount: "Smenalar",
    unapproved: "tasdiqlanmagan: {{n}}",
    empty: "Davr ichida smena yo‘q",
    select: "Smenani tanlash",
    approveAll: "Hammasini tasdiqlash ({{n}})",
    approveSelected: "Tanlanganlarni tasdiqlash ({{n}})",
    approvedN: "Tasdiqlangan smenalar: {{n}}",
    clockIn: "Boshlanishi",
    clockOut: "Tugashi",
    breakMinutes: "Tanaffus, daq",
    reason: "Sababi",
    correctTitle: "Tuzatish: {{name}}",
    correctHint: "Asl vaqt saqlanadi, o‘zgarish auditga yoziladi.",
    original: "Edi: {{in}} — {{out}}",
    statuses: {
      open: "Smenada",
      closed: "Yopilgan",
      auto_closed: "Avtomatik yopilgan",
      corrected: "Tuzatilgan",
      approved: "Tasdiqlangan",
    },
  },
  payroll: {
    title: "Ish haqi",
    description: "Davr bo‘yicha to‘lov sxemalari asosida hisoblash, tekshirish, tasdiqlash va to‘lash. Tasdiqlangan vedomost o‘zgarmaydi — tuzatishlar keyingi davrda.",
    calculate: "Hisoblash",
    runs: "Hisob-kitoblar",
    noRuns: "Hali hisob-kitoblar bo‘lmagan",
    period: "Davr",
    version: "Versiya",
    employees: "Xodimlar",
    gross: "Hisoblangan",
    net: "To‘lashga",
    calculatedAt: "Hisoblangan",
    sheetTitle: "Vedomost {{from}} — {{to}} (v{{v}})",
    approve: "Tasdiqlash",
    approved: "Vedomost tasdiqlandi",
    immutableHint: "Vedomost tasdiqlangan va o‘zgarmaydi. Tuzatishlar — keyingi davrda bonus yoki ushlab qolish sifatida.",
    payCash: "Kassadan {{amount}} to‘lash",
    payBank: "Bank orqali to‘lash",
    payOne: "{{amount}} to‘lash",
    paid: "To‘lov amalga oshirildi",
    noLines: "Hisoblashlar yo‘q — to‘lov sxemalari va smenalarni tekshiring",
    employeeTotals: "Hisoblangan {{gross}} · to‘lashga {{net}} · to‘langan {{paid}}",
    adjustments: "Bonuslar va ushlab qolishlar",
    noAdjustments: "Bonuslar va ushlab qolishlar yo‘q",
    addAdjustment: "Bonus yoki ushlab qolish",
    adjustmentHint: "Sana bo‘yicha davr hisobiga kiradi. Sababi majburiy.",
    type: "Turi",
    amount: "Summa",
    date: "Sana",
    reason: "Sababi",
    statuses: {
      calculated: "Hisoblangan",
      approved: "Tasdiqlangan",
      paid: "To‘langan",
      superseded: "Qayta hisoblash bilan almashtirilgan",
    },
    components: {
      hourly: "Soatbay",
      night: "Tungi soatlar",
      fixed_shift: "Smenalar uchun",
      fixed_monthly: "Oylik maosh",
      personal_sales_percent: "Sotuvdan %",
      tips: "Choychaqa",
      bonus: "Bonus",
      penalty: "Jarima",
      advance: "Avans",
      deduction: "Ushlab qolish",
      carry_over: "Ushlab qolishni o‘tkazish",
      carry_in: "Oldingi davrdan ushlab qolish",
    },
    basis: {
      hourly: "{{h}} soat × {{rate}}",
      night: "{{h}} tungi soat, koef. {{coef}}",
      shifts: "{{n}} smena × {{rate}}",
      monthly: "{{salary}} maoshdan {{days}} kun",
      sales: "{{sales}} sotuvdan {{pct}}%",
    },
  },
  tips: {
    title: "Choychaqa",
    description: "Mehmonlarning choychaqasi — muassasa tushumi emas. Taqsimlash: buyurtma ofitsiantiga, pul bilan teng yoki ishlangan soatlar bo‘yicha; kassadan yoki ish haqi bilan to‘lash.",
    mode: "Taqsimlash",
    modes: {
      individual: "Buyurtma ofitsiantiga",
      pool_equal: "Pul teng",
      pool_hours: "Pul soatlar bo‘yicha",
    },
    modeHints: {
      individual: "Har kim o‘z buyurtmalari choychaqasini oladi; ofitsiantsiz — ishlaganlar orasida teng.",
      pool_equal: "Davrdagi barcha choychaqa davrda ishlaganlar orasida teng.",
      pool_hours: "Davrda ishlangan soatlarga mutanosib.",
    },
    total: "Davr choychaqasi: {{amount}}",
    distribute: "Taqsimlash",
    created: "Choychaqa taqsimlandi",
    empty: "Davr ichida choychaqa yo‘q",
    basis: "Asos",
    hours: "{{h}} soat",
    ownOrders: "O‘z buyurtmalari",
    equalShare: "Teng ulush",
    amount: "Summa",
    pools: "Taqsimlashlar",
    noPools: "Hali taqsimlashlar bo‘lmagan",
    payout: "To‘lash",
    payoutAll: "Hammaga {{amount}} to‘lash",
    paidOut: "Choychaqa to‘landi",
    paidCash: "To‘langan",
    viaPayroll: "Ish haqi bilan",
    statuses: {
      calculated: "Taqsimlangan",
      paid: "To‘langan",
    },
  },
  me: {
    title: "Mening kabinetim",
    description: "Mening smenalarim, sotuvlarim, choychaqalarim va hisob varaqalarim.",
    onShift: "Siz {{since}} dan beri smenadasiz",
    offShift: "Siz smenada emassiz",
    clockIn: "Smenani boshlash",
    clockOut: "Smenani tugatish",
    clockedIn: "Smena boshlandi",
    clockedOut: "Smena tugadi",
    worked: "Ishlangan",
    orders: "Buyurtmalar",
    sales: "Sotuvlar",
    tips: "Choychaqa",
    payslip: "Hisob varaqasi {{from}} — {{to}}",
    payslipTotals: "To‘lashga {{net}} · to‘langan {{paid}}",
    shifts: "Mening smenalarim",
  },
  audit: {
    title: "Audit jurnali",
    description: "Kim, nimani va qachon o‘zgartirdi: narxlar, bekor qilishlar, qaytarishlar, kassa operatsiyalari, qarzlar, smenalar va ish haqi.",
    actionFilter: "Bo‘lim",
    at: "Vaqt",
    action: "Harakat",
    user: "Kim",
    entity: "Obyekt",
    system: "Tizim",
    empty: "Yozuvlar yo‘q",
    before: "Edi",
    after: "Bo‘ldi",
    ...auditUz,
  },
  docs: docsUz,
  billing: {
    pageDescription: "Tarif, limitlar, qo‘shimchalar va hisoblar. Qo‘shimcha to‘lovli o‘zgarishlar hisob to‘langandan keyin kuchga kiradi, tarifni pasaytirish — keyingi davr boshidan.",
    plans: "Tariflar",
    period: "To‘lov davri",
    periods: {
      month: "Oy",
      quarter: "Chorak",
      year: "Yil",
    },
    periodTill: "{{period}}, {{date}} gacha to‘langan",
    current: "Joriy",
    choose: "Tanlash",
    changePeriod: "Davrni o‘zgartirish",
    changeTo: "«{{plan}}» tarifi",
    byContract: "Shartnoma bo‘yicha",
    pay: "To‘lash",
    save: "foyda {{pct}}%",
    planInvoice: {
      term: "To‘lov muddati",
      custom: "Sanagacha",
      customHint: "O‘z tugash sanangiz: oylar — davr narxida, qolgan kunlar — kun bo‘yicha",
      until: "To‘langan sana (shu kun bilan)",
      perMonth: "oyiga {{amount}}",
      saving: "oyiga {{amount}} · foyda {{pct}}% ({{save}})",
      termLine: "Muddat: {{from}} – {{to}}",
      trialHint: "Tarif darhol yoqiladi, to‘langan muddat sinov davridan keyin boshlanadi.",
      paidHint: "Muddat to‘langanidan keyin boshlanadi — {{date}} dan. Tarif hisob to‘langach o‘zgaradi.",
      noPrice: "Tarif narxi yo‘q — Coca qo‘llab-quvvatlash xizmatiga murojaat qiling.",
    },
    planLimits: "Filiallar: {{branches}} · terminallar: {{terminals}} · foydalanuvchilar: {{users}}",
    addons: "Qo‘shimchalar",
    addonsHint: "To‘lovdan keyin darhol ulanadi; o‘chirish — davr oxirida, maʼlumotlar saqlanadi.",
    addon: "Qo‘shimcha",
    price: "Davr narxi",
    included: "Tarifga kiradi",
    active: "Ulangan",
    enable: "Ulash",
    enableAddon: "«{{name}}» ni ulash",
    disable: "O‘chirish",
    addonCancelled: "Qo‘shimcha davr oxirida o‘chadi",
    endsAt: "{{date}} o‘chadi",
    apply: "Qo‘llash",
    issueInvoice: "{{amount}} ga hisob chiqarish",
    toPay: "To‘lashga",
    discount: "Chegirma",
    afterPayment: "O‘zgarish hisob to‘langandan keyin kuchga kiradi.",
    trialFree: "Sinov davrida o‘zgarishlar bepul va darhol kuchga kiradi.",
    term: {
      label: "Muddat",
      subscription: "Obuna bilan",
      custom: "O‘z muddati",
      subscriptionHint: "To‘langan muddat oxirigacha — {{date}} gacha, keyin obuna bilan uzaytiriladi.",
      subscriptionTrialHint: "Birinchi to‘lov davri — {{date}} gacha, keyin obuna bilan uzaytiriladi.",
      from: "Dan",
      to: "Gacha (kiritilgan)",
      months: "{{count}} oy",
      customHint: "Tanlangan kunlar uchun bir marta to‘lanadi va o‘zi uzaytirilmaydi.",
      past: "Bugundan oldin emas",
      order: "Boshlanish sanasidan oldin",
    },
    paidUntil: "{{date}} gacha to‘langan",
    startsAt: "{{date}} dan",
    extend: "Uzaytirish",
    scheduled: "O‘zgarish {{date}} kuchga kiradi — keyingi davr boshidan.",
    scheduledChange: "Keyingi davrdan rejalashtirilgan: tarif {{plan}}, davr {{period}}",
    downgradeBlocked: "Foydalanish yangi tarif limitlaridan oshadi: ortiqcha filiallar, terminallar yoki foydalanuvchilarni o‘chiring.",
    addonsDropped: "Yangi tarifda mavjud boʻlmagan qoʻshimchalar oʻchiriladi: {{names}}. Maʼlumotlar saqlanadi.",
    invoiceIssued: "{{n}} hisobi chiqarildi",
    changeApplied: "O‘zgarish qo‘llandi",
    invoices: "Hisoblar",
    noInvoices: "Hozircha hisoblar yo‘q",
    number: "Raqam",
    issued: "Chiqarilgan",
    due: "To‘lov muddati",
    total: "Summa",
    print: "Chop etish",
    bankTitle: "To‘lov rekvizitlari",
    invoiceStatus: {
      open: "To‘lov kutilmoqda",
      paid: "To‘langan",
      void: "Bekor qilingan",
      refunded: "Qaytarilgan",
      draft: "Qoralama",
    },
    limitNear: "Deyarli tugagan",
    limitReached: "Tugagan",
    banner: {
      trial: "Tugagach, tarifni tanlab, hisobni to‘lang.",
      past_due: "Hisobni {{date}} gacha to‘lang, aks holda kirish faqat o‘qish uchun bo‘ladi.",
      read_only: "Faqat o‘qish: kassadagi sotuvlar ishlaydi, qolgani — to‘lovdan keyin. To‘xtatilishgacha: {{date}}.",
      suspended: "Obuna to‘xtatildi. Kirishni tiklash uchun hisobni to‘lang.",
      expired: "Sinov davri tugadi. Tarifni tanlang.",
      archived: "Obuna arxivda.",
      cancelled: "Obuna bekor qilindi va {{date}} gacha amal qiladi.",
    },
    bannerPastDue: "Obuna to‘lovni kutmoqda — kirishni yo‘qotmaslik uchun hisobni to‘lang.",
    bannerReadOnly: "Faqat o‘qish: kassa sotadi, o‘zgarishlar to‘lovgacha mavjud emas.",
    payNow: "To‘lash",
    choosePlan: "Tarifni tanlash",
    supportReadOnly: "Coca qo‘llab-quvvatlash seansi — faqat ko‘rish",
    supportFull: "Coca qo‘llab-quvvatlash seansi — o‘zgartirish huquqi bilan",
    supportExit: "Seansni yakunlash",
    supportLinkInvalid: "Qo‘llab-quvvatlash seansi havolasi yaroqsiz",
    inviteTitle: "Coca ga xush kelibsiz",
    inviteHint: "ERP ga kirish uchun parol o‘ylab toping.",
    inviteInvalid: "Taklif havolasi yaroqsiz",
    inviteExpired: "Havola eskirdimi? Parolni tiklash orqali o'rnating",
    inviteSubmit: "Parol o‘rnatib kirish",
  },
  onboarding: {
    title: "Muassasani sozlash",
    defaultHall: "Asosiy zal",
    next: "Keyingi",
    back: "Orqaga",
    skip: "O‘tkazib yuborish",
    skipped: "o‘tkazildi",
    todo: "Bajarish",
    optional: "Ixtiyoriy",
    company: {
      title: "Kompaniya",
      hint: "Biznesingiz nomi. Yuridik maʼlumotlarni keyin qo‘shish mumkin.",
      name: "Nomi",
      country: "Mamlakat",
      legalName: "Yuridik nomi",
      taxId: "STIR",
    },
    branch: {
      title: "Muassasa",
      hint: "Format standart buyurtma turlarini belgilaydi — funksiyalarni faqat tarif cheklaydi.",
      format: "Muassasa formati",
      name: "Nuqta nomi",
      phone: "Telefon",
      city: "Shahar",
      address: "Manzil",
    },
    currency: {
      title: "Valyuta va vaqt",
      hint: "Narxlar va cheklar valyutasi, vaqt zonasi va hisobotlar uchun biznes-kun chegarasi.",
      currency: "Valyuta",
      timezone: "Vaqt zonasi",
      cutoff: "Kun chegarasi",
      cutoffHint: "Shu vaqtgacha bo‘lgan sotuvlar oldingi kunga tegishli",
    },
    menu: {
      packsTitle: "To‘liq menyu kerakmi?", packsHint: "«Katalog → Tayyor menyular» bo‘limida shaurmaxona, qahvaxona, muzqaymoq kafesi, milliy oshxona, pitsseriya, sushi-bar va boshqa formatlar uchun to‘plamlar bor: rasm va tavsifli taomlar, mahsulotlar, yarim tayyor mahsulotlar va kalkulyatsiyali texkartalar. Bir marta sotib olinadi.",
      title: "Menyu",
      hint: "Formatingiz bo‘yicha demo-menyuni yuklang — narx va pozitsiyalarni o‘zgartirish yoki o‘chirish mumkin.",
      manual: "Menyuni o‘zim yarataman",
      load: "Yuklash",
      loaded: "Demo-menyu yuklandi",
      has: "Menyuda allaqachon {{n}} ta pozitsiya bor",
      templates: {
        coffee: "Qahva (o‘lchamlar, sut, siroplar), choy, pishiriqlar, desertlar",
        cafe: "Salatlar, sho‘rvalar, issiq taomlar, ichimliklar — oshxona va bar",
        fast_food: "Qo‘shimchali burgerlar, souslar bilan gazaklar, ichimliklar",
      },
    },
    tables: {
      title: "Stollar",
      hint: "Zalning tezkor rejasi: stollar to‘r shaklida joylashadi, har birida menyu uchun QR.",
      hall: "Zal",
      count: "Stollar",
      capacity: "Stoldagi o‘rinlar",
      generate: "Stollarni yaratish",
      created: "Yaratilgan stollar: {{n}}",
      has: "Stollar bor: {{n}}",
    },
    employees: {
      title: "Xodimlar",
      hint: "Kassirlar va ofitsiantlar kassaga PIN bilan kiradi — parol kerak emas.",
      name: "Ism",
      role: "Rol",
      pinHint: "4–6 raqam",
      add: "Xodim qo‘shish",
    },
    cash: {
      title: "Kassa",
      hint: "Veb-kassa smenasini maydalik bilan oching — va sotish mumkin. Terminallar «Sozlamalar → Terminallar» bo‘limida ulanadi.",
      open: "Smenani ochish",
    },
    finish: {
      title: "Birinchi sotuvga tayyor",
      hint: "O‘tkazib yuborilgan qadamlarni keyinroq sozlamalarda yakunlash mumkin.",
      openPos: "Kassani ochish",
      openDashboard: "Dashboardga o‘tish",
    },
    steps: {
      company: "Kompaniya",
      branch: "Muassasa",
      currency: "Valyuta va vaqt",
      menu: "Menyu",
      tables: "Stollar",
      employees: "Xodimlar",
      cash: "Kassa",
      finish: "Tayyor",
    },
    formats: {
      cafe: "Ofitsiantli kafe",
      coffee: "Qahvaxona",
      fast_food: "Fastfud",
      self_service: "O‘z-o‘ziga xizmat",
      food_court: "Fudkort",
    },
    formatHints: {
      cafe: "Zal, stollar, ovqatdan keyin to‘lov",
      coffee: "Olib ketish va zalda, ichimlik modifikatorlari",
      fast_food: "Buyurtma raqami, darhol to‘lov",
      self_service: "Peshtaxtada buyurtma, tayyorlik ekrani",
      food_court: "Umumiy zal, bir nechta oshxona",
    },
    countries: {
      KG: "Qirg‘iziston",
      KZ: "Qozog‘iston",
      UZ: "O‘zbekiston",
      TJ: "Tojikiston",
      RU: "Rossiya",
    },
  },
  site: {
    contacts: { title: "Kontaktlar va ijtimoiy tarmoqlar", hint: "Sayt pastki qismida va bosh sahifada koʻrinadi. Boʻsh maydonlar saytda koʻrinmaydi. Ijtimoiy tarmoqlar — havola yoki akkaunt nomi (@name).", phone: "Muassasa telefoni", email: "Mehmonlar uchun email" },
    title: "Sayt va QR-menyu",
    description: "Muassasaning ochiq sayti, stollardagi QR-menyu va mehmonlarning telefondan buyurtmasi.",
    open: "Saytni ochish",
    slug: "Sayt manzili (subdomen)",
    heroTitle: "Bosh sahifa sarlavhasi",
    about: "Muassasa haqida",
    seoTitle: "SEO-sarlavha",
    seoTitleHint: "60 belgigacha",
    seoDescription: "SEO-tavsif",
    seoDescriptionHint: "155 belgigacha",
    qrOrdering: "QR orqali mehmonlar buyurtmasi",
    qrOrderingHint: "Mehmonlar telefonidan buyurtma beradi, buyurtma darhol kassada paydo bo‘ladi",
    qrOrderingAddon: "«QR orqali buyurtma» qo‘shimchasi bilan mavjud — uni «Obuna» sahifasida ulang",
    requireName: "Mehmon ismini so‘rash",
    autoKitchen: "Darhol oshxonaga yuborish",
    autoKitchenHint: "Aks holda buyurtma ofitsiant tasdig‘ini kutadi",
    qrTitle: "Stollarning QR-kodlari",
    qrHint: "Stollar uchun stikerlar: mehmon skanerlab menyuni ko‘radi, buyurtma beradi va ofitsiantni chaqiradi.",
    printAll: "Stikerlarni chop etish ({{n}})",
    noTables: "Hozircha stollar yo‘q — «Zallar va stollar» bo‘limida yarating.",
    counterQr: "Peshtaxta va vitrina uchun QR",
    scanCaption: "Menyu uchun skanerlang",
    callWaiter: "{{n}}-stol ofitsiantni chaqirmoqda",
    requestBill: "{{n}}-stol hisob so‘ramoqda",
    domain: {
      title: "Saytning o‘z manzili",
      description: "Sayt va QR-menyu o‘z domeningizda — masalan, platforma manzili o‘rniga navat.kg.",
      addon: "«Saytning o‘z manzili» qo‘shimchasi bilan mavjud",
      addonHint: "Uni «Obuna» sahifasida ulang — sayt o‘z manzilingizda ochiladi, platforma manzilidagi havolalar ham o‘sha yerga olib boradi.",
      input: "Sizning domeningiz",
      inputHint: "Domen registratordan oldin sotib olingan bo‘lishi kerak (masalan, navat.kg yoki menu.navat.kg)",
      connect: "Ulash",
      none: "O‘z manzil ulanmagan.",
      pending: "DNS sozlanishi kutilmoqda",
      active: "Ishlayapti",
      since: "{{date}} tasdiqlangan",
      steps: "Ushbu yozuvlarni domen registratori panelida qo‘shing va «Tekshirish»ni bosing. DNS o‘zgarishlari odatda 5–30 daqiqada, ba’zan bir sutkada yetib keladi.",
      type: "Turi",
      name: "Nomi",
      value: "Qiymati",
      copy: "Nusxalash",
      copied: "Nusxalandi",
      verify: "Tekshirish",
      change: "Manzilni almashtirish",
      remove: "Manzilni o‘chirish",
      removeTitle: "O‘z manzilni o‘chirasizmi?",
      removeHint: "Sayt platforma manzili bo‘yicha ochilaveradi. DNS yozuvlarini registratorda o‘chirish mumkin.",
      noTxt: "TXT yozuvi hozircha ko‘rinmayapti. Nomi va qiymatini tekshiring yoki kuting — DNS darhol yangilanmaydi.",
      noRouting: "Domen hali bizga yo‘naltirilmagan (CNAME yoki A yozuvi). U bo‘lmasa, sayt bu manzilda ochilmaydi.",
      sslHint: "Xavfsiz ulanish (https) domen bizga yo‘naltirilgandan keyin bir necha daqiqada o‘zi yoqiladi.",
      activeToast: "{{domain}} manzili tasdiqlandi",
    },
  },
  supportAccess: {
    title: "Coca yordam xizmati ruxsat so‘ramoqda",
    description: "Yordam xizmati xodimi {{name}} kabinetingizga kirmoqchi. Sizning ruxsatingizsiz kira olmaydi.",
    approve: "Kirishga ruxsat berish",
    deny: "Rad etish",
    mode: "Rejim",
    modeReadOnly: "Faqat ko‘rish",
    modeFull: "Ko‘rish va o‘zgartirish",
    reason: "Sabab",
    until: "Javob berish muddati",
    readOnlyHint: "Xodim kabinetni sizning ko‘zingiz bilan ko‘radi, lekin hech narsani o‘zgartira olmaydi. Seans — 60 daqiqagacha, hammasi audit jurnaliga yoziladi.",
    fullHint: "Xodim egasi nomidan o‘zgartirish kiritishi mumkin. Faqat o‘zingiz yordam so‘ragan bo‘lsangiz ruxsat bering. Seans — 60 daqiqagacha, barcha amallar audit jurnaliga yoziladi.",
    approved: "Ruxsat berildi — yordam xizmati xodimi 10 daqiqa ichida kirishi mumkin",
    denied: "So‘rov rad etildi",
  },
  support: {
    title: "Yordam",
    description: "Bizga yozing — shu bo‘limda javob beramiz va bildirishnoma yuboramiz.",
    new: "Yordamga yozish",
    empty: "Hozircha murojaatlar yo‘q",
    emptyHint: "Biror narsa ishlamasa yoki savol bo‘lsa — yozing, yordam beramiz.",
    subject: "Mavzu",
    category: "Murojaat turi",
    body: "Xabar",
    bodyHint: "Nima bo‘lganini va nimani kutganingizni yozing. Buyurtma raqami yoki ekran yordam beradi.",
    send: "Yuborish",
    reply: "Javob berish",
    replyPlaceholder: "Javobingiz…",
    close: "Masala hal bo‘ldi",
    closeConfirm: "Murojaatni yopasizmi?",
    closeHint: "Masala qaytsa — shu murojaatga yozing.",
    sent: "Murojaat yuborildi",
    replied: "Xabar yuborildi",
    closed: "Murojaat yopildi",
    you: "Siz",
    supportName: "Coca yordam xizmati",
    number: "№ {{n}}",
    createdBy: "Muallif",
    updated: "Oxirgi xabar",
    slaNormal: "{{hours}} soat ichida javob beramiz",
    slaHigh: "Tezkor yordam: {{hours}} soat ichida javob, murojaatlaringiz — birinchi",
    slaUpsell: "Tezroq kerakmi? «Tezkor yordam»ni ulang — 2 soatda javob.",
    slaUpsellAction: "Obuna",
    waitUntil: "{{time}} gacha javob beramiz",
    overdue: "Javob kechikmoqda — shug‘ullanyapmiz",
    statuses: {
      open: "Javob kutilmoqda",
      answered: "Javob bor",
      closed: "Hal qilindi",
    },
    categories: {
      question: "Savol",
      problem: "Biror narsa ishlamayapti",
      billing: "To‘lov va obuna",
      idea: "Taklif",
    },
    filterAll: "Hammasi",
    priorityHigh: "Shoshilinch",
  },
  brand: {
    title: "O‘z brendingiz",
    description: "Coca o‘rniga nomingiz, logotip va rangingiz — dasturda, saytda va xatlarda.",
    addon: "«Coca o‘rniga o‘z brendingiz» qo‘shimchasi bilan mavjud",
    addonHint: "Xodimlar va mehmonlar faqat brendingizni ko‘radi: dastur sarlavhasi, tugmalar rangi, «Coca'da ishlaydi» yozuvisiz sayt, sizning nomingizdan xatlar.",
    name: "Nomi",
    nameHint: "Sarlavhada, brauzer yorlig‘ida va xat imzosida. Bo‘sh bo‘lsa — kompaniya nomi",
    color: "Asosiy rang",
    logo: "Logotip",
    logoHint: "Shaffof fonli, gorizontal cho‘zilgan PNG ma’qul",
    colors: {
      orange: "To‘q sariq (Coca)",
      red: "Qizil",
      rose: "Malina rang",
      violet: "Binafsha",
      blue: "Ko‘k",
      teal: "Feruza",
      green: "Yashil",
      brown: "Jigarrang",
    },
  },
  fraud: {
    title: "Suiiste’moldan himoya",
    description: "Xodimlarning shubhali harakatlari: o‘chirishlar, qaytarishlar, chegirmalar, kamomadlar. Har soatda o‘zi tekshiriladi.",
    scan: "Hozir tekshirish",
    scanFound: "Yangilari topildi: {{count}}",
    scanNothing: "Yangi shubhali harakatlar yo‘q",
    settings: "Qoidalar",
    alertsTab: "Signallar",
    peopleTab: "Xodimlar",
    peopleTitle: "Kim signallarga ko‘proq tushadi",
    peopleHint: "Xavf — og‘irliklar yig‘indisi: jiddiy 5, o‘rta 3, past 1. Soxta xavotirlar hisoblanmaydi.",
    empty: "Shubhali harakatlar yo‘q",
    emptyHint: "Tanlangan davrda qoidalar hech narsa topmadi.",
    all: "Hammasi",
    status: "Holat",
    rule: "Nima bo‘ldi",
    employee: "Xodim",
    date: "Sana",
    amount: "Summa",
    risk: "Xavf",
    alerts: "Signallar",
    noUser: "Xodimsiz",
    decision: "Qaror",
    comment: "Izoh",
    statuses: {
      new: "Yangi",
      reviewed: "Ko‘rib chiqildi",
      dismissed: "Soxta xavotir",
      confirmed: "Qoidabuzarlik",
    },
    severities: {
      low: "Past",
      medium: "O‘rta",
      high: "Jiddiy",
    },
    units: {
      count: "Ko‘p, marta",
      percent: "Ko‘p, %",
      days: "To‘lovsiz kunlar",
      sigma: "O‘rtachadan yuqori, σ",
    },
    rules: {
      void_many: "Ko‘p o‘chirilgan pozitsiyalar",
      void_after_kitchen: "Oshxonadan keyin pozitsiyani o‘chirish",
      cancel_after_kitchen: "Oshxonadan keyin buyurtmani bekor qilish",
      refunds_many: "Ko‘p qaytarishlar",
      refund_cash_for_card: "Karta to‘loviga naqd qaytarish",
      discount_share: "Ko‘p qo‘lda chegirmalar",
      price_below_menu: "Menyudan arzon sotish",
      writeoff_outlier: "G‘ayrioddiy katta hisobdan chiqarish",
      cash_shortage: "Kassada kamomad",
      credit_unpaid: "To‘lanmagan qarz",
    },
    ruleHints: {
      void_many: "Xodim bir kunda odatdagidan ko‘p pozitsiyani o‘chirgan.",
      void_after_kitchen: "Taom tayyorlangan, keyin o‘chirilgan — mahsulot sarflangan, pul yo‘q.",
      cancel_after_kitchen: "Buyurtma oshxonaga ketgan, keyin bekor qilingan.",
      refunds_many: "Bir kunda odatdagidan ko‘p qaytarish.",
      refund_cash_for_card: "Mehmon karta bilan to‘lagan, qaytarish naqd berilgan — pul chiqarishning klassik sxemasi.",
      discount_share: "Xodimning qo‘lda chegirmalari — uning kunlik savdosining sezilarli ulushi.",
      price_below_menu: "Pozitsiyalar menyu narxidan arzon sotilgan.",
      writeoff_outlier: "Hisobdan chiqarish bu muassasa uchun odatdagidan ancha katta.",
      cash_shortage: "Smena yopilganda naqd pul bo‘lishi kerakdan kam. 30 kun ichida takrorlansa — jiddiy.",
      credit_unpaid: "Qarzga sotuv, u bo‘yicha uzoq vaqtdan beri birorta to‘lov yo‘q.",
    },
    d: {
      count: "{{count}} marta (chegara {{threshold}})",
      order: "buyurtma № {{n}}",
      pct: "{{pct}}% (chegara {{threshold}}%)",
      lines: "pozitsiyalar: {{count}}",
      average: "odatda taxminan {{avg}}",
      repeats: "takroran: 30 kunda {{count}}",
      customer: "mijoz {{name}}",
      paidBy: "to‘lov: {{methods}}",
    },
  },
  sms: {
    title: "SMS-xabarnomalar",
    description: "Segmentlar bo‘yicha mijozlarga xabarlar: aksiyalar, yangiliklar, eslatmalar. Faqat rozilik berganlarga.",
    usage: "{{month}} uchun SMS",
    usageValue: "{{quota}} dan {{used}}",
    noQuota: "Oyga SMS yo‘q",
    lowQuota: "SMS qoldi: {{count}}",
    packHint: "«SMS 1000» paketi «Obuna» sahifasida ulanadi va har oy amal qiladi.",
    buyPack: "Obuna",
    new: "Yangi xabarnoma",
    test: "Sinov SMS",
    campaigns: "Xabarnomalar",
    empty: "Hozircha xabarnomalar yo‘q",
    emptyHint: "Birinchisini yarating — masalan, dam olish kunlariga chegirma bilan taklif.",
    name: "Nomi",
    nameHint: "O‘zingiz uchun, mijozlar uni ko‘rmaydi",
    segment: "Kimga",
    allCustomers: "Roziligi bor barcha mijozlarga",
    tag: "Mijoz tegi",
    tagHint: "Ixtiyoriy: faqat shu tegli mijozlar",
    text: "Matn",
    counter: "{{length}} belgi · {{parts}} SMS ({{perPart}} dan)",
    noRecipients: "Qabul qiluvchilar yo‘q: mijoz kartasida telefon va «xabarnomalarga roziman» belgisi kerak.",
    previewText: "Qabul qiluvchilar: {{recipients}}, SMS: {{total}}. Bu oyda qoldi: {{remaining}}.",
    notEnough: "SMS yetmaydi — paket sotib oling.",
    consentHint: "Faqat «xabarnomalarga roziman» belgisi, telefoni bor va bloklanmagan mijozlar oladi.",
    confirmTitle: "Xabarnomani yuborasizmi?",
    confirmText: "Qabul qiluvchilar: {{recipients}}, SMS sarflanadi: {{total}}. Yuborilgandan keyin bekor qilib bo‘lmaydi.",
    send: "Yuborish",
    started: "Xabarnoma boshlandi — xabarlar bir daqiqa ichida ketadi",
    phone: "Raqam",
    testText: "Kafemizdan SMS sinovi",
    testQueued: "SMS yuborilmoqda",
    date: "Qachon",
    recipients: "Qabul qiluvchilar",
    delivered: "Yetkazildi",
    notSent: "ketmadi: {{count}}",
    statuses: {
      sending: "Yuborilmoqda",
      sent: "Yuborildi",
    },
  },
  services: {
    title: "Xizmatlar va ijara",
    description: "Qalyon, karaoke, xona ijarasi: taymer serverda ishlaydi, to‘xtatilganda xizmat o‘zi buyurtmaga tushadi.",
    start: "Xizmatni boshlash",
    startTimer: "Taymerni ishga tushirish",
    sell: "Sotish",
    started: "Taymer ishga tushdi",
    sold: "Xizmat buyurtmaga qo‘shildi",
    stopped: "Xizmat buyurtmaga qo‘shildi",
    tabs: {
      now: "Hozir",
      rooms: "Xonalar",
      tariffs: "Tariflar",
      report: "Hisobot",
    },
    statuses: {
      running: "Davom etmoqda",
      paused: "Pauza",
      stopped: "Tugadi",
      cancelled: "Bekor qilindi",
    },
    pause: "Pauza",
    resume: "Davom ettirish",
    stop: "Tugatish",
    stopTitle: "Tugatib, buyurtmaga qo‘shasizmi?",
    stopHint: "Vaqt tarif bo‘yicha hisoblanadi (qadam va yaxlitlash), summa buyurtmaga tushadi.",
    cancel: "Bekor qilish",
    cancelTitle: "To‘lovsiz bekor qilasizmi?",
    cancelHint: "Vaqt to‘lanmaydi. Harakat jurnalga yoziladi.",
    elapsed: "O‘tdi {{time}}",
    planned: "{{time}} gacha to‘langan",
    overPlanned: "To‘langan vaqt tugadi",
    noActive: "Hozir hech narsa davom etmayapti",
    noActiveHint: "Xizmatni ishga tushiring — qalyon, karaoke yoki xona ijarasi.",
    recent: "Oxirgilari",
    when: "Boshlanishi",
    duration: "Vaqt",
    amount: "Summa",
    service: "Xizmat",
    room: "Xona",
    noRoom: "Xonasiz",
    busy: "band",
    free: "Bo‘sh",
    quantity: "Soni",
    plannedMinutes: "To‘langan vaqt, daq",
    plannedHint: "Ixtiyoriy: vaqt tugaganda taymer belgilanadi",
    orderHint: "Buyurtma tanlanmasa yangisi yaratiladi — xona stoliga, agar ko‘rsatilgan bo‘lsa.",
    noReady: "Sozlangan xizmatlar yo‘q: «Xizmat» turidagi menyu pozitsiyasini qo‘shing va «Tariflar» yorlig‘ida tarif belgilang.",
    billing: "Qanday hisoblash",
    billingHourly: "Vaqt bo‘yicha",
    billingUnit: "Dona",
    unitHint: "Narx — menyudan ({{price}}); texkarta bo‘lsa mahsulotlar (tamaki, ko‘mir) hisobdan chiqariladi.",
    hourlyPrice: "Soat narxi",
    minDuration: "Minimum, daq",
    step: "Qadam, daq",
    rounding: "Yaxlitlash",
    roundings: {
      up: "Yuqoriga",
      nearest: "Eng yaqiniga",
      down: "Pastga",
    },
    tierLabel: "Birinchi soatdan keyin boshqa narx",
    tierHint: "Masalan: birinchi soat 1000, keyin 800 dan",
    tierFrom: "Qaysi daqiqadan",
    tierPrice: "Keyingi soat narxi",
    commission: "Komissiya",
    commissions: {
      none: "Komissiyasiz",
      fixed: "Summa",
      percent: "Foiz",
      mixed: "Summa + foiz",
    },
    commissionPercent: "Foiz",
    commissionFixed: "Summa",
    addRoom: "Xona qo‘shish",
    roomName: "Nomi",
    minOrder: "Minimal buyurtma",
    minOrderHint: "Ijara tugaganda buyurtma shu summagacha to‘ldiriladi",
    deposit: "Depozit",
    roomActive: "Foydalaniladi",
    inactive: "O‘chirilgan",
    noRooms: "Hozircha xonalar yo‘q",
    noRoomsHint: "VIP-xona yoki karaoke zalini qo‘shing.",
    tariffsHint: "Xizmatlar — «Xizmat» turidagi menyu pozitsiyalari. Bu yerda — ularni qanday hisoblash va ijrochiga komissiya.",
    noServices: "Hozircha xizmatlar yo‘q",
    noServicesHint: "Menyuda «Xizmat» turidagi pozitsiya yarating.",
    notConfigured: "Sozlanmagan",
    perHour: "Soatiga {{price}}, qadam {{step}} daq",
    perUnit: "Donasi {{price}}",
    revenue: "Tushum",
    roomsLoad: "Xonalar bandligi",
    hours: "Soatlar",
    sessions: "Sessiyalar",
    load: "Bandlik",
    commissionsTitle: "Xodimlarga komissiya",
    commissionsHint: "Qaytarishlar va o‘chirilgan pozitsiyalar hisobga olinmaydi.",
    noCommissions: "Komissiya yo‘q",
    employee: "Xodim",
    sales: "Sotuvlar",
  },
  banquets: {
    title: "Banketlar",
    description: "To‘ylar, tug‘ilgan kunlar, korporativlar: mehmonga menyu, depozitlar, zal bandi va tadbir kuni buyurtma.",
    new: "Yangi banket",
    empty: "Banketlar yo‘q",
    emptyHint: "Ariza yarating — menyu va depozitni keyin qo‘shish mumkin.",
    name: "Nomi",
    type: "Turi",
    startsAt: "Boshlanishi",
    endsAt: "Tugashi",
    guests: "Mehmonlar",
    guestsN: "Mehmonlar: {{count}}",
    halls: "Zallar",
    hallsHint: "Tasdiqlangandan keyin zallar oddiy bandlar uchun yopiladi",
    depositRequired: "Tasdiqlash uchun depozit",
    depositRequiredHint: "0 — depozitsiz tasdiqlash",
    notes: "Izohlar",
    types: {
      wedding: "To‘y",
      birthday: "Tug‘ilgan kun",
      corporate: "Korporativ",
      anniversary: "Yubiley",
      other: "Boshqa",
    },
    statuses: {
      inquiry: "Ariza",
      tentative: "Dastlabki",
      confirmed: "Tasdiqlangan",
      in_progress: "Davom etmoqda",
      completed: "Tugagan",
      cancelled: "Bekor qilingan",
    },
    statusActions: {
      inquiry: "Arizalarga",
      tentative: "Dastlabki",
      confirmed: "Tasdiqlash",
      in_progress: "Boshlash",
      completed: "Tugatish",
      cancelled: "Bekor qilish",
    },
    cancelTitle: "Banketni bekor qilasizmi?",
    cancelHint: "Zallar bo‘shaydi. Qaytarilmagan depozitlarni «Depozitlar» yorlig‘ida qaytaring.",
    cancelReason: "ERP da bekor qilindi",
    start: "Banketni boshlash",
    startTitle: "Banketni boshlaysizmi?",
    startHint: "Menyudan buyurtma yaratiladi, depozit to‘lovga hisoblanadi. Ochiq kassa smenasi kerak.",
    started: "Banket buyurtmasi yaratildi",
    complete: "Tugatish",
    completed: "Banket tugadi",
    print: "Taklif",
    proposal: "Tijoriy taklif",
    orderN: "Buyurtma № {{n}}",
    tabs: {
      menu: "Menyu",
      deposits: "Depozitlar",
      summary: "Natijalar",
    },
    addItem: "Taom qo‘shish",
    menuEmpty: "Menyu bo‘sh",
    menuEmptyHint: "Taomlarni qo‘shing — sonini mehmonga ko‘rsatish mumkin.",
    dish: "Taom",
    course: "Tortish",
    qty: "Soni",
    perGuest: "mehmonga",
    price: "Narx",
    sum: "Summa",
    menuTotal: "Jami {{total}} · mehmonga {{perGuest}}",
    depositState: "{{required}} dan {{paid}} kiritildi; buyurtmaga hisoblandi {{applied}}",
    depositAmount: "Depozit summasi",
    method: "Usul",
    methods: {
      cash: "Naqd",
      card: "Karta",
      bank: "O‘tkazma",
    },
    takeDeposit: "Qabul qilish",
    depositAdded: "Depozit qabul qilindi",
    noDeposits: "Depozitlar yo‘q",
    when: "Qachon",
    refunded: "Qaytarilgan",
    refund: "Qaytarish",
    refundTitle: "Depozitni qaytarasizmi?",
    refundHint: "{{amount}} — naqd pul kassadan beriladi.",
    menuSum: "Menyu",
    orderSum: "Buyurtma № {{n}}",
    costSum: "Texkartalar bo‘yicha tannarx",
    costPartial: "hamma taomlarda texkarta yo‘q",
    extraCosts: "Qo‘shimcha xarajatlar",
    profit: "Foyda",
    deposits: "Depozitlar",
    due: "To‘lashga",
    productsTitle: "Banket uchun mahsulotlar",
    productsHint: "Barcha mehmonlar uchun menyu texkartalari bo‘yicha; qoldiqdan tashqari qancha sotib olish kerak.",
    missingRecipes: "Texkartasiz: {{names}}",
    noProducts: "Texkartali taomlar yo‘q",
    product: "Mahsulot",
    need: "Kerak",
    inStock: "Omborda",
    toBuy: "Sotib olish",
  },
  promotions: {
    title: "Aksiyalar",
    description: "Qoidalar bo‘yicha chegirmalar: happy hours, kombo, «2+1», sovg‘alar, promokodlar. Muvofiqlik — ustuvorlik va guruhlar bo‘yicha.",
    posHint: "Kassada aksiyalar buyurtmadagi «Aksiyalar» tugmasi bilan yoqiladi — promokod ham shu yerda kiritiladi.",
    new: "Yangi aksiya",
    empty: "Hozircha aksiyalar yo‘q",
    emptyHint: "Masalan: «Pivo −30% 17 dan 19 gacha» yoki «Burger + fri + ichimlik = 450».",
    tabs: {
      list: "Aksiyalar",
      report: "Qanchaga tushdi",
    },
    name: "Nomi",
    code: "Promokod",
    codeHint: "Ixtiyoriy: aksiya faqat shu kod bilan ishlaydi",
    type: "Turi",
    types: {
      percent: "Foizli chegirma",
      fixed: "Summali chegirma",
      combo: "Maxsus narxdagi kombo",
      bogo: "X ol — Y ol",
      gift: "Sovg‘a",
    },
    percent: "Foiz",
    amount: "Chegirma summasi",
    buyQty: "Sotib ol",
    getQty: "Ol",
    getPercent: "«Ol» uchun chegirma, %",
    slot: "Slot {{n}}",
    addSlot: "Slot",
    removeSlot: "Slotni olib tashlash",
    comboPrice: "To‘plam narxi",
    gift: "Sovg‘a",
    giftHint: "Pozitsiya buyurtmada bo‘lishi kerak — u bepul bo‘ladi",
    target: "Nimaga amal qiladi",
    scopes: {
      order: "Butun buyurtma",
      categories: "Toifalar",
      items: "Pozitsiyalar",
    },
    conditions: "Shartlar",
    minSubtotal: "Buyurtma ...dan",
    days: "Hafta kunlari",
    daysHint: "Bo‘sh — har kuni",
    timeFrom: "Dan",
    timeTo: "Gacha",
    timeHint: "Happy hours; yarim tun orqali ham mumkin",
    dateFrom: "Amal qiladi ...dan",
    dateTo: "Amal qiladi ...gacha",
    customerTag: "Mijoz tegi",
    customerTagHint: "Masalan: staff — xodimlarga chegirma",
    usageLimit: "Foydalanish limiti",
    firstOrder: "Faqat mijozning birinchi buyurtmasi",
    stackGroup: "Muvofiqlik guruhi",
    stackGroupHint: "Bir guruhdan bittasi, eng foydalisi qo‘llanadi",
    priority: "Ustuvorlik",
    exclusive: "Eksklyuziv",
    exclusiveHint: "Mos kelsa — boshqa aksiyalar qo‘llanmaydi",
    active: "Amal qiladi",
    on: "Amal qiladi",
    off: "O‘chirilgan",
    orders: "Buyurtmalar",
    cost: "Chegirma",
    revenue: "Buyurtmalar tushumi",
    reportEmpty: "Davrda aksiyalar qo‘llanmagan",
    deleteTitle: "Aksiyani o‘chirasizmi?",
    fromSum: "{{sum}} dan",
    limitN: "limit {{n}}",
  },
  deliveries: {
    formatOff: "Filial yetkazib berishda ishlamaydi",
    formatOffHint: "Filial sozlamalarida «Yetkazib berish» formatini yoqing — usiz yetkazish buyurtmasini yaratib bo‘lmaydi.",
    formatOffAction: "Filial sozlamalari",
    title: "Yetkazib berish",
    description: "Dispetcherlik: holatlar bo‘yicha buyurtmalar, va’da qilingan vaqtgacha taymerlar, kuryerlar va hududlar.",
    new: "Yangi yetkazish",
    createAndOpen: "Yaratish va kassada ochish",
    created: "Yetkazish rasmiylashtirildi — pozitsiyalarni qo‘shing",
    empty: "Ishdagi yetkazishlar yo‘q",
    emptyHint: "Yetkazishni rasmiylashtiring — pozitsiyalar kassada qo‘shiladi.",
    tabs: {
      board: "Ishda",
      done: "Tugaganlar",
      zones: "Hududlar",
      couriers: "Kuryerlar",
    },
    statuses: {
      new: "Yangi",
      confirmed: "Tasdiqlangan",
      cooking: "Tayyorlanmoqda",
      ready: "Tayyor",
      courier_assigned: "Kuryer tayinlangan",
      on_the_way: "Yo‘lda",
      delivered: "Yetkazildi",
      failed: "Bo‘lmadi",
      cancelled: "Bekor qilingan",
      returned: "Qaytarildi",
    },
    statusActions: {
      new: "Yangi",
      confirmed: "Tasdiqlash",
      cooking: "Tayyorlanmoqda",
      ready: "Tayyor",
      courier_assigned: "Tayinlash",
      on_the_way: "Yo‘lda",
      delivered: "Yetkazildi",
      failed: "Bo‘lmadi",
      cancelled: "Bekor qilish",
      returned: "Qaytdi",
    },
    payments: {
      prepaid: "To‘langan",
      cash: "Kuryerga naqd",
      card: "Kuryerga karta",
    },
    changeFrom: "{{sum}} dan qaytim",
    changeFromLabel: "Kupyuradan qaytim",
    lateBy: "{{n}} daq kechikish",
    leftN: "{{n}} daq qoldi",
    noItems: "pozitsiyalar hali yo‘q",
    noCourier: "Kuryersiz",
    courier: "Kuryer",
    openPos: "Kassada",
    reasonHint: "Harakat jurnalga yoziladi.",
    byDispatcher: "Dispetcher belgiladi",
    customer: "Mehmon ismi",
    phone: "Telefon",
    street: "Ko‘cha, uy",
    entrance: "Podyezd",
    floor: "Qavat",
    apartment: "Xonadon",
    comment: "Kuryerga izoh",
    zone: "Hudud",
    zoneHint: "Koordinatalar bo‘yicha o‘zi aniqlanadi",
    noZone: "Hududsiz (narx qo‘lda)",
    coords: "Koordinatalar",
    coordsHint: "Kenglik, uzunlik — xaritadan (ixtiyoriy)",
    payment: "To‘lov",
    scheduledAt: "Vaqtga",
    scheduledHint: "Bo‘sh — imkon qadar tez",
    entranceN: "{{n}}-podyezd",
    floorN: "{{n}}-qavat",
    aptN: "{{n}}-xonadon",
    address: "Manzil",
    promised: "Va’da",
    newZone: "Yangi hudud",
    zoneName: "Nomi",
    zoneKind: "Shakli",
    kinds: {
      circle: "Doira",
      polygon: "Ko‘pburchak",
    },
    center: "Markaz",
    radius: "Radius, m",
    polygon: "Uchlar",
    polygonHint: "Har qatorda bittadan: kenglik, uzunlik",
    fee: "Narx",
    freeFrom: "Bepul ...dan",
    freeFromHint: "0 — doim pullik",
    minOrder: "Min. buyurtma",
    eta: "Yetkazish vaqti, daq",
    zoneActive: "Amal qiladi",
    off: "O‘chirilgan",
    noZones: "Hozircha hududlar yo‘q",
    noZonesHint: "Hududsiz manzil tekshirilmaydi — narx qo‘lda ko‘rsatiladi.",
    radiusN: "radius {{n}} m",
    pointsN: "{{n}} nuqta",
    freeFromN: "{{sum}} dan bepul",
    minN: "{{n}} daq",
    noCouriers: "Kuryerlar yo‘q",
    noCouriersHint: "«Kuryer» rolidagi xodim qo‘shing.",
    activeN: "Ishda",
    onHand: "Qo‘lidagi naqd",
    handover: "Naqdni qabul qilish",
    handoverTitle: "{{name}} dan naqdni qabul qilasizmi?",
    handoverHint: "Kuryer {{sum}} topshiradi.",
    handedOver: "Naqd qabul qilindi",
    reportTitle: "Kuryerlar bo‘yicha hisobot",
    noData: "Ma’lumot yo‘q",
    delivered: "Yetkazildi",
    lateCount: "Kechikishlar",
    failedCount: "Bo‘lmadi",
    avgTime: "O‘rtacha vaqt",
    cash: "Naqd",
  },
  courier: {
    title: "Mening yetkazishlarim",
    description: "Sizga tayinlangan buyurtmalar: manzil, qo‘ng‘iroq, marshrut va holat.",
    empty: "Yetkazishlar yo‘q",
    emptyHint: "Dispetcher buyurtma tayinlaganda u shu yerda paydo bo‘ladi.",
    paid: "To‘langan",
    collectCash: "Naqd olish {{sum}}",
    collectCard: "Karta bilan to‘lov {{sum}}",
    call: "Qo‘ng‘iroq",
    route: "Marshrut",
    go: "Yo‘lga chiqdim",
    delivered: "Yetkazildi",
    failed: "Bo‘lmadi",
    failTitle: "Yetkazib bo‘lmadimi?",
    failHint: "Dispetcher sababini ko‘rib, nima qilishni hal qiladi.",
    failReason: "Topshirib bo‘lmadi",
    deliveredToast: "Belgilandi: yetkazildi",
  },
  ai: {
    "quota": {
      "left": "Shu oyda {{limit}} ta so‘rovdan {{remaining}} tasi qoldi",
      "more": "So‘rov qo‘shish",
      "exhausted": "Shu oy uchun Coca AI so‘rovlari tugadi. «Obuna» bo‘limida «+500 yordamchiga so‘rov» paketini ulang yoki keyingi oyni kuting."
    },
    "hint": {
      "title": "Coca AI maslahati",
      "updated": "Yangilandi {{time}}",
      "get": "Maslahat olish",
      "refresh": "Maslahatni yangilash (1 so‘rov)",
      "hide": "Yashirish",
      "topics": {
        "sales": "Davr savdosida muhim narsalar — 1 so‘rov",
        "menu": "Menyuda nimani o‘zgartirish kerak — 1 so‘rov",
        "writeoffs": "Hisobdan chiqarishni qanday kamaytirish — 1 so‘rov",
        "products": "Mahsulot ortiqcha sarfi qayerda — 1 so‘rov",
        "waiters": "Jamoa qanday ishlayapti — 1 so‘rov",
        "finance": "Pul qayerga ketyapti — 1 so‘rov",
        "stock": "Nimani qo‘shimcha buyurtma qilish — 1 so‘rov"
      }
    },
    "button": "Coca AI — tez orada",
    "title": "Coca AI",
    "soon": "Tez orada",
    "eyebrow": "Coca AI · tez orada",
    "heroTitle": "Restoraningiz ega bo'ladi",
    "heroAccent": "o'z intellektiga",
    "heroText": "Har bir chek, har bir smena va ombordagi har bir grammni ko'radigan yordamchi. U siz so'rashingizdan oldin bashorat qiladi, maslahat beradi va harakat qiladi.",
    "explore": "Nimalar qila oladi",
    "notify": "Menga birinchi xabar bering",
    "notified": "Siz birinchilar ro'yxatidasiz",
    "notifyDone": "Tayyor! Coca AI ishga tushishi haqida birinchilardan bo'lib bilasiz.",
    "featuresTitle": "Superkuchlar —",
    "featuresAccent": "butun jamoaga",
    "featuresText": "Muassasangiz ma'lumotlarida o'qitilgan neyrotarmoq: menyu, savdo, ombor, xodimlar va mehmonlar — bitta manzarada.",
    "finalEyebrow": "Umumiy ovqatlanish kelajagi",
    "soonBig": "Tez orada",
    "finalText": "Biz Coca AI'ni hozir o'qitmoqdamiz. Ariza qoldiring — muassasangiz birinchilardan bo'lib kirish oladi.",
    "chat": {
      "button": "Coca AI — yordamchi",
      "eyebrow": "Coca AI · beta",
      "ask": "Savol berish",
      "text": "Savdo, menyu, ofitsiantlar, hisobdan chiqarish yoki ombor haqida so‘rang — yordamchi filialingiz hisobotlarini o‘zi ko‘rib, raqamlar bilan javob beradi. Faqat rolingizga ruxsat etilganini ko‘radi.",
      "subtitle": "Filialingiz ma’lumotlari bo‘yicha javob beradi",
      "live": "Ishlamoqda",
      "hello": "Salom! Men bu filial hisobotlarini ko‘raman. Masalan, so‘rang:",
      "suggestions": {
        "yesterday": "Kecha qanday o‘tdi?",
        "menu": "Oy davomida qaysi taomlar eng kam sotildi?",
        "stock": "Omborda nima tugayapti?",
        "waiters": "Haftaning eng yaxshi ofitsianti kim?"
      },
      "placeholder": "Savolingiz…",
      "send": "Yuborish",
      "clear": "Qaytadan boshlash",
      "voice": "Ovozli kiritish",
      "voiceStop": "Yozishni to‘xtatish",
      "voiceDenied": "Mikrofonga ruxsat yo‘q — brauzer sozlamalarida ruxsat bering.",
      "voiceFailed": "Nutqni aniqlab bo‘lmadi. Qayta urinib ko‘ring.",
      "thinking": "Ma’lumotlarni ko‘ryapman…",
      "sources": "Ko‘rildi",
      "tools": {
        "sales_report": "savdo",
        "menu_report": "taomlar bo‘yicha savdo",
        "waiters_report": "ofitsiantlar",
        "writeoffs_report": "hisobdan chiqarish",
        "products_report": "mahsulotlar",
        "finance_report": "moliya",
        "low_stock": "ombor"
      },
      "empty": "Javob tuza olmadim. Boshqacha so‘rab ko‘ring.",
      "notConfigured": "Yordamchi ulanmagan: serverda sun’iy intellekt kaliti (Claude yoki Gemini) o‘rnatilmagan.",
      "unavailable": "Yordamchi vaqtincha mavjud emas. Bir daqiqadan so‘ng urinib ko‘ring.",
      "disclaimer": "Javoblarni sun’iy intellekt tayyorlaydi — muhim qarorlarni hisobotlar bilan solishtiring."
    },
    "demo": {
      "eyebrow": "Shunchaki so'rang",
      "heading": "Biznes bilan oddiy tilda gaplashing",
      "text": "Filtrlar ham, eksportlar ham yo'q. Boshqaruvchidan so'ragandek so'rang — Coca AI raqamlar, sabablar va tayyor reja bilan javob beradi.",
      "title": "Coca AI",
      "subtitle": "Tahlilchi, oshpaz va marketolog bitta oynada",
      "thinking": "AI o'ylayapti",
      "dialogs": {
        "revenue": {
          "q": "Nega seshanba kuni tushum 18% kam bo'ldi?",
          "a": "O'rtacha chek o'zgarmadi, lekin kechqurun 40 ta mehmon kam bo'ldi: yomg'ir va futbol. Shunday kunlarda «ikki kishilik kechki ovqat» kombosi ishlaydi — keyingi seshanbaga yoqaymi?"
        },
        "purchase": {
          "q": "Dam olish kunlariga yetkazib beruvchilardan nima buyurtma qilay?",
          "a": "Bashorat: ish kunlariga nisbatan +35%. Mol go'shti — 14 kg, qaymoq — 9 l, losos — 6 kg. Buyurtma qoralamalari tayyor, faqat tasdiqlash qoldi."
        },
        "menu": {
          "q": "Menyudan qaysi taomlarni olib tashlash kerak?",
          "a": "3 ta pozitsiya kam sotiladi va deyarli marja bermaydi. «Krevetkali pasta» — sizning yulduzingiz: uni menyuda yuqoriga ko'taring, undan keladigan foyda 12% oshishi mumkin."
        }
      }
    },
    "features": {
      "forecast": {
        "title": "Talab bashorati",
        "text": "Ob-havo, bayramlar va shahardagi tadbirlarni hisobga olib, mehmonlar, tushum va oshxona yuklamasini soatbay bashorat qiladi.",
        "tag": "Bashoratli tahlil"
      },
      "purchasing": {
        "title": "Avtoxarid",
        "text": "Hech narsa tugab qolmasligi va isrof bo'lmasligi uchun nimani va qancha buyurtma qilishni o'zi hisoblaydi.",
        "tag": "Nol isrof"
      },
      "menu": {
        "title": "AI-oshpaz",
        "text": "Menyuning yulduzlari va ortiqcha yukini topadi, narxlar va ombordagi mahsulotlardan yangi taomlar taklif qiladi.",
        "tag": "Menyu-injiniring"
      },
      "fraud": {
        "title": "Suiiste'mol radari",
        "text": "Shubhali o'chirishlar, chegirmalar va kamomadlarni odatga aylanmasdan oldin sezadi.",
        "tag": "24/7 himoya"
      },
      "staff": {
        "title": "Aqlli jadval",
        "text": "Smenalarni yuklama bashoratiga moslab tuzadi: tig'iz paytda odam yetarli, sokin soatlarda ortiqchasi yo'q.",
        "tag": "Ish haqi tejamkorligi"
      },
      "marketing": {
        "title": "Avtopilotdagi marketing",
        "text": "Mehmonlarni segmentlarga ajratadi, har biriga SMS va aksiyalar yozadi va yuborish uchun eng yaxshi vaqtni o'zi tanlaydi. Uzoq vaqt kelmaganlarni qaytaradi.",
        "tag": "Shaxsiylashtirish"
      },
      "voice": {
        "title": "Ovozli yordamchi",
        "text": "Ofitsiant buyurtmani aytadi — kassa uni yozib oladi. Qo'llar bo'sh, xatolar kam.",
        "tag": "Ovoz → buyurtma"
      }
    },
    "stats": {
      "title": "Coca AI'ni shu maqsadlar uchun o'qitmoqdamiz",
      "waste": {
        "value": "−30%",
        "label": "mahsulot isrofi"
      },
      "check": {
        "value": "+15%",
        "label": "o'rtacha chekka"
      },
      "hours": {
        "value": "10 soat",
        "label": "boshqaruvchiga haftasiga tejam"
      },
      "always": {
        "value": "24/7",
        "label": "doim aloqada, dam olishsiz"
      }
    },
    "steps": {
      "title": "Bu qanday ishlaydi",
      "data": {
        "title": "Ma'lumotlar",
        "text": "Savdo, ombor, smenalar va mehmonlar Coca'da allaqachon yig'ilgan — hech narsani sozlash shart emas."
      },
      "brain": {
        "title": "Intellekt",
        "text": "Model jadvallarda ko'rinmaydigan qonuniyatlarni topadi va ularni oddiy so'zlar bilan tushuntiradi."
      },
      "action": {
        "title": "Harakat",
        "text": "Har bir maslahatda tugma bor: buyurtma berish, aksiyani boshlash, jadvalni tuzatish. Qaror doim sizda."
      }
    }
  },
  "warehouse": {
    "warehouse": "Ombor",
    "pick": "Ombor",
    "kinds": {
      "main": "Asosiy",
      "kitchen": "Oshxona",
      "bar": "Bar",
      "central": "Markaziy",
      "other": "Boshqa"
    },
    "title": "Omborlar",
    "description": "Qoldiqlar omborlar bo‘yicha saqlanadi. Asosiy ombordan sotuvlar texnologik karta bo‘yicha hisobdan chiqariladi, oshxona va bar tovarni ko‘chirish orqali oladi.",
    "add": "Ombor qo‘shish",
    "editTitle": "Ombor",
    "name": "Nomi",
    "namePlaceholder": "Issiq sex oshxonasi",
    "kind": "Vazifasi",
    "mainKindHint": "Asosiy omborning vazifasi o‘zgarmaydi",
    "negative": "Minusga tushishga ruxsat",
    "negativeHint": "Qoldiqdan ortiq hisobdan chiqarish va ko‘chirish bloklanmaydi",
    "negativeShort": "Minusga mumkin",
    "makeDefault": "Asosiy qilish",
    "defaultHint": "Texnologik karta bo‘yicha sotuvlar shu ombordan hisobdan chiqariladi",
    "default": "Asosiy",
    "defaultChanged": "Asosiy ombor: {{name}}",
    "deleteTitle": "«{{name}}» omborini o‘chirasizmi?",
    "deleteHint": "Faqat yo‘ldagi ko‘chirishlari yo‘q bo‘sh omborni o‘chirish mumkin.",
    "count": "Omborlar: {{count}}",
    "limit": "tarif limiti — {{n}}",
    "products": "Qoldig‘i bor mahsulotlar",
    "openStock": "Qoldiqlar",
    "onlyMain": "Hozircha faqat asosiy ombor",
    "onlyMainHint": "Oshxona, bar yoki markaziy ombor qo‘shing va tovarni ular orasida ko‘chiring."
  },
  "expiry": {
    "title": "Yaroqlilik muddati",
    "description": "Filial omborlaridagi muddati bor partiyalar. Sotuv va hisobdan chiqarish avval tezroq tugaydiganidan boshlanadi.",
    "expired": "Muddati o‘tgan partiyalar",
    "soon": "{{n}} kunda tugaydi",
    "filter": "Ko‘rsatish",
    "states": {
      "expired": "Muddati o‘tgan",
      "soon": "Tez orada tugaydi",
      "dated": "Muddati borlar",
      "all": "Barcha partiyalar"
    },
    "days": "Muddat",
    "inDays": "{{count}} kun ichida",
    "received": "Kelgan",
    "expiresAt": "Yaroqli",
    "noDate": "Muddatsiz",
    "overdue": "{{count}} kun oldin o‘tgan",
    "today": "Bugun tugaydi",
    "left": "{{count}} kun qoldi",
    "writeoff": "Hisobdan chiqarish",
    "writeoffTitle": "«{{name}}» hisobdan chiqarilsinmi?",
    "writeoffHint": "{{qty}} {{sum}} summasiga hisobdan chiqariladi. Muddati eng yaqin partiyalar birinchi chiqariladi.",
    "writeoffComment": "Yaroqlilik muddati {{date}} gacha",
    "writtenOff": "Hisobdan chiqarildi",
    "empty": "Muddati tugayotgan partiya yo‘q",
    "emptyExpired": "Muddati o‘tgan partiya yo‘q",
    "emptyHint": "Xarid paytida muddatni kiriting yoki mahsulotning saqlash muddatini belgilang — u o‘zi qo‘yiladi."
  },
  "transfers": {
    "title": "Ko‘chirishlar",
    "description": "Omborlar orasida tovar: filial ichida — darhol, boshqa filialga — qabul qilinguncha «yo‘lda».",
    "new": "Yangi ko‘chirish",
    "from": "Qayerdan",
    "to": "Qayerga",
    "pickBoth": "Ikkala omborni tanlang",
    "addLines": "Mahsulot va miqdorini qo‘shing",
    "send": "Jo‘natish",
    "move": "Ko‘chirish",
    "externalHint": "«{{branch}}» filiali ombori: tovar «yo‘lda» bo‘ladi, oluvchida qoldiq qabul qilingandan keyin paydo bo‘ladi.",
    "internalHint": "Filialingiz ombori: tovar darhol ko‘chadi.",
    "doneInternal": "№{{n}} ko‘chirish o‘tkazildi",
    "doneSent": "№{{n}} ko‘chirish «{{branch}}» ga jo‘natildi",
    "titleN": "№{{n}} ko‘chirish",
    "sent": "Jo‘natildi",
    "received": "Qabul qilindi",
    "receive": "Qabul qilish",
    "receiveHint": "Miqdorni tekshiring: kam kelgan bo‘lsa — haqiqiysini kiriting, kamomad qayd etiladi.",
    "receiveComment": "Qabul qilish izohi",
    "receiveCommentPlaceholder": "Masalan: paket shikastlangan",
    "receivedToast": "№{{n}} ko‘chirish qabul qilindi",
    "cancel": "Ko‘chirishni bekor qilish",
    "cancelTitle": "№{{n}} ko‘chirish bekor qilinsinmi?",
    "cancelHint": "Tovar jo‘natuvchi omborga qaytadi.",
    "print": "Dalolatnoma",
    "actTitle": "№{{n}} ko‘chirish dalolatnomasi",
    "signFrom": "Berdi",
    "signTo": "Qabul qildi",
    "shipped": "Jo‘natildi",
    "receivedAt": "Qabul qilindi",
    "shortage": "Kamomad",
    "shortageNote": "Qabul qilishda kamomad: {{sum}}.",
    "statuses": {
      "in_transit": "Yo‘lda",
      "received": "Qabul qilindi",
      "cancelled": "Bekor qilindi"
    },
    "incoming": "Kiruvchi ko‘chirishlar: {{count}}",
    "incomingHint": "Tovar filialingizga jo‘natildi — qoldiqda paydo bo‘lishi uchun qabul qiling.",
    "showIncoming": "Ko‘rsatish",
    "direction": "Yo‘nalish",
    "dirAll": "Hammasi",
    "dirIn": "Kiruvchi",
    "dirOut": "Chiquvchi",
    "allStatuses": "Barcha holatlar",
    "route": "Yo‘nalish",
    "empty": "Hozircha ko‘chirishlar yo‘q",
    "emptyHint": "Mahsulotlarni ombordan oshxonaga yoki boshqa filialga ko‘chiring."
  },
  "production": {
    "suggest": "Reja taklif qilish",
    "suggestComment": "Bashorat bo‘yicha",
    "suggestCreated": "Rejalashtirilgan buyurtmalar: {{count}}",
    "suggestTitle": "{{date}} uchun bashorat bo‘yicha reja",
    "suggestHint": "{{weeks}} haftaning xuddi shu kunidagi o‘rtacha sarf + {{pct}}% zaxira − omborlardagi qoldiq − rejalashtirilgan.",
    "suggestCreate": "Rejalashtirish: {{count}}",
    "suggestEmpty": "Texnologik kartasi bor yarim tayyor mahsulot yo‘q",
    "suggestEmptyHint": "«Yarim tayyor» turidagi mahsulot yarating va uning texnologik kartasini e’lon qiling.",
    "suggestSales": "Haftalar bo‘yicha sarf",
    "suggestAvg": "Bashorat",
    "suggestHave": "Bor va rejada",
    "suggestMake": "Tayyorlash",
    "title": "Ishlab chiqarish",
    "description": "Texnologik karta bo‘yicha yarim tayyor mahsulotlar: kunlik reja, aniq tannarx bilan chiqarish, yaroqlilik muddati va yorliqlar.",
    "new": "Ishlab chiqarishni rejalashtirish",
    "newHint": "Texnologik kartasi bor yarim tayyor mahsulotni va qancha tayyorlashni tanlang — xom ashyo ehtiyoji o‘zi hisoblanadi.",
    "plan": "Rejalashtirish",
    "product": "Yarim tayyor mahsulot",
    "productHint": "«Yarim tayyor» turi, e’lon qilingan texnologik kartasi bilan",
    "productPlaceholder": "Xamir, sous, sho‘rva…",
    "qty": "Qancha tayyorlash",
    "date": "Sana",
    "rawWarehouse": "Xom ashyo ombori",
    "outWarehouse": "Tayyor mahsulot ombori",
    "requirements": "Xom ashyo ehtiyoji",
    "estTotal": "Taxminiy narx",
    "shortagesTitle": "Yetishmayotgan mahsulotlar: {{count}}",
    "shortagesHint": "Chiqarishdan oldin mahsulotlarni sotib oling yoki xom ashyo omboriga ko‘chiring.",
    "fillProduct": "Yarim tayyor mahsulot va miqdorni tanlang",
    "created": "№{{n}} buyurtma rejalashtirildi",
    "raw": "Xom ashyo",
    "semi": "YTM",
    "need": "Kerak",
    "used": "Sarflandi",
    "cost": "Narx",
    "available": "Omborda",
    "short": "{{qty}} yetishmaydi",
    "enough": "Yetadi",
    "estCost": "Taxmin",
    "completeTitle": "Chiqarish: {{name}}",
    "completeHint": "Xom ashyo ombordan hisobdan chiqariladi, yarim tayyor mahsulot omborga muddatli partiya bo‘lib keladi.",
    "complete": "Chiqarishni o‘tkazish",
    "actual": "Haqiqiy chiqim",
    "planned": "Reja: {{qty}}",
    "expiresAt": "Yaroqli",
    "shelfLife": "Mahsulotning saqlash muddati: {{count}} kun",
    "noShelfLife": "Mahsulotning saqlash muddati belgilanmagan",
    "deviation": "Chiqimning rejadan og‘ishi: {{pct}}%",
    "customUsage": "Sarf texnologik kartadan farq qildi",
    "customUsageHint": "Haqiqatda qancha xom ashyo ketganini kiriting",
    "shortWarn": "Omborda xom ashyo keragidan kam: ombor minusga ruxsat bermasa, chiqarish o‘tmaydi.",
    "fillActual": "Haqiqiy chiqimni kiriting",
    "completedToast": "№{{n}} chiqarish o‘tkazildi",
    "start": "Boshlash",
    "cancel": "Bekor qilish",
    "cancelTitle": "№{{n}} buyurtma bekor qilinsinmi?",
    "cancelHint": "Qoldiqlar o‘zgarmaydi.",
    "cancelDoneTitle": "№{{n}} chiqarish bekor qilinsinmi?",
    "cancelDoneHint": "Xom ashyo omborga qaytadi, yarim tayyor mahsulot hisobdan chiqariladi. Agar u ishlatib bo‘lingan bo‘lsa — bekor qilish o‘tmaydi.",
    "statuses": {
      "planned": "Rejalashtirilgan",
      "in_progress": "Ishda",
      "completed": "Tayyor",
      "cancelled": "Bekor qilingan"
    },
    "planShort": "Reja",
    "fact": "Fakt",
    "rawCost": "Xom ashyo narxi",
    "unitCost": "{{unit}} uchun tannarx",
    "unitCostShort": "Tannarx",
    "lowYield": "Chiqim rejadan {{pct}}% kam — me’yor va yo‘qotishlarni tekshiring.",
    "label": "Yorliq",
    "labelHint": "Nomi, chiqarilgan sana, {{date}} gacha yaroqli, oshpaz",
    "copies": "Nusxa",
    "printLabel": "Yorliqlarni chop etish",
    "labelMade": "Tayyorlangan",
    "labelUntil": "Yaroqli",
    "labelQty": "Miqdor",
    "labelBy": "Oshpaz",
    "createdBy": "Yaratgan: {{name}}, {{at}}",
    "completedBy": "Chiqargan: {{name}}, {{at}}",
    "yield": "Chiqim {{pct}}%",
    "prevDay": "Oldingi kun",
    "nextDay": "Keyingi kun",
    "today": "Bugun",
    "addToPlan": "Rejaga qo‘shish",
    "emptyDay": "Bu kunga hech narsa rejalashtirilmagan",
    "emptyDayHint": "Tayyorgarlikni rejalashtiring — oshxona ularni shu yerda ko‘radi.",
    "emptyColumn": "Bo‘sh",
    "allStatuses": "Barcha holatlar",
    "planFact": "Reja / fakt",
    "empty": "Ishlab chiqarish buyurtmalari yo‘q",
    "tabPlan": "Kunlik reja",
    "tabHistory": "Barcha buyurtmalar",
    "tabReport": "Hisobot",
    "repOrders": "Chiqarishlar",
    "repLowYield": "Chiqimi rejadan past pozitsiyalar",
    "repYield": "Chiqim",
    "repEmpty": "Bu davrda chiqarish yo‘q"
  },
  "promo": {
    "badge": "Qo‘shimcha · ulanmagan",
    "genericTagline": "«{{name}}» tarifingizga kirmaydi. Ulang — bo‘lim darhol ishlaydi.",
    "connect": "Ulash",
    "connectFor": "Oyiga {{price}} ga ulash",
    "changePlan": "Tarifni almashtirish",
    "openSubscription": "Obunani ochish",
    "askOwner": "Egasi yoki administrator ulay oladi — «Obuna» bo‘limini ochishni so‘rang.",
    "allAddons": "Barcha qo‘shimchalar",
    "inPlans": "Tarifga kiradi: {{plans}}",
    "fineprint": "Avval summani ko‘rsatamiz — ulanish faqat siz tasdiqlaganingizdan keyin. Istalgan vaqtda o‘chirish mumkin.",
    "insideTitle": "Ichida nima bor",
    "bandTitle": "Sinab ko‘rasizmi?",
    "bandText": "«{{name}}» bir daqiqada yoqiladi — ma’lumotlar va sozlamalar saqlanadi.",
    "items": {
      "inventory_pro": {
        "title": "Yo‘qotishsiz ombor: bir nechta ombor, muddatlar va ko‘chirishlar",
        "tagline": "Oshxona, bar va markaziy ombor — har birining o‘z qoldig‘i bor. Tizim yaroqlilik muddatini kuzatadi, avval tez buziladiganini hisobdan chiqaradi va tovarni ikki bosishda ko‘chiradi.",
        "b1": {
          "t": "Muddatlar nazoratda",
          "d": "Har bir partiya o‘z muddatini eslaydi. Har kuni ertalab — tugayotganlar ro‘yxati, sotuv esa eng «eski»sidan boshlanadi."
        },
        "b2": {
          "t": "Bir nechta ombor",
          "d": "Asosiy ombor, oshxona, bar, tarmoqning markaziy ombori — qoldiq va qiymat har biri bo‘yicha alohida."
        },
        "b3": {
          "t": "Nuqtalar orasida ko‘chirish",
          "d": "Ombor → oshxona — darhol; boshqa filialga — qabul qilinguncha «yo‘lda». Kamomad o‘zi qayd etiladi."
        },
        "b4": {
          "t": "Kam isrof — ko‘p foyda",
          "d": "Nima va qancha summaga buzilish arafasida ekani ko‘rinadi — vaqtida ishlatib yoki aksiyaga qo‘yib ulgurasiz."
        },
        "f1": "FEFO: avval tezroq tugaydigani ketadi",
        "f2": "Partiya muddati: xaridda yoki saqlash muddati bo‘yicha o‘zi",
        "f3": "Ilovada va Telegramda «tugayapti» bildirishnomasi",
        "f4": "Chop etiladigan dalolatnoma bilan ko‘chirishlar",
        "f5": "Har bir ombor bo‘yicha qoldiq va harakat kartasi",
        "f6": "Alohida ombor inventarizatsiyasi",
        "who": "Oshxona va bari bor muassasalar, markaziy omborli tarmoqlar va tez buziladigan mahsulotlar bilan ishlaydiganlar uchun."
      },
      "production": {
        "title": "Yarim tayyor mahsulot ishlab chiqarish",
        "tagline": "Xamir, souslar, sho‘rvalar va tayyorgarliklar — texnologik karta bo‘yicha, aniq tannarx va yaroqlilik muddati bilan. Oshpaz kunlik rejani, siz har bir kilogramm narxini ko‘rasiz.",
        "b1": {
          "t": "Kunlik reja",
          "d": "Oshxona bugun nimani va qancha tayyorlashni ko‘radi: «rejalashtirilgan» → «ishda» → «tayyor»."
        },
        "b2": {
          "t": "Tiyinigacha aniq tannarx",
          "d": "Xom ashyo texnologik karta bo‘yicha hisobdan chiqadi, YTM tannarxi = xom ashyo narxi ÷ haqiqiy chiqim. U taomlar tannarxiga ham kiradi."
        },
        "b3": {
          "t": "Chiqim nazorati",
          "d": "Haqiqiy chiqimning rejadan og‘ishi darhol ko‘rinadi — mahsulot qayerda yo‘qolayotgani tushunarli."
        },
        "b4": {
          "t": "Yorliqlar va muddatlar",
          "d": "YTM partiyasi yaroqlilik muddatini oladi, yorliq bir bosishda chop etiladi: nomi, sana, muddat, oshpaz."
        },
        "f1": "Ish boshlanishidan oldin xom ashyo ehtiyoji va kamomad",
        "f2": "Bir amalda chiqarish: xom ashyo chiqarildi, YTM omborda",
        "f3": "Texnologik kartadan farq qilsa, o‘z sarfi",
        "f4": "Sotuvda un va suv emas, tayyor YTM hisobdan chiqadi",
        "f5": "Hisobot: reja, fakt, chiqim og‘ishi, tannarx",
        "f6": "Chiqarishni bekor qilish — xom ashyoni qaytarish bilan storno",
        "who": "Pitsseriyalar, novvoyxonalar, tayyorgarligi bor kafelar va sous hamda yarim tayyor mahsulotni oldindan tayyorlaydigan oshxonalar uchun."
      },
      "procurement": {
        "title": "Xaridlar va yetkazib beruvchilar",
        "tagline": "Barcha yetkazib beruvchilar, ularning hisoblari, to‘lov muddatlari va qarzlari — bitta oynada. Daftarsiz va unutilgan to‘lovlarsiz.",
        "b1": {
          "t": "Yetkazib beruvchilarga qarz nazoratda",
          "d": "Qancha, kimga va qaysi sanagacha to‘lash kerak — kechikish eslatmalari bilan."
        },
        "b2": {
          "t": "To‘lovlar va avanslar",
          "d": "Kassadan naqd yoki o‘tkazma, qismlab yoki oldindan — hammasi o‘zi mos keladi."
        },
        "b3": {
          "t": "Yetkazib beruvchiga qaytarish",
          "d": "Tovar qaytarildi — qarz xarid narxlari bo‘yicha o‘zi kamayadi."
        },
        "b4": {
          "t": "Bir daqiqada solishtirish dalolatnomasi",
          "d": "Davr bo‘yicha dalolatnomani chop etib, yetkazib beruvchi bilan masalalarni yopasiz."
        },
        "f1": "To‘lov muddati bilan yetkazib beruvchilar ma’lumotnomasi",
        "f2": "Xarid = muddatli yetkazib beruvchi hisobi",
        "f3": "To‘lov muddati va kechikish haqida bildirishnoma",
        "f4": "Tovar qaytarish va yetkazib beruvchidan pul qaytarish",
        "f5": "Har biridan nima va qanchaga xarid qilingani",
        "f6": "A4 solishtirish dalolatnomasi",
        "who": "Yetkazib beruvchilar bilan qarzga yoki kechiktirib ishlaydiganlarning barchasi uchun."
      },
      "finance": {
        "title": "Muassasa moliyasi",
        "tagline": "Foyda, xarajatlar va pul oqimi — oy oxirida emas, har kuni. Pul qayerga ketayotgani va aslida qancha topayotganingiz ko‘rinadi.",
        "b1": {
          "t": "Istalgan davr uchun foyda",
          "d": "Tushum, tannarx, ish haqi, ijara va boshqa xarajatlar — bitta hisobotda."
        },
        "b2": {
          "t": "Toifalar bo‘yicha xarajatlar",
          "d": "Ijara, kommunal, marketing — soniyalarda kiritiladi, hisobot o‘zi hisoblaydi."
        },
        "b3": {
          "t": "Pul oqimi",
          "d": "Naqd va naqdsiz qancha kelib-ketdi, sizga va sizdan qancha qarz."
        },
        "b4": {
          "t": "Raqamlarga asoslangan qarorlar",
          "d": "Nimani qisqartirish va nimani rivojlantirish kerakligi tushunarli."
        },
        "f1": "Foyda va zarar hisoboti",
        "f2": "Toifa va filial bo‘yicha xarajatlar",
        "f3": "Ish haqi va choychaqalar hisobotga o‘zi tushadi",
        "f4": "Mehmon va yetkazib beruvchilar qarzi — pul oqimida",
        "f5": "Kassadan xarajatlar — darhol hisobotda",
        "who": "Faqat tushumni emas, haqiqiy foydani bilmoqchi bo‘lgan egalar uchun."
      },
      "fraud": {
        "title": "Suiiste’moldan himoya",
        "tagline": "Tizim har soatda o‘chirishlar, chegirmalar, qaytarishlar va kamomadlarni tekshiradi va shubhali holat haqida darhol xabar beradi. Siz yo‘q paytda ham kassa nazoratda.",
        "b1": {
          "t": "Shubhali holat darhol ko‘rinadi",
          "d": "Oshxonadan keyingi o‘chirishlar, karta uchun naqd qaytarish, me’yordan ortiq chegirmalar — bitta lentada."
        },
        "b2": {
          "t": "Xodimlar bo‘yicha xavf",
          "d": "Har bir xodimning xavf balli bor: kimga e’tibor berish kerakligi ko‘rinadi."
        },
        "b3": {
          "t": "Telegramdagi bildirishnomalar",
          "d": "Jiddiysi — darhol, haftada bir marta — xulosa."
        },
        "b4": {
          "t": "Sizning qoidalaringiz",
          "d": "Har bir qoida chegarasi muassasangizga moslanadi."
        },
        "f1": "Oshxonadan keyin pozitsiyalarni o‘chirish va bekor qilish",
        "f2": "Qaytarishlar, jumladan karta uchun naqd",
        "f3": "Qo‘lda berilgan chegirmalar ulushi va menyudan arzon sotuv",
        "f4": "Odatdan tashqari katta hisobdan chiqarishlar",
        "f5": "Kassadagi kamomadlar va ularning takrorlanishi",
        "f6": "Qarorlar: tekshirildi, soxta xavotir, tasdiqlandi",
        "who": "Har kuni muassasada bo‘la olmaydigan egalar uchun."
      },
      "sms": {
        "title": "Mehmonlarga SMS-xabarnomalar",
        "tagline": "Kerakli paytda o‘zingizni eslating: aksiya, yangi menyu, tug‘ilgan kun tabrigi. Tanlangan mehmonlarga ikki bosishda jo‘natish.",
        "b1": {
          "t": "Aniq nishonga",
          "d": "Segmentlar va teglar: doimiylar, anchadan beri kelmaganlar, haftaning tug‘ilgan kunlari."
        },
        "b2": {
          "t": "Faqat rozilik bilan",
          "d": "Xabar olishga rozi bo‘lgan mehmonlargagina jo‘natiladi."
        },
        "b3": {
          "t": "Shaffof sarf",
          "d": "Oyda qancha SMS qolgani ko‘rinadi; 80% va 100% da ogohlantirish keladi."
        },
        "b4": {
          "t": "Mehmonlarni qaytaring",
          "d": "SMSdagi qisqa taklif — va mehmon yana sizda."
        },
        "f1": "Segment yoki teg bo‘yicha jo‘natish",
        "f2": "Tug‘ilgan kun tabriklari",
        "f3": "Jo‘natishdan oldin SMS qismlarini hisoblash",
        "f4": "O‘zingizga sinov SMS",
        "f5": "Yetkazish holatlari",
        "who": "Doimiy mijozlarni ko‘proq ko‘rishni istagan, mehmonlar bazasi bor muassasalar uchun."
      },
      "services": {
        "title": "Xizmatlar va ijara",
        "tagline": "Karaoke, bilyard, qalyon, VIP-xonalar — serverdagi taymer bilan soatbay tariflash, minimal buyurtma va xodimlar komissiyalari o‘zi hisoblanadi.",
        "b1": {
          "t": "Ishonchli taymer",
          "d": "Vaqt serverda yuradi, pauzalar hisobga olinadi — mehmon bilan bahs yo‘q."
        },
        "b2": {
          "t": "Moslashuvchan tariflar",
          "d": "Soat narxi, yaxlitlash qadami, minimum, bosqichlar va jadval bo‘yicha narx."
        },
        "b3": {
          "t": "Xonaning minimal buyurtmasi",
          "d": "Yetmasa — qo‘shimcha to‘lov hisobga o‘zi qo‘shiladi."
        },
        "b4": {
          "t": "Xodimlarga komissiyalar",
          "d": "Belgilangan, foiz yoki aralash — darhol hisobotda."
        },
        "f1": "Soatbay va donali xizmatlar",
        "f2": "Minimal buyurtmali xonalar",
        "f3": "Seansni to‘xtatish va davom ettirish",
        "f4": "Xizmat darhol mehmon hisobida",
        "f5": "Xodimlar komissiyalari va hisobot",
        "who": "Karaoke, launj-barlar, bilyardxonalar, qalyonxonalar va VIP-xonali muassasalar uchun."
      },
      "banquets": {
        "title": "Banketlar va tadbirlar",
        "tagline": "Arizadan hisobni yopishgacha: mehmonga menyu, depozitlar, zallarni bron qilish va tannarx — barchasi banketning bitta kartasida.",
        "b1": {
          "t": "Birorta ariza yo‘qolmaydi",
          "d": "Ariza → dastlabki → tasdiqlangan → ketmoqda → yakunlangan."
        },
        "b2": {
          "t": "Chalkashliksiz depozitlar",
          "d": "Depozit qabul qilinadi va banket hisobiga o‘zi o‘tkaziladi."
        },
        "b3": {
          "t": "Zal ikki marta sotilmaydi",
          "d": "Tasdiqlangan banket zalni bronlar uchun bloklaydi."
        },
        "b4": {
          "t": "Tannarx va mahsulotlar",
          "d": "Banket marjasi va qancha mahsulot sotib olish kerakligi darhol ko‘rinadi."
        },
        "f1": "Mehmonga va butun dasturxonga menyu",
        "f2": "Naqd va o‘tkazma bilan depozitlar",
        "f3": "Tijoriy taklifni chop etish",
        "f4": "Texnologik karta bo‘yicha mahsulot ehtiyoji",
        "f5": "Kassada banket buyurtmasi bir bosishda",
        "who": "Bayram va korporativlarni qabul qiladigan restoranlar, banket zallari va kafelar uchun."
      },
      "promotions_pro": {
        "title": "Aksiyalar va promokodlar",
        "tagline": "Baxtli soatlar, kombo, «ikkinchisi sovg‘a», sovg‘alar va promokodlar — kassa kassir xatosisiz eng foydali aksiyani o‘zi qo‘llaydi.",
        "b1": {
          "t": "Har qanday mexanika",
          "d": "Foiz yoki summa bilan chegirma, kombo, «1+1», buyurtmaga sovg‘a."
        },
        "b2": {
          "t": "Aniq shartlar",
          "d": "Hafta kunlari, soatlar, sanalar, filiallar, buyurtma turi, birinchi buyurtma, mehmon tegi."
        },
        "b3": {
          "t": "Ziddiyatsiz",
          "d": "Eksklyuziv va mos aksiyalar: mehmon eng foydalisini oladi."
        },
        "b4": {
          "t": "Natija raqamlarda",
          "d": "Hisobot: aksiya necha marta ishladi va qanchaga tushdi."
        },
        "f1": "Baxtli soatlar, jumladan yarim tundan o‘tib",
        "f2": "Limitli promokodlar",
        "f3": "Kombo-to‘plamlar va «1+1»",
        "f4": "Buyurtmaga sovg‘a",
        "f5": "Aksiyalar bo‘yicha hisobot",
        "who": "Tinch soatlarni to‘ldirib, o‘rtacha chekni oshirmoqchi bo‘lgan muassasalar uchun."
      },
      "delivery": {
        "title": "O‘z yetkazib berish xizmati",
        "tagline": "Xaritadagi zonalar, kuryerlar, holatlar va kuryerlardagi pul — yetkazib berish soatdek ishlaydi, mehmon buyurtma holatini ko‘radi.",
        "b1": {
          "t": "Zonalar va narx",
          "d": "Poligonlar va radiuslar, minimal buyurtma, summadan boshlab bepul yetkazish."
        },
        "b2": {
          "t": "Yetkazishlar doskasi",
          "d": "Yangi → tayyorlanmoqda → yo‘lda → yetkazildi: taymerlar kechikishni ko‘rsatadi."
        },
        "b3": {
          "t": "Kuryer ekrani",
          "d": "«Mening yetkazishlarim», holatlar va joylashuv — telefondan."
        },
        "b4": {
          "t": "Naqd pul nazoratda",
          "d": "Har bir kuryerda qancha pul borligi ko‘rinadi; kassaga topshirish — bir bosishda."
        },
        "f1": "Manzilni zona bo‘yicha tekshirish",
        "f2": "Kuryer tayinlash",
        "f3": "Mehmon uchun yetkazish holati",
        "f4": "Kuryerning naqd pulni topshirishi",
        "f5": "Yetkazishlar bo‘yicha hisobot",
        "who": "O‘z kuryerlari bor muassasalar uchun."
      },
      "reservations": {
        "title": "Stollarni bron qilish",
        "tagline": "Kassada va ERPda bronlar: stol oldindan bron qilingan deb belgilanadi — hech kim mehmonlarni boshqaning joyiga o‘tqazmaydi.",
        "b1": {
          "t": "Bronlar bilan zal",
          "d": "Qaysi stollar band, bo‘sh va bron qilinganligi ko‘rinadi."
        },
        "b2": {
          "t": "Ustma-ustsiz",
          "d": "Bitta stolga kesishuvchi bron yaratib bo‘lmaydi."
        },
        "b3": {
          "t": "Bir soat oldin «bron»",
          "d": "Mehmonlar kelishidan oldin stol o‘zi belgilanadi."
        },
        "b4": {
          "t": "Mehmon tarixi",
          "d": "Bron mijoz kartasiga bog‘lanadi."
        },
        "f1": "Kassadan va ERPdan bronlar",
        "f2": "Mehmonlar soni va izoh",
        "f3": "Ko‘chirish va bekor qilish",
        "f4": "Kassada internetsiz ham ishlaydi",
        "f5": "Kunlik bronlar ro‘yxati",
        "who": "Stollar oldindan bron qilinadigan restoran va kafelar uchun."
      },
      "analytics_pro": {
        "title": "Kengaytirilgan tahlil",
        "tagline": "ABC-tahlil, menyu-injiniring, food cost va yuklama issiqlik xaritasi — qaysi taomlar biznesni boqayotgani va qaysilari orqaga tortayotgani ko‘rinadi.",
        "b1": {
          "t": "Menyu-injiniring",
          "d": "Yulduzlar, ishchi otlar, jumboqlar va autsayderlar: nimani targ‘ib qilish, qayta ishlash yoki olib tashlash kerak."
        },
        "b2": {
          "t": "ABC-tahlil",
          "d": "Pozitsiyalarning qaysi 20% i tushum va marjaning 80% ini beradi."
        },
        "b3": {
          "t": "Food cost va labor cost",
          "d": "Kunlar va toifalar bo‘yicha mahsulot va mehnat tannarxi."
        },
        "b4": {
          "t": "Issiqlik xaritasi",
          "d": "Hafta kunlari va soatlar bo‘yicha yuklama — haqiqiy mehmon oqimiga mos smena jadvali."
        },
        "f1": "Tushum, marja, miqdor, mahsulot va mehmon bo‘yicha ABC",
        "f2": "Menyu matritsasi",
        "f3": "Prime cost va mehnat soatiga tushum",
        "f4": "Filiallarni solishtirish",
        "f5": "Excel uchun CSV yuklab olish",
        "who": "Raqamlarga tayanib qaror qabul qiladigan egalar va boshqaruvchilar uchun."
      },
      "telegram": {
        "title": "Egasining Telegram-boti",
        "tagline": "Kunlik tushum, ombor, yetkazib beruvchilarga to‘lovlar va xavotirlar — qayerda bo‘lmang, to‘g‘ridan-to‘g‘ri Telegramda.",
        "b1": {
          "t": "Kunlik hisobot",
          "d": "Har kechqurun — tushum, cheklar, o‘rtacha chek, eng ko‘p sotilgan taomlar."
        },
        "b2": {
          "t": "Muhimi — darhol",
          "d": "Qaytarishlar, smenani yopish, «omborda tugayapti»."
        },
        "b3": {
          "t": "/today buyrug‘i",
          "d": "Kun natijalari so‘rov bo‘yicha bitta xabarda."
        },
        "b4": {
          "t": "Har kimga o‘ziniki",
          "d": "Xodim faqat huquqi yetganlarini oladi."
        },
        "f1": "Filiallar bo‘yicha kunlik hisobot",
        "f2": "Smenalar va qaytarishlar haqida bildirishnomalar",
        "f3": "Ombor: tugayapti va muddati o‘tmoqda",
        "f4": "Yetkazib beruvchilarga to‘lovlar",
        "f5": "Bitta havola orqali ulash",
        "who": "Vaziyatdan doim xabardor bo‘lishni istagan egalar va boshqaruvchilar uchun."
      },
      "qr_ordering": {
        "title": "QR-kod orqali buyurtma",
        "tagline": "Mehmon stoldagi QRni skanerlaydi, taom tanlaydi va buyurtma yuboradi — u darhol kassada va oshxonada paydo bo‘ladi. Kutish kam, buyurtma ko‘p.",
        "b1": {
          "t": "Ofitsiantni kutmasdan",
          "d": "Mehmon tayyor bo‘lganda buyurtma beradi — va ko‘proq oladi."
        },
        "b2": {
          "t": "To‘g‘ri oshxonaga",
          "d": "Buyurtma oshxona ekraniga o‘zi ketadi."
        },
        "b3": {
          "t": "Ofitsiant va hisobni chaqirish",
          "d": "Mehmon telefonidagi tugmalar — kassada bildirishnoma."
        },
        "b4": {
          "t": "Buyurtma holati",
          "d": "Mehmon taom tayyorlanayotganini ko‘radi."
        },
        "f1": "Har bir stol uchun chop etiladigan QR",
        "f2": "Taom variantlari va modifikatorlari",
        "f3": "O‘sha hisobga qo‘shimcha buyurtma",
        "f4": "Buyurtma spamidan himoya",
        "f5": "Ofitsiantlarga bildirishnomalar",
        "who": "Zalda xizmat ko‘rsatiladigan kafe va restoranlar uchun."
      },
      "debts": {
        "title": "Mehmonlar qarzlari",
        "tagline": "Doimiy mehmonlarga va kompaniya xodimlariga «qarzga» sotish — limit, muddat va kassada to‘lash bilan. Daftarsiz.",
        "b1": {
          "t": "Mehmonga limit",
          "d": "Kassa kredit limitidan oshirishga yo‘l qo‘ymaydi."
        },
        "b2": {
          "t": "Kassada to‘lash",
          "d": "Smena orqali naqd; qarz o‘zi yopiladi, eskilari — birinchi."
        },
        "b3": {
          "t": "Kechikish hisoboti",
          "d": "Kim, qancha va qachondan beri qarzdor."
        },
        "b4": {
          "t": "Tuzatish va hisobdan chiqarish",
          "d": "Hammasi sababi bilan va jurnalda."
        },
        "f1": "Kassada «qarzga» to‘lash",
        "f2": "Qismlab to‘lash",
        "f3": "Qarzlar muddati",
        "f4": "Har bir mehmon tarixi",
        "f5": "Umidsiz qarzni hisobdan chiqarish",
        "who": "Doimiy mehmonlari va korporativ mijozlari bor muassasalar uchun."
      }
    }
  },
  "invSettings": {
    "title": "Ombor sozlamalari",
    "description": "Kompaniyaning barcha omborlari uchun qoidalar.",
    "expiry": "Yaroqlilik muddati",
    "blockExpired": "Muddati o‘tgan partiyalardan sotmaslik",
    "blockExpiredHint": "Sotuv avval yangi partiyalarni oladi; muddati o‘tganlari — boshqasi qolmasagina, va hisobdan chiqarishni kutadi",
    "warningDays": "Necha kun oldin ogohlantirish",
    "warningDaysHint": "Muddati shu davrda tugaydigan partiyalar «Tez orada tugaydi» va ertalabki bildirishnomaga tushadi",
    "production": "Ishlab chiqarish",
    "explode": "Yarim tayyor mahsulot yo‘q — xom ashyo bilan hisobdan chiqarish",
    "explodeHint": "Tayyor yarim tayyor mahsulot yetmasa, sotuv uning texnologik kartasi bo‘yicha xom ashyoni hisobdan chiqaradi. O‘chirsangiz — yarim tayyor mahsulot minusga ketadi va tayyorlanmagani ko‘rinadi",
    "safety": "Ishlab chiqarish rejasi bashoratiga zaxira",
    "safetyHint": "O‘rtacha sarfdan necha foiz ko‘p tayyorlash",
    "nothing": "Sozlamalar «Ombor (kengaytirilgan)» yoki «Ishlab chiqarish» qo‘shimchalari bilan paydo bo‘ladi."
  },
  "locations": {
    "title": "Saqlash joylari",
    "short": "Joy",
    "description": "«{{name}}» ombori: javonlar, muzlatkichlar, zonalar",
    "placeholder": "Masalan: №1 muzlatkich",
    "name": "Joy nomi",
    "add": "Qo‘shish",
    "empty": "Hozircha joylar yo‘q",
    "emptyHint": "Javon va muzlatkichlarni qo‘shing — ular bo‘yicha inventarizatsiya qilish qulay.",
    "products": "Mahsulotlar: {{count}}",
    "deleteTitle": "«{{name}}» joyini o‘chirasizmi?",
    "deleteHint": "Mahsulotlar omborda joysiz qoladi.",
    "hint": "Mahsulotni joyga «Qoldiqlar» bo‘limida biriktirish mumkin: «Joy» ustuni.",
    "all": "Barcha joylar",
    "pick": "Joyni tanlang",
    "countHint": "Shu joyga biriktirilgan mahsulotlar sanaladi"
  },
  "purchaseRequests": {
    "tabRequests": "So‘rovlar",
    "tabSuggest": "Nima buyurtma qilish kerak",
    "suggest": {
      "purchaseComment": "Tavsiyalar bo‘yicha: sarf va qoldiqlar",
      "coverDays": "Necha kunga",
      "days": "{{count}} kun",
      "history": "Sarfni ko‘rish",
      "lastDays": "{{count}} kunda",
      "safety": "Zaxira",
      "showAll": "Sarfi borlarning hammasini ko‘rsatish",
      "how": "{{history}} kunlik sarf (texkartalar bo‘yicha sotuvlar, hisobdan chiqarishlar, ishlab chiqarish) → oxirgi haftani hisobga olgan kunlik prognoz → {{cover}} kunga +{{safety}}% zaxira, qo‘shuv minimal qoldiq, ayiruv qoldiq va so‘rovlardagi miqdor.",
      "summaryMoney": "Buyurtma qilishni tavsiya qilamiz: {{count}} pozitsiya, taxminan {{sum}}",
      "summary": "Buyurtma qilishni tavsiya qilamiz: {{count}} pozitsiya",
      "summaryHint": "Keraklisini belgilang, miqdorni to‘g‘rilang va so‘rov yoki darhol xarid yarating. Summa — oxirgi xarid narxi bo‘yicha.",
      "selectAll": "Hammasini tanlash",
      "lastPurchase": "{{date}} sotib olingan",
      "stock": "Qoldiq",
      "daysLeft": "~{{n}} kunga yetadi",
      "daily": "Kunlik sarf",
      "trendUp": "hafta: +{{pct}}%",
      "trendDown": "hafta: −{{pct}}%",
      "pending": "So‘rovlarda bor",
      "order": "Buyurtma",
      "estimate": "Taxminan",
      "why": "Nega",
      "reasons": {
        "negative": "Minusda",
        "below_min": "Minimumdan past",
        "runs_out": "Tez orada tugaydi",
        "low_data": "Ma’lumot kam"
      },
      "empty": "Hozircha buyurtma qilinadigan narsa yo‘q",
      "emptyHint": "Sarf texkartali sotuvlar va hisobdan chiqarishlar bo‘yicha hisoblanadi. Mahsulot kartasida minimal qoldiqni belgilang — qachon sotib olish kerakligini aytamiz.",
      "toRequest": "So‘rov yaratish"
    },
    "title": "Xarid so‘rovlari",
    "description": "Xodimlar nima sotib olish kerakligini yozadi — boshqaruvchi tasdiqlaydi, so‘rov bo‘yicha sotib oladi yoki rad etadi. Kim va qachon yozgani, qaror qilgani ko‘rinadi.",
    "new": "Yangi so‘rov",
    "newHint": "Nima va qancha sotib olish kerak. Mahsulotni ma’lumotnomadan tanlang yoki shunchaki nomini yozing.",
    "send": "So‘rovni yuborish",
    "addLines": "Miqdori bilan kamida bitta qator qo‘shing",
    "saved": "So‘rov saqlandi",
    "created": "№{{n}} so‘rov yuborildi",
    "editTitle": "№{{n}} so‘rov: o‘zgartirish",
    "what": "Nima sotib olish kerak",
    "whatPlaceholder": "Mahsulot yoki nomi",
    "addAsText": "«{{name}}»ni ma’lumotnomasiz qo‘shish",
    "lineNote": "Qatorga izoh",
    "lineNotePlaceholder": "Izoh: markasi, yog‘liligi, o‘lchami…",
    "priority": "Shoshilinchlik",
    "priorities": {
      "normal": "Oddiy",
      "urgent": "Shoshilinch"
    },
    "neededBy": "Qachongacha kerak",
    "neededByShort": "{{date}} gacha kerak",
    "comment": "Izoh",
    "commentHint": "Nima uchun, qaysi tadbirga, qayerdan sotib olgan yaxshi",
    "commentPlaceholder": "Masalan: shanbadagi banketga, sut tugayapti",
    "rejectReason": "Rad etish sababi",
    "rejectReasonRequired": "Rad etish sababini ko‘rsating",
    "decisionNote": "Muallif uchun izoh",
    "done": {
      "approve": "№{{n}} so‘rov tasdiqlandi",
      "reject": "№{{n}} so‘rov rad etildi",
      "purchased": "№{{n}} so‘rov yopildi — sotib olindi"
    },
    "decision": {
      "approve": "№{{n}} so‘rov tasdiqlansinmi?",
      "reject": "№{{n}} so‘rov rad etilsinmi?",
      "purchased": "№{{n}} so‘rov «sotib olindi» deb belgilansinmi?"
    },
    "decisionHint": {
      "approve": "Muallif bildirishnoma oladi. Darhol sotib olish mumkin — «Xaridni rasmiylashtirish» tugmasi.",
      "reject": "Muallif rad etish sababini ko‘radi.",
      "purchased": "Omborga kiritilmaydigan xarid uchun. Tovar omborga kelishi uchun — «Xaridni rasmiylashtirish»."
    },
    "actions": {
      "approve": "Tasdiqlash",
      "reject": "Rad etish",
      "purchased": "Sotib olindi",
      "cancel": "Qaytarib olish",
      "makePurchase": "Xaridni rasmiylashtirish"
    },
    "cancelTitle": "№{{n}} so‘rov qaytarib olinsinmi?",
    "history": {
      "created": "Yaratdi",
      "updated": "O‘zgartirdi",
      "approved": "Tasdiqladi",
      "rejected": "Rad etdi",
      "purchased": "Sotib oldi",
      "cancelled": "Qaytarib oldi"
    },
    "titleN": "№{{n}} xarid so‘rovi",
    "purchaseLink": "{{date}} dagi xarid, {{sum}}",
    "commentBy": "{{name}} izohi",
    "rejectedTitle": "Rad etildi: {{name}}",
    "noteFrom": "{{name}} izohi",
    "notInCatalog": "ma’lumotnomada yo‘q",
    "statuses": {
      "submitted": "Qaror kutilmoqda",
      "approved": "Tasdiqlandi",
      "purchased": "Sotib olindi",
      "rejected": "Rad etildi",
      "cancelled": "Qaytarib olindi"
    },
    "pending": "Qaror kutilmoqda: {{count}}",
    "pendingHint": "Xodimlar javob kutmoqda — tasdiqlang, sotib oling yoki rad eting.",
    "show": "Ko‘rsatish",
    "approvedCount": "Tasdiqlangan va xaridni kutmoqda: {{count}}",
    "approvedHint": "So‘rovni oching va «Xaridni rasmiylashtirish»ni bosing — qatorlar o‘zi to‘ldiriladi.",
    "scope": "Kimning so‘rovlari",
    "scopeAll": "Hammasi",
    "scopeMine": "Meniki",
    "search": "Tovar yoki izoh bo‘yicha qidirish",
    "author": "Kim yozdi",
    "empty": "Hozircha so‘rovlar yo‘q",
    "emptyHint": "Biror narsa tugayaptimi? So‘rov yozing — boshqaruvchi uni darhol ko‘radi.",
    "purchaseComment": "№{{n}} xarid so‘rovi bo‘yicha",
    "purchaseFor": "№{{n}} so‘rov bo‘yicha xarid ({{name}})",
    "textLinesHint": "Ma’lumotnomada yo‘q — qo‘lda qo‘shing: {{lines}}"
  },
  "requests": {
    "title": "Omborga buyurtmalar",
    "description": "Filial markaziy ombordan tovar buyurtma qiladi, ombor uni ko‘chirish orqali jo‘natadi, filial qabul qiladi.",
    "new": "Yangi buyurtma",
    "newHint": "Omboringizga nima va qancha kerak. Yetkazib beruvchi ombor bildirishnoma oladi.",
    "send": "Buyurtma yuborish",
    "supplier": "Qaysi ombordan",
    "supplierHint": "Odatda tarmoqning markaziy ombori",
    "target": "Qaysi omborga",
    "neededBy": "Qachongacha kerak",
    "commentPlaceholder": "Masalan: dam olish kunlariga, banket kutilmoqda",
    "pickSupplier": "Yetkazib beruvchi omborni tanlang",
    "created": "№{{n}} buyurtma yuborildi: {{wh}}",
    "titleN": "№{{n}} buyurtma",
    "ship": "Jo‘natish",
    "reject": "Rad etish",
    "cancel": "Qaytarib olish",
    "shippedToast": "№{{n}} buyurtma jo‘natildi — tovar yo‘lda",
    "rejectTitle": "№{{n}} buyurtma rad etilsinmi?",
    "rejectHint": "Filial rad etish sababini ko‘radi.",
    "rejectReason": "Rad etish sababi",
    "openTransfer": "№{{n}} ko‘chirish",
    "transferN": "№{{n}} ko‘chirish",
    "neededByShort": "{{date}} gacha kerak",
    "rejected": "Rad etildi",
    "shipHint": "Miqdorni tekshiring: buyurtmadan kamroq yoki tovar bo‘lmasa 0 jo‘natish mumkin. «Yo‘lda» ko‘chirish yaratiladi.",
    "ordered": "Buyurtma qilingan",
    "ourStock": "Bizning omborda",
    "toShip": "Jo‘natish",
    "shipped": "Jo‘natilgan",
    "createdBy": "Yaratgan: {{name}}, {{at}}",
    "decidedBy": "Qaror: {{name}}, {{at}}",
    "statuses": {
      "submitted": "Jo‘natish kutilmoqda",
      "shipped": "Jo‘natildi",
      "received": "Olindi",
      "rejected": "Rad etildi",
      "cancelled": "Qaytarib olindi"
    },
    "incoming": "Omboringizga buyurtmalar: {{count}}",
    "incomingHint": "Filiallar tovar kutmoqda — jo‘nating yoki rad eting.",
    "dirOut": "Bizning buyurtmalar",
    "dirIn": "Bizning omborga",
    "empty": "Hozircha buyurtmalar yo‘q",
    "emptyHint": "Markaziy ombordan tovar buyurtma qiling — u ko‘chirish orqali keladi."
  },
  "conversions": {
    "title": "Bo‘laklash va yig‘ish",
    "description": "Bo‘laklash: tana → lahm go‘sht, yumshoq go‘sht, suyaklar. Yig‘ish: bir nechta tovar → to‘plam. Tannarx chiqishlar orasida bo‘linadi.",
    "new": "Bo‘laklash yoki yig‘ish",
    "post": "O‘tkazish",
    "type": "Amal",
    "types": {
      "disassembly": "Bo‘laklash",
      "assembly": "Yig‘ish"
    },
    "disHint": "Kirishda bitta mahsulot — chiqishda bir nechta. Kirish tannarxi ulushlar bo‘yicha bo‘linadi; ulushsiz — chiqishlarning xarid narxiga (yoki miqdoriga) mutanosib.",
    "asmHint": "Kirishda bir nechta mahsulot — chiqishda bitta. Uning tannarxi = kirishlar yig‘indisi.",
    "template": "Shablon",
    "pickTemplate": "Shablondan to‘ldirish",
    "inputDis": "Nimani bo‘laklaymiz",
    "inputAsm": "Nimadan yig‘amiz",
    "outputDis": "Nima chiqdi",
    "outputAsm": "Nima yig‘ildi",
    "byShares": "Tannarx ulushlarini ko‘rsatish",
    "share": "Ulush",
    "sharesSum": "Ulushlar yig‘indisi: {{pct}}%",
    "autoHint": "Ulushlar o‘zi hisoblanadi: chiqishlarning xarid narxi bo‘yicha, u bo‘lmasa — miqdor bo‘yicha.",
    "preview": "Taxmin: oxirgi xarid narxi bo‘yicha {{sum}}",
    "fill": "Kirish va chiqishni to‘ldiring",
    "shares100": "Ulushlar yig‘indisi 100% bo‘lishi kerak",
    "doneDis": "Bo‘laklash o‘tkazildi",
    "doneAsm": "Yig‘ish o‘tkazildi",
    "tplName": "Shablon nomi, masalan «Mol tanasi»",
    "saveTemplate": "Shablon sifatida saqlash",
    "tplFill": "Shablon nomi va qatorlarini kiriting",
    "tplSaved": "Shablon saqlandi",
    "templates": "Shablonlar",
    "useTemplate": "Shablon bo‘yicha o‘tkazish",
    "tplDeleteTitle": "«{{name}}» shablonini o‘chirasizmi?",
    "deleteTitle": "Amal bekor qilinsinmi?",
    "deleteHint": "Kirish omborga qaytadi, chiqishlar hisobdan chiqariladi. Chiqishlar ishlatib bo‘lingan bo‘lsa — bekor qilish o‘tmaydi.",
    "cancelDoc": "Bekor qilish",
    "dist": {
      "share": "Ulushlar bo‘yicha",
      "price": "Xarid narxi bo‘yicha",
      "qty": "Miqdor bo‘yicha"
    },
    "input": "Kirish",
    "output": "Chiqish",
    "unitCost": "Tannarx",
    "search": "Mahsulot yoki izoh",
    "what": "Nima → nimaga",
    "empty": "Hozircha amallar yo‘q",
    "emptyHint": "Tanani bo‘laklang yoki sovg‘a to‘plamini yig‘ing — qoldiqlar va tannarx o‘zi yangilanadi."
  },
  "help": {
    "title": "Ma’lumotnoma",
    "description": "Coca’ning har bir funksiyasini qanday sozlash va ishlatish — maqolalar: {{count}}",
    "search": "Ma’lumotnomadan qidirish",
    "searchPlaceholder": "Masalan: xaridni qanday o‘tkazish, Z-hisobot, texnologik karta…",
    "results": "«{{q}}» bo‘yicha topildi: {{count}}",
    "noResults": "Hech narsa topilmadi",
    "noResultsHint": "Boshqa so‘zlar bilan urinib ko‘ring yoki qo‘llab-quvvatlashga yozing.",
    "popular": "Nimadan boshlash",
    "videos": "Video darslar",
    "videosHint": "Qisqa roliklar: ekranda qanday qilinadi",
    "video": "Video",
    "sections": "Ma’lumotnoma bo‘limlari",
    "allArticles": "Barcha maqolalar ({{count}})",
    "contents": "Ma’lumotnoma mundarijasi",
    "breadcrumbs": "Yo‘l",
    "inPlan": "Tarifda bor: {{name}}",
    "notInPlan": "Ulanmagan: {{name}}",
    "noPermission": "Rolingizda kirish huquqi yo‘q",
    "openSection": "Bo‘limni ochish",
    "howToConnect": "Qanday ulash",
    "related": "Bog‘liq maqolalar",
    "notFound": "Javob topmadingizmi?",
    "notFoundHint": "Savolingizni yozing — qo‘llab-quvvatlash dastur ichida javob beradi.",
    "askSupport": "Qo‘llab-quvvatlashga yozish",
    "hint": "Maslahat",
    "more": "Ma’lumotnomada batafsil",
    "aboutSection": "Shu bo‘lim bo‘yicha ma’lumotnoma",
    "ruOnly": "Ma’lumotnoma hozircha rus tilida. Tarjimalar yaqin yangilanishlarda chiqadi."
  },
  goals: {
    title: "Maqsadlar va yutuqlar",
    description: "Muassasa, filial va har bir xodim uchun maqsadlar, reyting va jamoa yutuqlari. Bajarilishi har soatda avtomatik hisoblanadi.",
    myTitle: "Mening maqsadlarim",
    myDescription: "Maqsadlaringiz, yutuqlaringiz va darajangiz. Progress toʻlangan buyurtmalar boʻyicha hisoblanadi.",
    tabs: {
      goals: "Maqsadlar",
      leaderboard: "Reyting",
      achievements: "Yutuqlar",
    },
    add: "Maqsad qoʻyish",
    edit: "Maqsadni oʻzgartirish",
    scan: "Hozir tekshirish",
    scanResult: "Hisoblangan maqsadlar: {{goals}}, yangi yutuqlar: {{achievements}}",
    empty: "Hozircha maqsad yoʻq",
    emptyHint: "Kunlik tushum, oʻrtacha chek yoki taom sotuviga maqsad qoʻying — jamoa progressni koʻradi.",
    myEmpty: "Hozircha maqsad yoʻq — ularni rahbar qoʻyadi",
    showOff: "Oʻchirilganlarni koʻrsatish",
    titlePlaceholder: "Masalan: kuniga 50 000 tushum",
    pickEmployee: "Xodimni tanlang",
    allBranches: "Barcha filiallar",
    anyCategory: "Istalgan kategoriya",
    itemFilterHint: "Boʻsh — barcha taomlar",
    rewardHint: "Masalan: 1000 soʻm mukofot",
    activeHint: "Oʻchirilgan maqsad hisoblanmaydi va xodimlarga koʻrinmaydi",
    fields: {
      title: "Nomi",
      scope: "Kim uchun",
      branch: "Filial",
      employee: "Xodim",
      metric: "Nimani hisoblaymiz",
      target: "Maqsad",
      menuItem: "Taom",
      category: "Kategoriya",
      period: "Davr",
      dateFrom: "Dan",
      dateTo: "Gacha",
      reward: "Mukofot",
      points: "Bajarilgani uchun ball",
      active: "Maqsad yoqilgan",
    },
    targetHints: {
      revenue: "Davr uchun toʻlangan buyurtmalar summasi",
      orders: "Toʻlangan buyurtmalar soni",
      avg_check: "Buyurtmaning oʻrtacha summasi — davr yakuni boʻyicha hisoblanadi",
      items: "Nechta sotish kerak",
      new_customers: "Bazaga nechta mijoz qoʻshish kerak",
    },
    metrics: {
      revenue: "Tushum",
      orders: "Buyurtmalar",
      avg_check: "Oʻrtacha chek",
      items: "Sotilgan taomlar",
      new_customers: "Yangi mijozlar",
      points: "Ballar",
    },
    periods: {
      day: "Kun",
      week: "Hafta",
      month: "Oy",
      custom: "Oʻz sanalari",
    },
    periodNow: {
      day: "Bugun",
      week: "Shu hafta",
      month: "Shu oy",
      custom: "{{from}} — {{to}}",
    },
    scopes: {
      company: "Butun kompaniya",
      branch: "Filial",
      employee: "Xodim",
    },
    done: "Bajarildi",
    off: "Oʻchirilgan",
    progressOf: "{{target}} dan {{value}}",
    rewardBadge: "Mukofot: {{reward}}",
    pointsBadge: "+{{count}} ball",
    history: "Bajarilish tarixi",
    historyEmpty: "Maqsad hali bajarilmagan",
    deleteConfirm: "«{{title}}» maqsadini oʻchirasizmi?",
    deleteHint: "Bajarilish tarixi va xodimlar ballari saqlanadi.",
    rank: "Oʻrin",
    employee: "Xodim",
    value: "Natija",
    points: "Ballar",
    level: "{{level}}-daraja",
    pointsTotal: "{{count}} ball",
    leaderboardTitle: "Filial xodimlari reytingi",
    leaderboardEmpty: "Davr uchun hali sotuv yoʻq",
    pointsAllTime: "Barcha vaqt ballari: yutuqlar va bajarilgan shaxsiy maqsadlar",
    myRank: "Reytingdagi oʻrin: {{count}} dan {{rank}}",
    nextLevel: "{{level}}-darajagacha: {{count}} ball",
    maxLevel: "Eng yuqori daraja",
    earned: "{{date}} olingan",
    achievementsEarned: "Yutuqlar: {{total}} dan {{count}}",
    teamTitle: "Jamoa",
    teamHint: "Xodimlarning darajalari, ballari va olgan yutuqlari",
    teamEmpty: "Hali hech kim yutuq olmagan",
    catalogTitle: "Barcha yutuqlar",
    catalogHint: "Kassa, smena va yetkazib berishdagi harakatlar uchun avtomatik beriladi — soatiga bir marta tekshiriladi",
    tiers: {
      bronze: "Bronza",
      silver: "Kumush",
      gold: "Oltin",
      platinum: "Platina",
    },
    ach: {
      first_order: { title: "Birinchi buyurtma", hint: "Birinchi toʻlangan buyurtmani oʻtkazish" },
      orders_100: { title: "100 buyurtma", hint: "100 ta toʻlangan buyurtma oʻtkazish" },
      orders_1000: { title: "1000 buyurtma", hint: "1000 ta toʻlangan buyurtma oʻtkazish" },
      orders_5000: { title: "Zal afsonasi", hint: "5000 ta toʻlangan buyurtma oʻtkazish" },
      items_500: { title: "500 taom", hint: "500 ta pozitsiya sotish" },
      items_5000: { title: "5000 taom", hint: "5000 ta pozitsiya sotish" },
      big_table: { title: "Katta stol", hint: "10 va undan ortiq mehmonga buyurtma xizmati" },
      first_shift: { title: "Birinchi smena", hint: "Birinchi smenani ishlash" },
      shifts_50: { title: "50 smena", hint: "50 smena ishlash" },
      shifts_200: { title: "200 smena", hint: "200 smena ishlash" },
      clean_cash_10: { title: "Aniq kassa", hint: "10 ta kassa smenasini farqsiz yopish" },
      clean_cash_50: { title: "Benuqson kassa", hint: "50 ta kassa smenasini farqsiz yopish" },
      customers_10: { title: "10 yangi mijoz", hint: "Bazaga 10 mijoz qoʻshish" },
      customers_100: { title: "100 yangi mijoz", hint: "Bazaga 100 mijoz qoʻshish" },
      deliveries_10: { title: "10 yetkazish", hint: "10 ta buyurtma yetkazish" },
      deliveries_100: { title: "100 yetkazish", hint: "100 ta buyurtma yetkazish" },
      deliveries_500: { title: "500 yetkazish", hint: "500 ta buyurtma yetkazish" },
      goal_first: { title: "Birinchi maqsad", hint: "Birinchi shaxsiy maqsadni bajarish" },
      goals_10: { title: "10 maqsad", hint: "10 ta shaxsiy maqsadni bajarish" },
      goals_50: { title: "50 maqsad", hint: "50 ta shaxsiy maqsadni bajarish" },
      top_seller: { title: "Hafta sotuvchisi", hint: "Filialda hafta davomida eng katta tushum" },
    },
  },
  mixedPay: {
    label: "Aralash",
    cash: "Naqd",
    rest: "Qolgani",
    invalid: "Ikkala qism ham noldan katta bo‘lishi kerak",
    partial: "Qisman o‘tkazildi: {{paid}}. Ikkinchi qism o‘tmadi — tekshirib, qolganini to‘lang.",
  },
  menuPacks: {
    title: "Tayyor menyular",
    subtitle: "Formatingizga mos menyu: rasm va tavsifli taomlar, xarid narxlari bilan mahsulotlar, yarim tayyor mahsulotlar va kalkulyatsiyali texkartalar",
    howTitle: "Bu qanday ishlaydi",
    how: "Formatingizga mos to‘plamni tanlang va taomlarni ko‘rib chiqing. Bir marta, hisob bo‘yicha sotib olinadi. To‘lovdan keyin to‘plamni menyuga to‘liq yoki tanlab yuklang: kategoriyalar, rasmli pozitsiyalar, mahsulotlar, yarim tayyor mahsulotlar va e’lon qilingan texkartalar paydo bo‘ladi. Narx va gramajlarni keyin o‘zgartirish mumkin.",
    empty: "Hozircha tayyor menyular yo‘q",
    footer: "Tannarx Bishkekdagi xarid narxlari bo‘yicha hisoblangan — yuklangandan keyin mahsulotlaringiz narxlari bo‘yicha qayta hisoblanadi.",
    open: "Ko‘rish",
    owned: "Sotib olingan",
    counts: "{{items}} taom · {{semis}} yarim tayyor · {{products}} mahsulot",
    state: {
      available: "Sotib olish mumkin",
      pending: "To‘lov kutilmoqda",
      owned: "Sotib olingan",
    },
    stat: {
      items: "taom",
      semis: "yarim tayyor",
      products: "mahsulot",
      photos: "rasm",
    },
    avgFoodCost: "To‘plamning o‘rtacha fudkosti — {{pct}}%",
    fc: "fudkost {{pct}}%",
    minutes: "{{n}} daq",
    buy: "{{price}} ga sotib olish",
    showInvoice: "Hisobni ko‘rsatish",
    ownedNow: "To‘plam ochildi — menyuga yuklash mumkin",
    askOwner: "To‘plamni egasi yoki administrator sotib olishi mumkin («Obuna: boshqarish» huquqi).",
    noPrice: "To‘plam hozircha obunangiz valyutasida sotilmaydi — qo‘llab-quvvatlashga yozing.",
    pendingHint: "{{n}} hisobi to‘lovni kutmoqda. To‘plam to‘lovdan so‘ng darhol ochiladi.",
    currencyHint: "To‘plam narxlari somda — {{currency}} uchun konvertatsiya sozlanmagan, yuklangandan keyin narxlarni tekshiring.",
    imported: "Yuklangan: {{n}} marta",
    importAgain: "Yana yuklash",
    price: "Narxi",
    cost: "Tannarx",
    yield: "Chiqishi",
    calories: "Kkal",
    cookTime: "Tayyorlanadi",
    variants: "O‘lchamlar",
    modifiers: "Modifikatorlar",
    allergens: "Allergenlar",
    semis: "Yarim tayyor mahsulotlar",
    semiOutput: "Chiqishi {{qty}} {{unit}} · {{cost}}",
    photoCredit: "Rasm: {{author}}, {{license}}",
    photosNote: "Rasmlar — Wikimedia Commons (erkin litsenziyalar; muallif va litsenziya taom kartasida ko‘rsatilgan). Tannarx — to‘plamning xarid narxlari bo‘yicha.",
    units: {
      g: "g",
      ml: "ml",
      pcs: "dona",
    },
    recipe: {
      title: "Texkarta",
      product: "Mahsulot",
      gross: "Brutto",
      waste: "Chiqindi",
      loss: "Yo‘qotish",
      takeaway: "olib ketish uchun",
      instructions: "Tayyorlash texnologiyasi",
      locked: "Gramajlar, chiqindilar va texnologiya sotib olingandan keyin ochiladi.",
    },
    invoice: {
      title: "{{n}} hisobi",
      pack: "«{{name}}» tayyor menyusi",
      bank: "To‘lov rekvizitlari",
      after: "To‘plam hisob to‘langandan so‘ng darhol ochiladi. Barcha hisoblar — «Obuna» bo‘limida.",
      print: "Hisobni chop etish",
      all: "Barcha hisoblar",
    },
    import: {
      open: "Menyuga yuklash",
      title: "«{{name}}» ni yuklash",
      submit: "Yuklash ({{n}})",
      photos: "Taomlar rasmlari",
      recipes: "Texkartalar, mahsulotlar va yarim tayyor mahsulotlar",
      recipesHint: "Xarid narxlari bilan mahsulotlar, yarim tayyorlar va e’lon qilingan texkartalar — tannarx darhol hisoblanadi",
      inactive: "Tekshirguncha pozitsiyalarni yashirish",
      inactiveHint: "Pozitsiyalar o‘chirilgan holda yaratiladi — narxlarni tekshirgach «Menyu» bo‘limida yoqing.",
      repeatHint: "Menyuda xuddi shunday nomli pozitsiyalar o‘tkazib yuboriladi. Xuddi shunday nomli mahsulotlar, kategoriyalar va modifikator guruhlari qayta ishlatiladi.",
      done: "Yuklangan pozitsiyalar: {{n}}",
      resultTitle: "To‘plam yuklandi",
      toMenu: "Menyuni ochish",
      skipped: "Menyuda bor edi — o‘tkazib yuborildi: {{n}}",
      counts: {
        items: "Pozitsiyalar",
        categories: "Yangi kategoriyalar",
        products: "Mahsulotlar",
        semis: "Yarim tayyorlar",
        recipes: "Texkartalar",
        groups: "Modifikator guruhlari",
        photos: "Rasmlar",
      },
    },
  },
  waiterZones: {
    title: "Zallar bo‘yicha ofitsiantlar",
    description: "Kim qaysi zal va stollarga xizmat qiladi: ofitsiant smenada bo‘lmasa, stolni darhol keyingisi oladi; avtotaqsimotni yoqish mumkin.",
    tabs: {
      now: "Hozir",
      zones: "Zonalar",
      settings: "Sozlamalar",
    },
    add: "Zona qo‘shish",
    edit: "Zonani o‘zgartirish",
    empty: "Hozircha zonalar yo‘q",
    emptyHint: "Zona yarating: zal yoki stollar va tartib bilan ofitsiantlar. Bu stollarga yangi buyurtmalar darhol kerakli ofitsiantga ketadi.",
    namePlaceholder: "Asosiy zal",
    fields: {
      name: "Nomi",
      scope: "Nimaga xizmat qiladi",
      hall: "Zal",
      tables: "Stollar",
      mode: "Qanday taqsimlash",
      waiters: "Ofitsiantlar",
      active: "Zona yoqilgan",
    },
    scopes: {
      branch: "Butun filial",
      hall: "Zal",
      tables: "Alohida stollar",
    },
    modes: {
      priority: "Ustuvorlik bo‘yicha",
      round_robin: "Navbat bilan",
      least_loaded: "Kim bo‘shroq",
    },
    modeHints: {
      priority: "Stolni ro‘yxatdagi smenada bo‘lgan birinchisi oladi. U bo‘lmasa — ikkinchisi va hokazo.",
      round_robin: "Avtotaqsimot: stollar navbat bilan — keyingi stol eng uzoq vaqt stol olmaganga.",
      least_loaded: "Avtotaqsimot: stol hozir ochiq stollari eng kam ofitsiantga.",
    },
    pickHall: "Zalni tanlang",
    pickTables: "Stollarni tanlang",
    branchHint: "Zaxira zona: o‘z zonasi bo‘lmagan yoki zonasida hozir smenada hech kim yo‘q stollar uchun ishlaydi.",
    orderHint: "Tartib muhim: birinchisi — asosiy ofitsiant, qolganlari — navbat bilan almashtiruvchi.",
    addWaiter: "Ofitsiant qo‘shish",
    moveUp: "Yuqoriga",
    moveDown: "Pastga",
    activeHint: "O‘chirilgan zona taqsimotda qatnashmaydi.",
    table: "{{number}}-stol",
    tablesList: "Stollar: {{list}}",
    off: "O‘chirilgan",
    inactive: "Mavjud emas",
    onShift: "Smenada",
    offShift: "Smenada emas",
    deleteConfirm: "«{{name}}» zonasi o‘chirilsinmi?",
    deleteHint: "Zona ofitsiantlari xizmat qilayotgan stollar ularda qoladi.",
    orderRule: "Stolni birinchi mos zona oladi: avval «Alohida stollar», keyin «Zal», keyin «Butun filial». Zonada smenada hech kim bo‘lmasa — keyingisi olinadi.",
    noZonesNow: "Zonalar yo‘q — buyurtmalar uni ochgan odamda qoladi. «Zonalar» bo‘limida zona yarating.",
    notTracking: "Smenalar hisobga olinmaydi: zonalarning barcha ofitsiantlari joyida deb hisoblanadi.",
    staffTitle: "Ofitsiantlar",
    staffHint: "Kim smenada va kimda nechta ochiq stol bor.",
    staffEmpty: "Zonalarda ofitsiant yo‘q va hech kim smenani belgilamagan",
    openTables: "Ochiq stollar: {{count}}",
    servedBy: "{{name}} xizmat qiladi · №{{number}} buyurtma",
    free: "Bo‘sh",
    nextIs: "Yangi buyurtmani oladi: {{name}} ({{zone}})",
    nextNobody: "Hozir hech kim yo‘q — buyurtma uni ochgan odamda qoladi",
    settings: {
      requireShift: "Ish smenalarini hisobga olish",
      requireShiftHint: "Stolni faqat kelganini belgilagan va tanaffusda bo‘lmagan odam oladi.",
      reassignOnLeave: "Ketganning stollarini topshirish",
      reassignOnLeaveHint: "Ofitsiant smenani yopdi — uning ochiq stollari darhol zona bo‘yicha keyingisiga o‘tadi.",
      assignStaffOrders: "Kassir buyurtmalarini taqsimlash",
      assignStaffOrdersHint: "Kassir yoki administrator ochgan stoldagi buyurtmani darhol zona ofitsianti oladi.",
    },
  },
};
